/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable max-len */
import { AfterViewInit, Component, EventEmitter, Injectable, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, Inject, ElementRef, TemplateRef, OnDestroy, ViewEncapsulation, QueryList, ViewChildren, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { BryntumSchedulerProComponent } from '@bryntum/schedulerpro-angular-thin';
import { BryntumGridComponent } from '@bryntum/grid-angular-thin';
import { DragHelper, DragHelperConfig, GridColumnConfig, Tooltip } from '@bryntum/core-thin';
import { Grid, GridConfig } from '@bryntum/grid-thin';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { DispatchBoardService } from '../dispatch-board/dispatch-board.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { ConfigurationService } from '../../core/services/configuration.service';
import { TemplateService } from '../../core/services/template.service';
import { dispatchSplitConfig, TemplateType } from '../dispatch-board/dispatch-board.interface';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { MapsService } from 'app/modules/maps/maps.service';
import moment, { Moment } from 'moment';
import { NgxTippyProps, NgxTippyService } from 'ngx-tippy-wrapper';
import _, { delay } from 'lodash';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { SharedService } from '../../core/services/shared.service';
import { SettingsComponent } from '../settings/settings.component';
import { Router } from '@angular/router';
import { DispatchFilterService } from '../dispatch-filter/dispatch-filter.service';
import { ManageDispatchFilterComponent } from '../manage-dispatch-filter/manage-dispatch-filter.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, ReplaySubject, Subject, Subscription, forkJoin, of, throwError } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, shareReplay, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { DateRange, MAT_DATE_RANGE_SELECTION_STRATEGY, MatCalendarCellClassFunction, MatDateRangeSelectionStrategy } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import tippy from 'tippy.js';
import { RescheduleJobComponent } from '../reschedule-job/reschedule-job.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RemarksComponent } from '../remarks/remarks.component';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import { RescheduleRouteComponent } from '../reschedule-route/reschedule-route.component';
import { RemoveJobComponent } from 'app/components/remove-job/remove-job.component';
import { PreviewDataOptions } from 'app/components/preview-data/preview-data.interface';
import { dataObj } from 'app/modules/jobs/job-form/job-form.type';
import { JobFormComponent } from 'app/modules/jobs/job-form/job-form.component';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { Location } from '@angular/common';
import { Tabs, TabsConfig } from 'app/components/tabs/tabs.interface';
import { RecurringRouteService } from 'app/components/recurring-route-details/recurring-route.service';
import { MoveRouteJobComponent } from 'app/components/move-route-job/move-route-job.component';
import { UpdateDueDateComponent } from 'app/modules/jobs/job-details/edit-due-date/edit-due-date.component';
import dayjs, { Dayjs } from 'dayjs';
import { ColorProfileOptions } from 'app/modules/maps/map.interface';
import { ModuleAccess, Permissions } from '../dispatch-board/dispatch-board.interface';
import { ZuperSdkEventService } from 'app/core/services/sdk_service/sdk-event.service';

@Injectable()
export class DefaultCustomRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  maxDateRange: number = 7;
  constructor(
    private _dateAdapter: DateAdapter<D>,
    private _sharedService: SharedService,
  ) { }
  selectionFinished(date: any, currentRange: DateRange<D>): DateRange<D> {
    let { start, end } = currentRange;
    if (start == null) {
      start = date;
      this._sharedService.routeSchedulerMaxEndDate = this._dateAdapter.addCalendarDays(start, this.maxDateRange);
    } else if (end == null && date && this._dateAdapter.compareDate(date, start) >= 0) {
      if (date.diff(start, 'day') > this.maxDateRange) {
        end = this._dateAdapter.addCalendarDays(start, this.maxDateRange);
      }
      else {
        end = date;
        this._sharedService.routeSchedulerMaxEndDate = null;
      }
    } else {
      start = date;
      this._sharedService.routeSchedulerMaxEndDate = this._dateAdapter.addCalendarDays(start, this.maxDateRange);
      end = null;
    }
    return new DateRange<D>(start, end);
  }

  createPreview(activeDate: any, currentRange: DateRange<D>): DateRange<D> {
    let start: D | null = null;
    let end: D | null = null;

    if (currentRange.start && !currentRange.end && activeDate) {
      start = currentRange.start;
      if (activeDate.diff(start, 'day') > this.maxDateRange) {
        end = this._dateAdapter.addCalendarDays(start, this.maxDateRange);
      }
      else {
        end = activeDate;
      }
    }
    return new DateRange<D>(start, end);
  }
}

@Component({
  selector: 'app-dispatch-board-routes',
  templateUrl: './dispatch-board-routes.component.html',
  styleUrls: ['./dispatch-board-routes.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DefaultCustomRangeSelectionStrategy,
    }
  ]
})
export class DispatchBoardRoutesComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() currentTab: string;
  @Input() holidays: any;
  @Input() prefillConfig: any = {};
  @Output() dispatchTabChange = new EventEmitter<string>();

  //ElementRef
  @ViewChild('routeCardView', { static: false }) cardViewComponent!: BryntumGridComponent;
  @ViewChild('routeTableView', { static: false }) tableViewComponent!: BryntumGridComponent;
  @ViewChild('routeScheduler') schedulerProComponent!: BryntumSchedulerProComponent;
  @ViewChild('employeeSearch', { read: ElementRef, static: true }) employeeSearchTemplate: ElementRef;
  @ViewChild('routeGridAssignedToContent', { read: ElementRef, static: true }) routeGridAssignedToContent: ElementRef;
  @ViewChild('noTeamAlertDialogContent', { static: true }) noTeamAlertDialogContent: TemplateRef<any>;
  @ViewChild('mapLegendWrapperRoute', { static: false }) mapLegendWrapperRef!: ElementRef;
  @ViewChild('gridSchedulerContainer', { static: false }) gridSchedulerContainerRef!: ElementRef;
  @ViewChild('schedulerDatepicker', { static: false }) schedulerDatepickerRef!: ElementRef;
  @ViewChildren('mapLegendItemsRoute') mapLegendItems!: QueryList<ElementRef>;
  @ViewChild('mapContainer', { static: false }) mapContainerRef!: ElementRef;
  @ViewChild('mapLegendContainer', { static: false }) mapLegendContainerRef!: ElementRef;
  @ViewChild('userSortTippyWrapper', { static: false }) userSortTippyWrapper!: ElementRef;
  @ViewChild('userSkillSubMenuTippyWrapper', { static: false }) userSkillSubMenuTippyWrapper!: ElementRef;
  @ViewChild('skillSubMenuTemplate') skillSubMenuTemplate!: TemplateRef<any>;

  //General
  enablePlanningTab: boolean = true;
  enableMapTab: boolean = true;
  enableServiceTerritory: boolean = true;
  metaData: any = {};
  timeFormat: any;
  dateFormat: string = this._utilityService.dateFormat;
  dateTimeFormat: string = this._utilityService.dateTimeFormat;
  moduleAccess: ModuleAccess;
  permissions: Permissions;
  newJobDrawerData = { openNewJobDrawer: false, newJobPrefillData: {}, cloneJobData: null };
  schedulerMaxDateRange: any;
  selectedTimezone: any;
  browserTimezone: string;
  noTeamAlertDialogRef: MatDialogRef<any>;
  dispatchJobRouteTransferEmitterSubscription: Subscription;
  recurringRouteDetailsSubscription: Subscription;
  timeoffEditElement: HTMLElement;
  timeoffDeleteElement: HTMLElement;
  timeoffEditHandler: any;
  timeoffDeleteHandler: any;
  toNumber = Number;
  businessHours = { start: moment(this._dispatchBoardService.getBusinessHours('start'), 'HH:mm:ss'), end: moment(this._dispatchBoardService.getBusinessHours('end'), 'HH:mm:ss') };
  defaultDispatchBoardFilters = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'job': { 'filterOptions': {'grid':[{'displayKeyValue':[],'key':'job_category_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'displayKeyValue':[],'key':'scheduled_start_time','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'due_date','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'customer_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}],'employee':[{ "displayKeyValue": [], "key": "assigned_to.user_uid", "operator": "CONTAINS", "field_type": "LOOKUP", "value": "", "module": "JOB", "type": "nested_field" },{'displayKeyValue':[],'key':'skillset_uid','operator':'EQUAL_TO','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}],'scheduler':[{'displayKeyValue':[],'key':'job_category_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'displayKeyValue':[],'key':'due_date','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'customer_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}],'map':{'filter.route_uid':[]}}, 'sortOptions': { 'grid': { 'sort_by': 'scheduled_start_time', 'sort': 'DESC' }, 'employee': {}, 'scheduler': {}, 'map': {} }, 'filterUid': 'ALL', 'filterCount': { 'grid': 0, 'employee': 0, 'scheduler': 0, 'map': 0 } },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'route': { 'filterOptions': { 'grid': [{'displayKeyValue':[],'key':'job_category_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'displayKeyValue':[],'key':'scheduled_start_time','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'due_date','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'customer_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}], 'grid_route': [{'displayKeyValue':[],'key':'keyword','operator':'CONTAINS','field_type':'TEXT','value':'','module':'JOB','type':'default_field'}], 'employee': [{ "displayKeyValue": [], "key": "assigned_to.user_uid", "operator": "CONTAINS", "field_type": "LOOKUP", "value": "", "module": "JOB", "type": "nested_field" },{'displayKeyValue':[],'key':'skillset_uid','operator':'EQUAL_TO','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}], 'scheduler': [{'displayKeyValue':[],'key':'job_category_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'displayKeyValue':[],'key':'due_date','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'customer_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}], 'scheduler_route': [{'displayKeyValue':[],'key':'keyword','operator':'CONTAINS','field_type':'TEXT','value':'','module':'JOB','type':'default_field'}], 'map': { 'filter.route_uid': [] } }, 'sortOptions': { 'grid': { 'sort_by': 'scheduled_start_time', 'sort': 'DESC' }, 'employee': {}, 'scheduler': {}, 'map': {}, 'grid_route': { 'sort_by': 'departure', 'sort': 'DESC' } }, 'filterUid': 'ALL', 'filterCount': { 'grid': 0, 'employee': 0, 'scheduler': 0, 'map': 0, 'grid_route': 0, 'scheduler_route': 0 } }
  };
  defaultSchedulerPreference = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'job': { 'from_date': moment().format('YYYY-MM-DD'), 'to_date': moment().format('YYYY-MM-DD'), 'team_uid': '', 'currentView': 'DAY' },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'route': { 'date': moment().format('YYYY-MM-DD'), 'from_date': moment().format('YYYY-MM-DD'), 'to_date': moment().add(2, 'd').format('YYYY-MM-DD'), 'team_uid': '' },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'timezone': { 'JOBS': moment.tz.guess(), 'ROUTES': moment.tz.guess() },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'service_territory': { 'JOBS': { serviceTerritoryUid: null, serviceTerritoryName: null, type: null, radius: 0 }, 'ROUTES': { serviceTerritoryUid: null, serviceTerritoryName: null, type: null, radius: 0 } }
  };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  recurringRouteSortOptions = { 'sort': 'DESC', 'sort_by': 'created_at' };
  //NavBar
  selectedDispatchTab: 'JOBS' | 'ROUTES' = 'ROUTES';
  selectedRouteTab: 'TRACKING' | 'PLANNING' = 'TRACKING';
  selectedPlanningTab: 'SCHEDULE' | 'MAP' = 'SCHEDULE';
  selectedSchedulerPlanningNavTab: 'DISPATCH_BOARD' | 'MAP' = 'DISPATCH_BOARD';
  routesTabView: 'TRACKING' | 'PLANNING' = 'TRACKING';
  selectedQuickFilter: string = 'ALL';
  quickFilterLoading: boolean = false;
  quickFilters: any[] = [];
  teamSearchPagination = { currentPage: 1, totalPage: 1, keyword: '', filterUid: '', serviceTerritoryFilterUid: '' };
  teamPickerList: any[];
  allTeams: any[] = [];
  selectedTeam: string;
  teamApiIterateBlocker: boolean = false;
  showSchedulerPlanningNavTab: boolean = false;
  schedulerRouteEventRowHeight: number = 60;
  schedulerJobEventRowHeight: number = 45;
  schedulerResourceRowHeight: number = 60;
  schedulerPlanningNavTabs: Tabs[] = [
    {
      title: 'dispatch.nav.title',
      dataKey: 'DISPATCH_BOARD',
      isEnabled: true
    },
     {
      title: 'dispatchBoard.settings.map.title',
      dataKey: 'MAP',
      isEnabled: true
    }
  ];
  schedulerPlanningNavTabConfig: TabsConfig = {
    size:'lg',
    position:'start',
    variant:'bordered',
    tabBarGutter:'space-x-6',
    showActionButton: false,
    extraClass: 'border-b'
  };


  //Filter
  dispatchFilterDrawerData = { openFilter: false, dispatchFilterValues: {}, saveFilterByDefault: false, additionalFilters: {}, hideSaveFilter: false, addNewFilter: false, selectedModule: 'GRID', filterOptionalValues: { map: [] } };
  fallbackSelectedQuickFilter: string = 'ALL';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  filterCount = { grid: 0, employee: 0, scheduler: 0, map: 0, grid_route: 0, scheduler_route: 0 };
  useColorProfile: boolean = false;
  sortOptions = { grid: { sort_by: 'scheduled_start_time', sort: 'DESC' }, user: { sort_by: 'name', sort: 'ASC' }, scheduler: {} };
  userSortTemplateContext: any = {
    sortOptions: this.sortOptions,
    setUserSort: (key: string, value: string) => this.setUserSort(key, value),
    applyUserSort: () => this.applyUserSort(),
    showUserSkillSubMenu: () => this.showUserSkillSubMenu,
    hideUserSkillSubMenu: () => this.hideUserSkillSubMenu
  };
  userSortSearchInput$: Subject<string> = new Subject<string>(); 
  userSortData = { instanceRef: null, contentRef: null, isOpened: false, selectedSkill: null, selectedSkillName: '', skillSubMenu: { contentViewRef: null, hideTimeout: null, instanceRef: null, isOpened: false, skillList: [], filteredSkillset: [], searchKeyword: '' } };
  //Settings
  settingsDialogdata: any = {};
  dispatchRouteSplitSettings: dispatchSplitConfig = {
    orientation: 'horizontal',
    grid: {
      size: 25,
      minSize: 20,
      maxSize: 35,
      order: 1
    },
    scheduler: {
      size: 75,
      minSize: 40,
      maxSize: null,
      order: 2
    },
    map: {
      size: 25,
      minSize: 15,
      maxSize: 30,
      order: 3
    },
    visible: {
      grid: true,
      scheduler: true,
      map: true
    },
    gutter: {
      toggleState: {
        0: 'neutral',
        1: 'neutral'
      }
    },
    maxSize: 80,
    minSize: 70
  };
  mapResizeTimeout: any;

  //Grid
  cardConfig: any;
  tableConfig: Partial<GridConfig>;
  gridSortableColumns: any;
  /* eslint-disable @typescript-eslint/naming-convention */
  gridTbarData = { 'JOBS': { type: 'UNASSIGNED', gridSearchKeyword: '', sortOptions: { sort_by: 'scheduled_start_time', sort: 'DESC' } }, 'ROUTES': { type: 'UNASSIGNED', gridSearchKeyword: '', filter_rules: [], sortOptions: { sort_by: 'departure', sort: 'DESC' } } };
  gridBbarData = { 'JOBS': { totalGridRecords: 1, gridPageNumber: 1, totalGridPage: 1 }, 'ROUTES': { totalGridRecords: 1, gridPageNumber: 1, totalGridPage: 1 } };
  defaultJobGridPreference = { page: 1, count: 10, type: 'UNASSIGNED', sort_by: 'scheduled_start_time', sort: 'DESC', filter_rules: [] };
  currentFilters: any = {};
  gridViewParamData: { 'JOBS': any; 'ROUTES': any; 'RECURRING_ROUTES': any } = { 'JOBS': {}, 'ROUTES': {}, 'RECURRING_ROUTES': {} };
  gridData: { 'JOBS': any[]; 'ROUTES': any[] } = { 'JOBS': [], 'ROUTES': [] };
  gridViewType: 'listView' | 'tableView';
  routeCardData: any[] = [];
  tableData: any[] = [];
  cardViewInstance: Grid;
  tableViewInstance: any;
  loadingGridData: boolean = false;
  selectedGridTab: 'JOBS' | 'ROUTES' = 'ROUTES';
  gridParam: any = {};
  gridViewInstance: any;
  dragInstance: DragHelper;
  gridJobTypeMap: any;
  gridFilterOptions: any;
  allRoutes: any[];
  allJobs: any[];
  masterRouteJobs = {};
  allRouteJobs: any[] = [];
  routeParam: any = {};
  recurringRouteParam: any = {};
  routeGridAssignedToTippyRef: any;
  gridSortTippyProps: NgxTippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    interactive: true,
    appendTo: document.body,
    placement: 'right-start',
    offset: [0, 0],
    onShow: () => {
      this._dispatchBoardService.trackEvent('grid_sort');
    }
  };
  routeTableData = [];
  openGridSearch: boolean = false;
  dragConfig: Partial<DragHelperConfig>;
  routeGridCardUserAssignTippyData = { prefillUsers: [], routeDetails: null, updatedRouteDetails: null, assignedToBtnRef: null };
  routeGridCardContextMenuData = { menuBtnRef: null, routeDetails: null };
  schedulerFocusData = { eventUid: null, userUid: null };
  openMapTooltip = { jobUid: null, routeUid: null };
  initialGridLoad: boolean = true;

  //Scheduler
  schedulerParams: any = {};
  teams: Observable<any[]>;;
  schedulerDatePrevBtn: boolean = false;
  schedulerDateNextBtn: boolean = false;
  schedulerTbarForm: UntypedFormGroup;
  selectedTeamTimezone: any;
  teamPickerLoading: boolean = false;
  teamValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();;
  schedulerProConfig: any;
  schedulerInstance: any;
  schedulerPresets: any;
  schedulerZoomInBtnState: boolean = false;
  schedulerZoomOutBtnState: boolean = false;
  currentView: 'DAY' | 'WEEK' | 'MONTH' = 'DAY';
  trackingMaxDate: any;
  currentDay: string;
  schedulerSearchKeyword: string = '';
  employeeSearchKeyword: string = '';
  appliedSchedulerSearchKeyword: string = '';
  appliedEmployeeSearchKeyword: string = '';
  customUserDetails: any;
  schedulerEmployees: any[] = [];
  schedulerRoutes: any[] = [];
  recurringRouteInstances: any[] = [];
  schedulerJobs: any[] = [];
  schedulerAssignments: any[] = [];
  employeeSearchTippy: any;
  schedulerData: any;
  schedulerParamData: any = {};
  schedulerSummaryTooltipInstance: any;
  timeoffTooltipInstance: Tooltip;
  tooltipTimeoffEvent: any;
  previewDrawer = { drawerOpen: false, module: 'USER', moduleUID: '', source: '' };
  previewDataOptions: PreviewDataOptions;
  schedulerScrollPositionData = { eventRecord: null, resourceRecord: null };
  schedulerSearchTippyInstance: any;
  schedulerResourceSortState: 'DEFAULT' | 'ASC' | 'DESC' = 'DEFAULT';
  schedulerSearchTippyProps: NgxTippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    interactive: true,
    appendTo: document.body,
    placement: 'bottom',
    onShow: (instance: any) => {
      this.schedulerSearchTippyInstance = instance;
      this._dispatchBoardService.trackEvent('scheduler_search');
    },
    onMount: (instance: any) => {
      instance.popper.querySelector('input')?.focus();
    },
    onHide: () => {
      this.schedulerSearchKeyword = this.appliedSchedulerSearchKeyword;
      if (!this.schedulerSearchKeyword?.trim()?.length && this.schedulerInstance) {
        this.schedulerSearchKeyword = '';
        this.schedulerInstance.eventStore.removeFilter('schedulerEventSearch');
      }
    }
  };
  isSchedulerInCurrentDate: boolean = false;
  isSchedulerInitialLoad: boolean = true;

  //Service Territory
  allTerritories: any[] = [];
  serviceTerritories: Observable<any[]>;
  selectedServiceTerritory: string = 'ALL';
  territoryApiIterateBlocker: boolean = false;
  serviceTerritoryValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  selectedServiceTerritoryDetails = { name: null, geoCords: [], type: null, radius: 0 };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  allServiceTerritorySelectOption = { 'territory_uid': 'ALL', 'territory_name': this._utilityService.getLocaleValue('text.all_service_territory', 'All Service Territory') };
  serviceTerritoryPickerList: any[] = [this.allServiceTerritorySelectOption];
  territorySearchPagination = { currentPage: 1, totalPage: 1, keyword: '', filterUid: '', isLoading: false };

  //Routes
  routePreviewDrawerData = { drawerName: 'dispatchRoutesPreview', show: false, routeDetailsUid: '', isOptimized: false, source: '', assignedTo: [], isLocked: false };
  routeAssignDrawerData = { drawerName: 'dispatchRoutesAssign', show: false, routeUid: '', date: '', jobTitle: '', jobUid: '' };
  recurringRouteDetails = { routeUid: null, isOpened: false, rrDetails: null, performAction: null };
  routeAssignDrawerInstance: any;
  routeFormOption: any;
  openRouteFormDrawer: any;
  routeFormCurrentRoute: any;
  routeLockedMsgToastRef: any;
  routeTypeOptions: any[];
  routesTabViewOptions = [
    { value: 'TRACKING', label: 'text.tracking' }
  ];

  //Map
  isMapViewEnabled: boolean = false;
  mapViewData: any;
  allowMapView: boolean = false;
  isDrawOnMapView: boolean = false;
  drawOnMapNavbarData = { selectedJobs: [] };

    //Toast Ref
  gridOnCellClickToastRef: CreateHotToastRef<any>;
  closedJobScheduleErrorToastRef: CreateHotToastRef<any>;

  //Cleanup
  tearDown$: Subject<void> = new Subject<void>();
  
  getUserTeamId = _.memoize((userUid: any): string => {
    let teamId = this.selectedTeam;
    const schedulerRoutes = this.schedulerProConfig.events;
    schedulerRoutes.forEach((route: any) => {
      const assignedTo = route?.assigned_to?.filter((assignee: any) => assignee?.user.user_uid === userUid);
      if (assignedTo.length) {
        const teamUid = assignedTo[0]?.team.team_uid;
        if (!this._utilityService.isEmptyOrUndefined(teamUid)) {
          teamId = teamUid;
          return false;
        }
      }
    });
    return teamId;
  });

  getTeamName = _.memoize((teamUid: any): string => {
    const teamDetails: any = this.allTeams.find((teamDetails: any) => teamDetails?.team_uid === teamUid);
    return teamDetails?.team_name || ''
  });

  setSchedulerStartEndDate = _.debounce((skipSchedulerScroll: boolean = false): void => {
    let startDate: any; let endDate: any; let startDateTime: any; let endDateTime: any;
    const isTrackingTab = this.selectedRouteTab === 'TRACKING';
    const isPlanningTab = this.selectedRouteTab === 'PLANNING';
    this.isSchedulerInCurrentDate = moment().isSame(moment(startDate, 'YYYY-MM-DD'), 'date');

    // Set start and end dates based on the selected tab
    if (isTrackingTab) {
      startDate = endDate = this.schedulerTbarForm.get('schedulerDate').value.clone().format('YYYY-MM-DD');
    } else if (isPlanningTab) {
      startDate = this.schedulerTbarForm.get('scheduleStartDate').value.clone().format('YYYY-MM-DD');
      endDate = this.schedulerTbarForm.get('scheduleEndDate').value.clone().format('YYYY-MM-DD');
    }

    const dateDiff = moment(endDate).diff(moment(startDate), 'd');
    const businessStartTime = this._dispatchBoardService.getBusinessHours('start');
    const businessEndTime = this._dispatchBoardService.getBusinessHours('end');
    this.suspendAllSchedulerEvents();
    if (this.metaData?.scheduler.display.business_hours_only) {
      this.buildBusinessHoursTimeRange('remove');

      // Set start and end times based on whether the tab is 'TRACKING' or 'PLANNING'
      if (dateDiff === 0 || isTrackingTab) {
        startDateTime = new Date(`${startDate} ${businessStartTime}`);
        endDateTime = new Date(`${endDate} ${businessEndTime}`);
      } else if (isPlanningTab && dateDiff !== 0 && this.schedulerInstance) {
        startDateTime = new Date(`${startDate} 00:00:00`);
        endDateTime = new Date(`${endDate} 23:59:59`);
        this.schedulerInstance.timeAxis.filter({
          id: 'businessHoursOnly',
          filterBy: (_timeAxis: any) =>
            _timeAxis.startDate.getHours() >= this.businessHours.start.hour() &&
            _timeAxis.startDate.getHours() <= this.businessHours.end.hour(),
        });
      }
    } else {
      this.buildBusinessHoursTimeRange('add');
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        startDateTime = new Date(`${startDate} 00:00:00`);
        endDateTime = new Date(`${endDate} 23:59:59`);
        this.schedulerInstance.timeAxis.removeFilter('businessHoursOnly');
      }
    }

    // Set the scheduler's start and end dates
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      this.schedulerInstance.setStartDate(startDateTime);
      this.schedulerInstance.setEndDate(endDateTime);
    }

    // Set scheduler scroll position if not skipped
    if (!skipSchedulerScroll) {
      this._dispatchBoardService.setSchedulerScrollPosition(
        this.schedulerInstance,
        this.currentView
      );
    }
    this.resumeAllSchedulerEvents();
  }, 500);

  addSchedulerEmpHeaderOnClickListener = _.debounce((): void => {
    const schedulerResourceHeader = (this.schedulerProComponent['elementRef']?.['nativeElement'] as HTMLElement).querySelector('#schedulerResourceHeader-ROUTES');
    if (!schedulerResourceHeader) return;
  
    const searchBtn = schedulerResourceHeader.querySelector('#schedulerEmpHeaderSearchBtn-ROUTES') as HTMLElement;
    const filterBtn = schedulerResourceHeader.querySelector('#schedulerEmpHeaderFilterBtn-ROUTES') as HTMLElement;
    const settingsBtn = schedulerResourceHeader.querySelector('#schedulerEmpHeaderSettingsBtn-ROUTES') as HTMLElement;
    const sortBtn = schedulerResourceHeader.querySelector('#schedulerEmpHeaderSortBtn-ROUTES') as HTMLElement;
  
    if (!searchBtn || !filterBtn || !settingsBtn || !sortBtn) return;
  
    this.employeeSearchTippy?.destroy();
    this.employeeSearchTippy = tippy(searchBtn, {
      allowHTML: true,
      theme: 'light',
      trigger: 'click',
      interactive: true,
      appendTo: document.body,
      placement: 'right',
      content: this.employeeSearchTemplate.nativeElement,
      onMount: () => {
        this.employeeSearchTemplate.nativeElement.classList.replace('hidden', 'flex');
        this.employeeSearchTemplate.nativeElement.querySelector('input')?.focus();
      },
      onHide: () => {
        this.employeeSearchKeyword = this.appliedEmployeeSearchKeyword;
        const searchIndicator = schedulerResourceHeader.querySelector('#routes-employee-search-active-indicator');
        
        if (this.employeeSearchKeyword?.trim()?.length) {
          if (this.schedulerInstance?.resourceStore?.filters?.values?.length && !searchIndicator) {
            const indicator = document.createElement('div');
            indicator.id = 'routes-employee-search-active-indicator';
            indicator.className = 'w-2 h-2 bg-primary-600 rounded-full absolute top-1 right-1 z-10';
            searchBtn.classList.add('relative');
            searchBtn.appendChild(indicator);
          }
        } else {
          searchIndicator?.remove();
          this.employeeSearchKeyword = '';
          this.schedulerInstance?.resourceStore?.removeFilter('userSearch');
        }
      }
    });
  
    const filterClickHandler = () => this.openDispatchFilter('EMPLOYEE');
    const settingsClickHandler = () => this.openSettingsDialog('EMPLOYEE');
    const searchClickHandler = () => this.employeeSearchTippy.show();
    const sortClickHandler = (event: any): void => {
      if (this.userSortData.isOpened) {
        return;
      }
      const sortButton = (event.target as Element).closest('button');
      if (sortButton) {
        this.userSortData.isOpened = true;
        this._changeDetector.detectChanges();
        setTimeout(() => {
          const tooltipContent = this.userSortTippyWrapper.nativeElement;
          this.userSortData.instanceRef = tippy(sortButton, {
            content: tooltipContent,
            allowHTML: true,
            theme: 'light',
            trigger: 'click',
            interactive: true,
            appendTo: document.body,
            placement: 'right-start',
            hideOnClick: false,
            animation: 'fade',
            duration: [0, 200],
            arrow: true,
            onShow: (instance: any) => {
              this.userSortData.instanceRef = instance;
            },
            onMount: () => {
              tooltipContent.classList.remove('hidden');
            },
            onClickOutside: () => {
              if (!this.userSortData.skillSubMenu.isOpened) {
                this.closeUserSort();
                return true;
              }
              return false;
            },
            onHidden: () => this.closeUserSort()
          });
          this.userSortData.instanceRef.show();
        }, 0);
      }
    };
  
    filterBtn.addEventListener('click', filterClickHandler);
    settingsBtn.addEventListener('click', settingsClickHandler);
    searchBtn.addEventListener('click', searchClickHandler);
    sortBtn.addEventListener('click', sortClickHandler);
  
    this.updateFilterCount();
  }
  , 1000, { trailing: true });
  
  colorProfiletCreateDrawerData = { openDrawer: false, drawerName: 'colorProfileRouteDrawer' };
  mapColorProfileOptions: ColorProfileOptions = { isEnabled: true, enableLegend: true };
  mapLegendData = { legendDetails: [], extraCount: 0 };

  /* eslint-enable @typescript-eslint/naming-convention */
  constructor(
    private _localisationService: LocalisationService,
    private _localStorageService: LocalStorageService,
    private _configurationService: ConfigurationService,
    private templateService: TemplateService,
    private _dataCollectorService: DataCollectorService,
    private _toastService: HotToastService,
    private _mapService: MapsService,
    private _zuperDialogService: ZuperDialogService,
    private _jobsService: JobsService,
    private ngxTippyService: NgxTippyService,
    private _dispatchFilterService: DispatchFilterService,
    private formBuilder: UntypedFormBuilder,
    private zuperDrawerService: ZuperDrawerService,
    private matDialog: MatDialog,
    private recurringRouteService: RecurringRouteService,
    public _utilityService: UtilityService,
    public router: Router,
    public _dispatchBoardService: DispatchBoardService,
    public _sharedService: SharedService,
    private _sdkEventService: ZuperSdkEventService,
    private _changeDetector: ChangeDetectorRef,
    private location: Location  ) { }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
    this.updatePermissions();
    this.initDependencies();
    this.setPreferences();
    this.initTabPrefillListener();
    this.setCardConfig();
    this.setTableConfig();
    this.setSchedulerConfig();
    this.loadSchedulerData();
    this.updateSchedulerSettings(true);
    this.onDispatchTabChange('ROUTES');
  }

  ngAfterViewInit(): void {
    this.cardViewInstance = this.cardViewComponent?.instance;
    this.tableViewInstance = this.tableViewComponent?.instance;
    this.schedulerInstance = this.schedulerProComponent?.instance;
    this.gridViewInstance = this.gridViewType === 'listView' ? this.cardViewInstance : this.tableViewInstance;
    this.initiateTableSortEventListener();
    this.setGridEmptyText();
    this.setSchedulerEventLisners();
    this.schedulerInstance.project.commitAsync().then(async () => {
      setTimeout( () => {
        this.refreshScheduler();
      }, 1000);
    });
  }

  ngOnDestroy(): void {
    this.schedulerProConfig.events = [];
    this.schedulerProConfig.resources = [];
    this.schedulerProConfig.assignments = [];
    this.dispatchJobRouteTransferEmitterSubscription?.unsubscribe();
    if (this.recurringRouteDetailsSubscription?.unsubscribe) {
      this.recurringRouteDetailsSubscription.unsubscribe();
    }
    if (this.schedulerInstance?.destroy) {
      this.schedulerInstance?.destroy();
      this.schedulerInstance = null;
    }
    if (this.cardViewInstance?.destroy) {
      this.cardViewInstance.destroy();
      this.cardViewInstance = null;
    }
    if (this.tableViewInstance?.destroy) {
      this.tableViewInstance.destroy();
      this.tableViewInstance = null;
    }
    this.destroyTooltipInstances();
    this.tearDown$.next();
    this.tearDown$.complete();
  }

  //General
  updatePermissions(): void {
    this.permissions = this._dispatchBoardService.permissions;
    this.moduleAccess = this._dispatchBoardService.moduleAccess;
    this.enableServiceTerritory = this._dispatchBoardService.companyConfig.serviceTerritory;
  }

  updateMetaData(metaData?: any): void {
    if (!metaData) {
      metaData = this._dispatchBoardService.getLocalMetaData();
    }
    if (this._dispatchBoardService.enableMapViewByDefault) {
      metaData.map.enable_map_view = true;
    }
    if (this._dispatchBoardService.activeDispatchTab === 'JOBS') {
      if (this._dispatchBoardService.enableMapLayerByDefault.jobs) {
        metaData.map.layers.jobs = true;
      }
      if (this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory) {
        metaData.map.layers.service_territories = true;
      }
    }
    else if (this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
      if (this._dispatchBoardService.enableMapLayerByDefault.routes) {
        metaData.map.layers.routes = true;
      }
      if (this._dispatchBoardService.enableMapLayerByDefault.routesJob) {
        metaData.map.layers.jobs = true;
      }
      if (this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory) {
        metaData.map.layers.service_territories = true;
      }
    }
    if (metaData.grid?.['view_type'] === 'tableView' && this.selectedRouteTab === 'PLANNING' && this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
      metaData.grid.view_type = 'listView';
    }
    if (metaData.grid.view_type !== this.gridViewType) {
      this.gridViewType = metaData.grid.view_type;
      setTimeout(() => {
        this.setGridSchedulerInstance();
        this.dragInstance?.destroy();
        this.initiateDragHelper(this.gridViewType);
      }, 100);
    }
    this.metaData = metaData;
    this.templateService.metaData = metaData;
    this._mapService.toggleMapDrawTool(this.metaData?.map?.layers?.routes);
  }

  initDependencies(): void {
    this.schedulerTbarForm = this.formBuilder.group({
      selectedTeam: [null],
      schedulerDate: [moment(), Validators.required],
      scheduleStartDate: [moment(), Validators.required],
      scheduleEndDate: [moment(), Validators.required],
    });
    this.updateMetaData();
    this._dispatchBoardService.isSchedulerHolidayMounted.ROUTES = false;
    this.gridSortableColumns = this._configurationService.getGridSortableColumns();
    this.gridJobTypeMap = this._configurationService.getGridJobTypeMap();
    this.gridViewType = this.metaData?.grid.view_type;
    this.isMapViewEnabled = this.metaData?.map.enable_map_view;
    this.timeFormat = this._utilityService.timeFormat === '24_HRS' ? 'HH:mm' : 'hh:mm A';
    this.browserTimezone = moment.tz.guess();
    this.trackingMaxDate = moment().add(1, 'd');
    this.initSchedulerPresets();
    this.initiateDragHelper(this.gridViewType);
    this.getPreviewDataOptions();
    this.updateRouteGridTypeOptions();
    this.addRouteGridCardAssignedToClickEvent = this.addRouteGridCardAssignedToClickEvent.bind(this);
    this.editResourceTimeRangeEvent.bind(this);
    this.deleteResourceTimeRangeEvent.bind(this);

    this.recurringRouteDetailsSubscription = this._dispatchBoardService.recurringRouteDetailsSubject.subscribe((event: any) => {
      if (event?.action === 'RECURRING_ROUTE_INSTANCES_LIST') {
        this.recurringRouteInstances = _.compact(event?.data || []);
        this.updateMapRouteFilter();
      }
      else if (event?.action === 'MAP_PAN_TO_ROUTE') {
        const routeData: any =  event?.data || {};
        if (routeData?.recurring_route_name) {
          routeData['route_name'] = routeData?.recurring_route_name || '';
        }
        this.mapViewData = routeData;
      }
    });
  }

  setPreferences(): void {
    let saveschedulerPreference: boolean = false;
    let gridPreferenceLocal = this._localStorageService.getLocalStorage('dispatch_board_grid_preferences');
    let dispatchBoardFilters = this._localStorageService.getLocalStorage('dispatch_board_advance_filter');
    let schedulerPreference = this._localStorageService.getLocalStorage('dispatch_board_scheduler_preferences');
    const newGridFilterRules: any[] = [];

    if (!dispatchBoardFilters) {
      dispatchBoardFilters = this.defaultDispatchBoardFilters;
    }
    if (!schedulerPreference) {
      schedulerPreference = this.defaultSchedulerPreference;
      saveschedulerPreference = true;
    }
    if (!gridPreferenceLocal) {
      gridPreferenceLocal = { job: {}, route: {} };
    }

    if (dispatchBoardFilters?.route?.filterOptions) {
      dispatchBoardFilters.route.filterOptions = this._dispatchBoardService.sanitizeFilterOptions(dispatchBoardFilters?.route?.filterOptions);
    }

    if (gridPreferenceLocal?.route?.filter_rules) {
      gridPreferenceLocal.route.filter_rules = gridPreferenceLocal.route.filter_rules.map((rule: any) => this._utilityService.setPrepopulatedDateValue(rule));
    }
    //Set prefill data
    if (!_.isEmpty(this.prefillConfig)) {
      this.selectedQuickFilter = 'ALL';
      dispatchBoardFilters.route.filterUid = 'ALL';

      //Switch to Planning Tab
      this.selectedRouteTab = 'PLANNING';
      this._dispatchBoardService.currentTab = 'PLANNING';
      this._dispatchBoardService.trackNavigationEvent(this.selectedRouteTab);
      this.location.replaceState(this._dispatchBoardService.createQueryParam('PLANNING'));

      let hasSchedulerParamsChanged: boolean = false;
      schedulerPreference.service_territory.ROUTES = { serviceTerritoryUid: 'ALL', geoCords: [], radius: 0, serviceTerritoryName: 'All Service Territory' };
      //Prefill Grid filters
      if (this.prefillConfig?.['work-order-number'] && Number(this.prefillConfig?.['work-order-number']) && this._utilityService.isPlainPositiveNumber(this.prefillConfig?.['work-order-number'])) {
        this.selectedGridTab = 'JOBS';
        const workOrderFilterRules: any[] = this._dispatchFilterService.constructFilterRules([{ key: 'work_order_number', value: this.prefillConfig?.['work-order-number'] }]);
        newGridFilterRules.push(...workOrderFilterRules);
      }

      //Prefill Scheduler Params
      if (this.prefillConfig?.['job-uid'] && !this.prefillConfig?.['recurring-route-uid']) {
        this.schedulerFocusData.eventUid = this.prefillConfig?.['job-uid'];
        this.openMapTooltip.jobUid = this.prefillConfig?.['job-uid'];
        hasSchedulerParamsChanged = true;
      }

      if (this.prefillConfig?.['route-uid'] && !this.prefillConfig?.['recurring-route-uid']) {
        this.schedulerFocusData.eventUid = this.prefillConfig?.['route-uid'];
        this.openMapTooltip.routeUid = this.prefillConfig?.['route-uid'];
        hasSchedulerParamsChanged = true;
      }
      if (this.prefillConfig?.['user-uid']) {
        this.schedulerFocusData.userUid = this.prefillConfig?.['user-uid'];
        hasSchedulerParamsChanged = true;
      }
      if (this.prefillConfig?.['team-uid']) {
        schedulerPreference.route.team_uid = this.prefillConfig?.['team-uid'];
        hasSchedulerParamsChanged = true;
      }
      if (this.prefillConfig?.['scheduled-start-date'] && moment(this.prefillConfig?.['scheduled-start-date'], 'YYYY-MM-DD', true).isValid()) {
        schedulerPreference.route.from_date = this.prefillConfig?.['scheduled-start-date'];
        schedulerPreference.route.to_date = this.prefillConfig?.['scheduled-start-date'];
        hasSchedulerParamsChanged = true;
      }
      if (this.prefillConfig?.timezone && this._utilityService.isValidTimezone(this.prefillConfig?.timezone)) {
        schedulerPreference.timezone.ROUTES = this.prefillConfig?.timezone;
      }

      if (newGridFilterRules?.length) {
        gridPreferenceLocal.route.type = 'ALL';
        gridPreferenceLocal.route.filter_rules = newGridFilterRules;
        dispatchBoardFilters.route.filterOptions.grid = newGridFilterRules;
      }
      if (hasSchedulerParamsChanged) {
        dispatchBoardFilters.route.filterOptions.employee = this.defaultDispatchBoardFilters.route.filterOptions.employee;
        dispatchBoardFilters.route.filterOptions.scheduler = this.defaultDispatchBoardFilters.route.filterOptions.scheduler;
      }
      this.schedulerParams['filter_rules'] = dispatchBoardFilters.route.filterOptions.scheduler || [];
      this.schedulerParams['employee_filter_rules'] = dispatchBoardFilters.route.filterOptions.employee || [];
      this.gridFilterOptions = dispatchBoardFilters.route.filterOptions.grid;
      this._localStorageService.setLocalStorage('dispatch_board_grid_preferences', gridPreferenceLocal);
      this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchBoardFilters);
      this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
      this.refreshFilterCount();
      this.prefillConfig = {};
    }
    else {
      if (saveschedulerPreference) {
        this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
      }
      this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchBoardFilters);
      this._localStorageService.setLocalStorage('dispatch_board_grid_preferences', gridPreferenceLocal);
    }
    this.calculateSchedulerHeight();
    // Grid
    const gridJobPreference = gridPreferenceLocal?.['route'];
    if (gridJobPreference) {
        this.gridTbarData.JOBS.type = gridJobPreference?.['type'] || this.defaultJobGridPreference.type;
        this.gridTbarData.JOBS.sortOptions.sort = gridJobPreference?.['sort'] || this.defaultJobGridPreference.sort;
        this.gridTbarData.JOBS.sortOptions.sort_by = gridJobPreference['sort_by'] || this.defaultJobGridPreference.sort_by;
        this.gridParam = gridJobPreference || {};
    }
    this.gridViewType = this.metaData?.grid.view_type;
    this.isMapViewEnabled = this.metaData?.map?.enable_map_view;
    this.gridData.JOBS = this.gridData.ROUTES = this.routeCardData = this.tableData = this.initiateGridShimmer(7);

    // Filter
    this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchBoardFilters);
    this.currentFilters = dispatchBoardFilters.route;
    this.gridParam['filter_rules'] = this.currentFilters?.filterOptions?.grid;
    this.routeParam['filter_rules'] = this.currentFilters?.filterOptions?.grid_route;
    this.routeTypeOptions = this._dispatchBoardService.routeTypeOptions;
    if (this.enablePlanningTab) {
      this.routesTabViewOptions.push({ value: 'PLANNING', label: 'text.planning' });
    }
    // Scheduler Preferences
    this._dispatchBoardService.selectedTeam.ROUTES = this.selectedTeam = schedulerPreference?.route.team_uid;
    this.selectedTimezone = schedulerPreference?.timezone?.ROUTES || this.browserTimezone;
    this._dispatchBoardService.customTimezone = this.selectedTimezone;
    this._dispatchBoardService.selectedTimezone.ROUTES = this.selectedTimezone;
    this.schedulerTbarForm.get('selectedTeam')?.setValue(this.selectedTeam);
    this.schedulerTbarForm.get('schedulerDate')?.setValue(moment(schedulerPreference.route.date, 'YYYY-MM-DD', true));
    this.schedulerTbarForm.get('scheduleStartDate')?.setValue(moment(schedulerPreference.route.from_date, 'YYYY-MM-DD', true));
    this.schedulerTbarForm.get('scheduleEndDate')?.setValue(moment(schedulerPreference.route.to_date, 'YYYY-MM-DD', true));
    this.teamSearchPagination.filterUid = this.selectedTeam;
    this.schedulerParams['filter_rules'] = this.currentFilters?.filterOptions.scheduler;
    this.schedulerParams['employee_filter_rules'] = this.currentFilters?.filterOptions.employee;
    this.schedulerParams['route_filter_rules'] = this.currentFilters?.filterOptions.scheduler_route;
    this.selectedServiceTerritory = schedulerPreference?.service_territory?.ROUTES?.serviceTerritoryUid || 'ALL';
    this.selectedServiceTerritoryDetails = {
        name: schedulerPreference?.service_territory?.ROUTES?.serviceTerritoryName || '',
        type: schedulerPreference?.service_territory?.ROUTES?.type || null,
        radius: schedulerPreference?.service_territory?.ROUTES?.radius || 0,
        geoCords: schedulerPreference?.service_territory?.ROUTES?.geoCords || [null, null]
    };
    this.territorySearchPagination.filterUid = this.selectedServiceTerritory !== 'ALL' ? this.selectedServiceTerritory : '';
    this.teamSearchPagination.serviceTerritoryFilterUid = this.selectedServiceTerritory !== 'ALL' ? this.selectedServiceTerritory : '';

    let gridFilterOptions = dispatchBoardFilters?.route?.filterOptions?.grid || [];
    if (gridFilterOptions?.length && this.enableServiceTerritory) {
        const existingServiceTerritoryFilterRule = this._dispatchBoardService.getFilterRuleByKey('territory_uid', gridFilterOptions);
        if (existingServiceTerritoryFilterRule) {
            // Set filter rules based on global service territory selection - Grid
            const serviceTerritoryFilterRules = this._dispatchBoardService.getServiceTerritoryFilterRule([this.selectedServiceTerritory], [this.selectedServiceTerritoryDetails.name], existingServiceTerritoryFilterRule?.source || null);
            gridFilterOptions = this._dispatchBoardService.removeFilterKey('territory_uid', gridFilterOptions) || [];
            gridFilterOptions.push(serviceTerritoryFilterRules);
            gridPreferenceLocal.route.filter_rules = gridFilterOptions;
            this._localStorageService.setLocalStorage('dispatch_board_grid_preferences', gridPreferenceLocal);

            // Advanced filter values
            dispatchBoardFilters.route['filterOptions']['grid'] = gridFilterOptions;
            this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchBoardFilters);
            this.refreshFilterCount();
        }
    }

    this.userSortSearchInput$.pipe(debounceTime(250), takeUntil(this.tearDown$)).subscribe((searchKeyword: string) => {
      this.userSortData.skillSubMenu.searchKeyword = searchKeyword;
      this.userSortData.skillSubMenu.filteredSkillset = this.userSortData.skillSubMenu.skillList.filter((skill: any) => (skill?.skillset_name || '')?.toLowerCase()?.includes(searchKeyword?.toLowerCase()));
    });

    // Map
    this.allowMapView = this.selectedRouteTab !== 'PLANNING';
    this.updateDispatchRouteSplitSettings();
}

  openNoTeamAlert(): void {
    this._sharedService.isNoTeamCreatedAlertIsOpened = true;
    this.onTeamClear();
    this.noTeamAlertDialogRef = this.matDialog.open(this.noTeamAlertDialogContent, {
      panelClass: ['w-120'],
      disableClose: true,
    });

    this.noTeamAlertDialogRef.afterClosed().subscribe(() => {
      this._sharedService.isNoTeamCreatedAlertIsOpened = false;
    });
  };

  createNewTeam(): void {
    this._dispatchBoardService.createNewTeam();
    this.noTeamAlertDialogRef.close();
  }

  goBackFromCreateTeamAlert(): void {
    this.router.navigate(['/dashboard']);
    this.noTeamAlertDialogRef.close();
  }

  onTeamClear(): void {
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      this.schedulerInstance.eventStore.removeAll();
      this.schedulerInstance.assignmentStore.removeAll();
      this.schedulerInstance.resourceStore.removeAll();
      this.schedulerInstance.resourceTimeRangeStore.removeAll();
    }
    this.schedulerProConfig.events = [];
    this.schedulerProConfig.assignments = [];
    this.schedulerProConfig.resources = [];
    this.schedulerJobs = [];
    this._dispatchBoardService.jobLocationMapData.JOBS.schedulerJob = [];
    this.updateMapLayersData();
  }

  createNewJob(dragData: any): void {
    if (this._utilityService.isEmptyOrUndefined(dragData)) {
      this.newJobDrawerData.newJobPrefillData = {};
      this._dispatchBoardService.trackEvent('create_job');
    }
    else {
      this.newJobDrawerData.newJobPrefillData = dragData;
      this._dispatchBoardService.trackEvent('scheduler_drag_create_new_job');
    }
    this.newJobDrawerData.openNewJobDrawer = true;
  }

  jobFormEmitHandler(event: any): void {
    if (event?.isDrawerClosed) {
      this.newJobDrawerData.openNewJobDrawer = false;
      this.newJobDrawerData.cloneJobData = null;
      this.newJobDrawerData.newJobPrefillData = null;
    }
    if (event.isCreatedJob) {
      this.updateNewJobData(event.job_uid);
    } else if (event?.action === 'ADVANCED_JOB' && event?.job) {
      const job: dataObj = { ...event?.job, action: 'clone', isDialog: true };
      const advancedJobService = this._zuperDialogService.openCustom(JobFormComponent, {
        data: job,
        extraClass: 'advanced-job-dialog'
      });
      advancedJobService.afterClosed()
        .subscribe((dialogData: any) => {
          if (dialogData?.job_uid) {
            this.updateNewJobData(dialogData.job_uid);
          }
        });
    }
  }

  updateNewJobData(jobUid: string): void {
    if (!this._utilityService.isEmptyOrUndefined(jobUid)) {
      const jobUrl = `${this._dispatchBoardService.jobDetailsUrl}/${jobUid}`;
      this._dataCollectorService.getData(jobUrl)
        .subscribe(() => {
          if (this.selectedGridTab === 'JOBS') {
            this.getGridData().then(() => {
              this.injectGridDataIntoView();
            });
          }
        });
    }
  }

  initTabPrefillListener(): void {
    this.dispatchJobRouteTransferEmitterSubscription = this._dispatchBoardService.jobRouteTransferEmitter.subscribe(({ module, subModule, additionalParams }: any) => {
      if (module === 'ROUTES') {
        if (subModule === 'TRACKING') {
          this.onToggleRouteTab(subModule, {init: true});
        }
        else if (subModule === 'PLANNING') {
          if (additionalParams?.recurringRouteUid) {
            const paramData = { openRecurringRoutePreview: true, ...additionalParams, init: true };
            this.onToggleRouteTab(subModule, paramData);
          }
          else {
            this.onToggleRouteTab(subModule, { init: true });
          }
        }
        this.updateRouteGridTypeOptions();
      }
      if (additionalParams?.updateHoliday && additionalParams?.holidays) {
        this.holidays = additionalParams?.holidays;
        this.buildHolidaysTimeRange();
      }
      if (additionalParams?.type === 'routeDetailsOnCloseEmitter' && additionalParams?.event) {
        this.routeDetailsEvent(additionalParams?.event);
        this.routePreviewDrawerData.source = additionalParams?.source;
      }
    });
  }

  getJobPresence(jobUid: any): any[] {
    const jobPresence: any[] = [];
    const jobFromGrid = this.gridViewInstance?.store.getById(jobUid);
    const jobFromScheduler = this.schedulerInstance?.eventStore.getById(jobUid);
    if (jobFromGrid) {
      jobPresence.push('grid');
    }
    if (jobFromScheduler) {
      jobPresence.push('scheduler');
    }
    return jobPresence;
  }

  onRoutesTabViewchange(): void {
    if (this.routesTabView === 'TRACKING') {
      this.onToggleRouteTab('TRACKING');
    }
    else if (this.routesTabView === 'PLANNING') {
      this.onToggleRouteTab('PLANNING');
    }
  }

  updateRouteGridTypeOptions(): void {
    if (this.selectedRouteTab === 'TRACKING') {
      this.routeTypeOptions = this._dispatchBoardService.routeTypeOptions.filter((type: any) => {
        return type.value !== 'RECURRING_ROUTES'
      });
      if (this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
        this.gridTbarData.ROUTES.type = 'UNASSIGNED';
        this.changeGridRouteType();
      }
    }
    else if (this.selectedRouteTab === 'PLANNING') {
      this.routeTypeOptions = this._dispatchBoardService.routeTypeOptions;
    }
  }

  getRouteCardSelectors(): any[] {
    const routeGridAttributes = this.metaData?.grid?.route_card_view || {};
    const routeCardValues = this._dispatchBoardService.removeRouteCardDefaultAttributes(routeGridAttributes);
    const selectors = [];
    Object.values(routeCardValues).forEach((columns: any) => {
      columns.forEach((column: any) => {
        selectors.push(column?.selector);
      });
    });
    return selectors;
  }

  suspendAllGridEvents(): void {
    if (this.gridViewInstance) {
      this.gridViewInstance.suspendEvents();
      this.gridViewInstance.store.beginBatch();
    }
  }

  resumeAllGridEvents(): void {
    if (this.gridViewInstance) {
      this.gridViewInstance.store.endBatch(true);
      this.gridViewInstance.resumeEvents();
    }
  }

  suspendAllSchedulerEvents(options?: { resource?: boolean; event?: boolean; assignment?: boolean; timeRange?: boolean; resourceTimeRange?: boolean; preset?: boolean; timeAxis?: boolean }): void {
    this.setGridSchedulerInstance();
    this._dispatchBoardService.suspendAllSchedulerEvents(this.schedulerInstance, options);
  }

  resumeAllSchedulerEvents(options?: { resource?: boolean; event?: boolean; assignment?: boolean; timeRange?: boolean; resourceTimeRange?: boolean; preset?: boolean; timeAxis?: boolean }): void {
    this.setGridSchedulerInstance();
    this._dispatchBoardService.resumeAllSchedulerEvents(this.schedulerInstance, options);
  }

  //Navbar
  onToggleRouteTab(selectedTab: 'TRACKING' | 'PLANNING', additionalParams?: any): void {
    this.selectedRouteTab = selectedTab;
    this.routesTabView = selectedTab;
    if (selectedTab === 'PLANNING') {
      this.onSchedulerDateRangeChange(additionalParams?.init);
      if (additionalParams?.openRecurringRoutePreview && additionalParams?.recurringRouteUid) {
        this.onToggleGridTab('ROUTES');
        this.gridTbarData.ROUTES.type = 'RECURRING_ROUTES';
        this.changeGridRouteType();
        this.openRecurringRoutePreview(additionalParams?.recurringRouteUid);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.location.replaceState(this._dispatchBoardService.createQueryParam('PLANNING', { 'recurrence-route-uid': additionalParams?.recurringRouteUid }));
      }
      else {
        this.location.replaceState(this._dispatchBoardService.createQueryParam('PLANNING'));
      }

      this._dispatchBoardService.currentTab = 'PLANNING';
      if (!this.dispatchRouteSplitSettings.visible.scheduler) {
        this.resetSplitVisibility(1);
      }
      this._dispatchBoardService.trackNavigationEvent(selectedTab);
    }
    else if (selectedTab === 'TRACKING') {
      this.onSchedulerDateChange(additionalParams?.init);
      if (this.recurringRouteDetails.isOpened) {
        this.closeRecurringRoutePreview();
      }
      this.location.replaceState(this._dispatchBoardService.createQueryParam('ROUTES'));
      this._dispatchBoardService.currentTab = 'ROUTES';
      this._dispatchBoardService.trackNavigationEvent('ROUTES');
    }
    this.toggleMapLegendBar(false, null, true);
    this.selectedPlanningTab = 'SCHEDULE';
    this.allowMapView = this.selectedRouteTab !== 'PLANNING';
    this.isDrawOnMapView = false;
    this.updateDispatchRouteSplitSettings();
    this.closeDispatchFilter();
    this.updateRouteGridTypeOptions();
    this._mapService.toggleMapDrawTool(this.metaData?.map?.layers?.routes);
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      this.schedulerInstance.refresh();
    }
  }

  onTogglePlanningTab(selectedTab: 'SCHEDULE' | 'MAP'): void {
    this.selectedPlanningTab = selectedTab;
    if (selectedTab === 'SCHEDULE') {
      this.onSchedulerDateRangeChange();
      this.location.replaceState(this._dispatchBoardService.createQueryParam('PLANNING'));
      this._dispatchBoardService.currentTab = 'PLANNING';
      this._dispatchBoardService.trackNavigationEvent('PLANNING');
      if (this.recurringRouteDetails.isOpened) {
        this.setRecurringRouteMasterDetailsSplitSettings();
      }
      else {
        this.updateDispatchRouteSplitSettings();
      }
    }
    else if (selectedTab === 'MAP') {
      this._dispatchBoardService.injectDrawOnMapData(null, this.selectedPlanningTab, this.metaData, null, true);
      this.location.replaceState(this._dispatchBoardService.createQueryParam('MAP'));
      this._dispatchBoardService.currentTab = 'MAP';
      this._dispatchBoardService.trackNavigationEvent(selectedTab);
    }
    this.toggleMapLegendBar(false, null, true);
    this._dispatchBoardService.setSchedulerScrollPosition(this.schedulerInstance, this.currentView);
    this.allowMapView = this.selectedRouteTab !== 'PLANNING';
    this.isDrawOnMapView = this.selectedRouteTab === 'PLANNING' && this.selectedPlanningTab === 'MAP' ? true : false;
    this.updateRouteGridTypeOptions();
    this.closeDispatchFilter();
  }

  onDispatchTabChange(module: 'JOBS' | 'ROUTES'): void {
    this.selectedDispatchTab = module;
    this._dispatchBoardService.activeDispatchTab = module;
    this.isDrawOnMapView = false;
    this.selectedTimezone = this._dispatchBoardService.selectedTimezone.ROUTES;
    this.updateMetaData();
    this.refreshSchedulerTimezone();
    setTimeout(() => {
      this.buildHolidaysTimeRange();
      this.gridViewInstance?.refreshRows();
      this.schedulerInstance?.renderContents();
      this._dispatchBoardService.injectServiceTerritoryMapData(this.metaData);
      this.updateMapRouteFilter();
      this.schedulerInstance.timeAxis.reconfigure({
        timezone: this.selectedTimezone,
      });
      this.schedulerInstance.refresh();
    });
  }

  getQuickFilters(init: boolean, newFilterUid: any = this.selectedQuickFilter): Observable<any> {
    const params = {
      'count': '50',
      'filter.module': 'ROUTES',
      'page': '1'
    };
    this.quickFilterLoading = true;
    return this._dataCollectorService.getData(this._dispatchBoardService.quickFilterUrl, params).pipe(
      tap((response: any) => {
        this.quickFilters = response?.data;
        this.selectedQuickFilter = this.selectedQuickFilter ? this.selectedQuickFilter : 'ALL';
        if (init) {
          this.selectedQuickFilter = this.currentFilters?.filterUid || 'ALL';
        } else {
          this.selectedQuickFilter = newFilterUid;
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const quickFilter = _.find(this.quickFilters, { 'filter_uid': this.selectedQuickFilter });
        let considerExistingFilter = true;
        if (!quickFilter && this.selectedQuickFilter !== 'ALL') {
          this.selectedQuickFilter = 'ALL';
          considerExistingFilter = false;
        }
        this.updateFilterCount();
        this.onQuickFilterChange(this.selectedQuickFilter, considerExistingFilter, init);
        this.quickFilterLoading = false;
        return response;
      }),
      catchError((error: any) => {
        this.updateFilterCount();
        this.onQuickFilterChange('ALL', true, true);
        this.quickFilterLoading = false;
        return throwError(() => error);
      })
    );
  }

  onQuickFilterChange(filterUid: any, skipComparison: boolean, init: boolean = false): void {
    this.closeDispatchFilter();
    if (filterUid === 'ADD') {
      this.addNewDispatchFilter();
      return;
    }
    else if (filterUid === 'MANAGE') {
      this.manageQuickFilters();
      return;
    }
    const dispatchFilterValues = this.getDispatchFilterValues();
    this.selectedQuickFilter = filterUid;
    this.fallbackSelectedQuickFilter = filterUid;
    this.gridBbarData[this.selectedGridTab].gridPageNumber = 1;

    //Save to local
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const filter = _.find(this.quickFilters, { 'filter_uid': filterUid });
    let quickFilterData = filter?.filter_options;
    let filterOptions = filter?.filter_options?.filterOptions;
    if (filterUid === 'ALL') {
      const isFilterApplied = Object.keys(this.filterCount).filter((module: any) => this.filterCount[module] === 0).length !== 0;
      if (isFilterApplied && init) {
        filterOptions = dispatchFilterValues?.filterOptions;
        quickFilterData = dispatchFilterValues;
      }
      else {
        filterOptions = this.defaultDispatchBoardFilters?.route.filterOptions;
        quickFilterData = this.defaultDispatchBoardFilters?.route;
      }
    }
    this.currentFilters = quickFilterData;
    const sortOptions = this.currentFilters.sortOptions;
    this.dispatchFilterDrawerData.dispatchFilterValues = quickFilterData;
    this.updateDispatchBoardFilterValuesLocal('route', quickFilterData);
    if (filterOptions) {
      this.filterCount = this._dispatchFilterService.getFilterCount(filterOptions, this.selectedDispatchTab);
      this.applyQuickFilter('quickFilter', filterOptions, sortOptions, quickFilterData, skipComparison);
    }
    else {
      this.filterCount = this.defaultDispatchBoardFilters.route.filterCount;
    }
    this.updateSelectedQuickFilterValue(filterUid, this.filterCount);
    this.updateFilterCount();
  }

  loadSchedulerData(): void {
    this.teamPickerLoading = true;
    this.territorySearchPagination.isLoading = true;
    this.quickFilterLoading == true;
    if (this.isSchedulerInitialLoad) {
      this.serviceTerritories = this.getServiceTerritory(true).pipe(shareReplay(1));
      const quickFilter$ = this.getQuickFilters(true).pipe(shareReplay(1));

      this.teams = this.serviceTerritories.pipe(
        switchMap(serviceTerritory => this.getTeams(true)),
        shareReplay(1)
      );

      forkJoin([this.serviceTerritories, this.teams, quickFilter$])
        .pipe(takeUntil(this.tearDown$))
        .subscribe({
          next: () => {
            this.getSchedulerData(true);
          }
        });
    }
  }

  getTeams(onInit: boolean = false): Observable<any> {
    this.teamPickerLoading = true;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const params = { 
      'page': this.teamSearchPagination.currentPage, 
      'filter.keyword': this.teamSearchPagination.keyword || '', 
      'filter.team_uid': this.teamSearchPagination.filterUid, 
      'sort': 'ASC', 
      'sort_by': 'team_name', 
      'filter.service_territory': this.enableServiceTerritory ? this.teamSearchPagination.serviceTerritoryFilterUid || '' : '', 
      'consider_service_territory': true 
    };
    
    const originalFilterUid = this.teamSearchPagination.filterUid;
    
    return this._dataCollectorService.getData(this._dispatchBoardService.teamDataUrl, params).pipe(
      switchMap(response => {
        if (onInit && (!response?.data || response.data.length === 0) && originalFilterUid) {
          const fallbackParams = {...params};
          fallbackParams['filter.team_uid'] = '';
          this.teamSearchPagination.filterUid = '';
          this.schedulerTbarForm.get('selectedTeam').setValue(null);
          this._dispatchBoardService.selectedTeam.ROUTES = this.selectedTeam = null;
          return this._dataCollectorService.getData(this._dispatchBoardService.teamDataUrl, fallbackParams);
        }
        return of(response);
      }),
      
      map(response => {
        if (onInit) {
          this.allTeams = response?.data || [];
          this.teamPickerList = [];
          if (this.allTeams.length === 0) {
            this.schedulerTbarForm.get('selectedTeam').setValue(null);
            this._dispatchBoardService.selectedTeam.ROUTES = this.selectedTeam = null;
            if (!this._sharedService.isNoTeamCreatedAlertIsOpened && !this.teamSearchPagination.serviceTerritoryFilterUid) {
              this.openNoTeamAlert();
            } else {
              this.onTeamClear();
            }
          } else {
            if (this._utilityService.isEmptyOrUndefined(this.schedulerTbarForm.get('selectedTeam').value)) {
              this.schedulerTbarForm.get('selectedTeam').setValue(response.data[0]?.team_uid);
              this._dispatchBoardService.selectedTeam.ROUTES = this.selectedTeam = response.data[0]?.team_uid;
            }
            this.onTeamChange(onInit);
          }
        } else {
          this.allTeams.push(...response.data);
          this.allTeams = _.uniqBy(this.allTeams, 'team_uid');
        }
        
        this.teamSearchPagination.totalPage = response.total_pages || 1;
        this.teamPickerList = _.union(this.teamPickerList, response.data || []);
        this.teamPickerList = _.uniqBy(this.teamPickerList, 'team_uid');
        this.teamPickerLoading = false;
        
        return response.data || [];
      }),
      
      catchError(error => {
        this.teamPickerLoading = false;
        return throwError(() => error);
      }),
      shareReplay(1)
    );
  }

  updateEmpShiftRenderer(): void {
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      const zoomLevel = this.schedulerInstance?.zoomLevel;
      const addShiftDetails = this.currentView === 'DAY' || (this.currentView === 'WEEK' && (zoomLevel === 1 || zoomLevel === 2)) || (this.currentView === 'MONTH' && zoomLevel === 1);
      if (addShiftDetails) {
        this._dispatchBoardService.setResourceShift(this.schedulerInstance, this.schedulerEmployees, 'DAY');
      }
      else {
        let resourceTimeRanges: any[] = this.schedulerInstance?.resourceTimeRanges;
        resourceTimeRanges = resourceTimeRanges.filter((resourceTimeRange: any) => !resourceTimeRange.id.startsWith('empShift_'));
        this.schedulerInstance.resourceTimeRanges = resourceTimeRanges;
      }
    }
  }

  onTeamPickerOpen(): void {
    if (this.teamSearchPagination.filterUid && this.selectedTeam) {
      this.teamSearchPagination.currentPage = 1;
      this.teamSearchPagination.filterUid = '';
      this.teamSearchPagination.keyword = '';
      this.getTeams().subscribe((teams: any) => {
        this.teams = of(_.uniqBy(_.union(teams, this.teamPickerList), 'team_uid'));
      });
    }
  }

  teamPickerScrollToEnd(): any {
    if (this.teamSearchPagination.currentPage < this.teamSearchPagination.totalPage) {
      this.teamSearchPagination.currentPage += 1;
      this.getTeams().subscribe(() => {
        this.teams = of(_.uniqBy(this.teamPickerList, 'team_uid'));
      });

    }
  }

  onTeamSearch(): void {
    if (this.teamSearchPagination.currentPage !== this.teamSearchPagination.totalPage || this.teamSearchPagination.filterUid) {
      this.teams = this.teamValueSubject.pipe(
        distinctUntilChanged(),
        debounceTime(500),
        switchMap((term: any) => {
          if (!_.isNil(term)) {
            this.teamSearchPagination.keyword = term;
            this.teamSearchPagination.currentPage = 1;
            this.teamSearchPagination.filterUid = '';
            if (term?.trim().length === 0) {
              this.teamSearchPagination.keyword = '';
            }
            return this.getTeams();
          }
          else {
            return of(this.teamPickerList);
          }
        })
      );
    }
  }

  onTeamChange(init?: boolean): void {
    // TODO: check if config has multi-team enabled amd join the array of uids
    this._dispatchBoardService.selectedTeam.ROUTES = this.selectedTeam = this.schedulerTbarForm.get('selectedTeam')?.value;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this.schedulerParams = { ...this.schedulerParams, 'filter.team_uid': this.selectedTeam };
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const selecetdTeam = _.find(this.allTeams, { 'team_uid': this.schedulerTbarForm.get('selectedTeam')?.value });
    this.selectedTeamTimezone = selecetdTeam?.team_timezone;
    this.selectedTimezone = this._dispatchBoardService.getTimezonePrecedence(this.selectedTeamTimezone);
    if (!init) {
      this.getSchedulerData(true);
    }
    this.refreshSchedulerTimezone();
    this.resetEmployeeSearch();
    this.updateTeamInUserFilter();
  }

  updateTeamInUserFilter(): void {
    const teamName: string = this.getTeamName(this.selectedTeam)
    this.dispatchFilterDrawerData.additionalFilters = {
      key: 'assigned_to.user_uid',
      filter: {
        'filter.team_uid': this.selectedTeam
      }, 
      appendToDisplayKey: teamName ? `${this._utilityService.getLocaleValue('text.users_team')} : ${teamName}`: ''
    };
  }

  onCustomTimezoneChange(): void {
    this.selectedTimezone = this._dispatchBoardService.customTimezone;
    this.refreshSchedulerTimezone();
    //Workaround - set schduler data after a delay to avoid timezone related issue in nested events.
    setTimeout(() => {
      this.constructSchedulerData(this.schedulerData, false);
    }, 100);
  }

  onSchedulerPlanningNavTabChange(selectedTab: 'DISPATCH_BOARD' | 'MAP'): void {
  if (selectedTab === 'DISPATCH_BOARD') {
      this._mapService.clearDrawLayer.next(true);
    }
    this.selectedSchedulerPlanningNavTab = selectedTab;
    if (this.selectedSchedulerPlanningNavTab === 'MAP') {
      this._mapService.showOnMap.next({ module: 'ROUTES', eventUid: '' });
      setTimeout(()=> {
        this._mapService.mapResizeIndicator.next(true);
      }, 100);
    }
  }

  //Grid
  updateGridParams(gridTab?: 'JOBS' | 'ROUTES' | 'RECURRING_ROUTES'): void {
    this.updateMetaData();
    const count = this.metaData?.grid.job_count || 10;
    let params: any = {};
    if (gridTab === 'JOBS') {
      params['count'] = count;
      params['page'] = this.gridBbarData.JOBS.gridPageNumber || 1;
      params['type'] = this.gridTbarData.JOBS.type;
      params['sort'] = this.gridTbarData.JOBS.sortOptions.sort;
      params['sort_by'] = this.gridTbarData.JOBS.sortOptions.sort_by;
      params['timezone'] = this.selectedTimezone;
      params['filter_rules'] = this.currentFilters?.filterOptions?.grid || [];
      params = {...this.gridParam, ...params};
      this.gridParam = _.cloneDeep(params);
    }
    else if (gridTab === 'ROUTES') {
      params['count'] = count;
      params['page'] = this.gridBbarData.ROUTES.gridPageNumber || 1;
      params['filter_rules'] = this._dispatchBoardService.addSearchKeywordFilterRule(this.gridTbarData.ROUTES.gridSearchKeyword, this.routeParam?.filter_rules || []);
      params['sort'] = this.gridTbarData.ROUTES.sortOptions.sort;
      params['sort_by'] = this.gridTbarData.ROUTES.sortOptions.sort_by;
      params['timezone'] = this.selectedTimezone;
      this.routeParam = _.cloneDeep(params);
    }
    else if (gridTab === 'RECURRING_ROUTES') {
      params['count'] = count;
      params['page'] = this.gridBbarData.ROUTES.gridPageNumber || 1;
      params['filter.keyword'] = this.gridTbarData.ROUTES.gridSearchKeyword;
      params['timezone'] = this.selectedTimezone;
      params['sort'] = this.recurringRouteSortOptions.sort;
      params['sort_by'] = this.recurringRouteSortOptions.sort_by;
      this.recurringRouteParam = _.cloneDeep(params);
    }
  }

  updateGridParamValue(key: string, value: any): void {
    if (!key) { return; }
    if (this.selectedGridTab === 'JOBS') {
      this.gridParam[key] = value;
    }
    else if (this.selectedGridTab === 'ROUTES') {
      if (this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
        this.recurringRouteParam[key] = value;
      }
      else {
        this.routeParam[key] = value;
      }
    }
  }

  getGridData(updateParam: boolean = false): Promise<any> {
    if (updateParam) {
      this.updateGridParams('JOBS');
    }
    this.gridParam['type'] = this.gridTbarData.JOBS.type;
    const params: any = this.gridParam;
    if (this.gridViewType === 'listView') {
      this.routeCardData = this.initiateGridShimmer(7);
    } else if (this.gridViewType === 'tableView') {
      this.tableData = this.initiateGridShimmer(7);
    }
    params['populate_route'] = true;
    params['use_color_profile'] = true;
    params['page'] = this.gridBbarData.JOBS.gridPageNumber;
    params['count'] = this.metaData?.grid.job_count || 10;
    params['filter_rules'] = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', params?.filter_rules || []);
    if (this.enableServiceTerritory) {
      if (this.selectedServiceTerritory !== 'ALL') {
        const serviceTerritoryFilterRules = this._dispatchBoardService.getServiceTerritoryFilterRule([this.selectedServiceTerritory], [this.selectedServiceTerritoryDetails.name], 'dispatch_board_global');
        params['filter_rules'] = this._dispatchBoardService.removeFilterKey('territory_uid', params['filter_rules']) || [];
        params['filter_rules'].push(serviceTerritoryFilterRules);
      }
      else {
        params['filter_rules'] = this._dispatchBoardService.removeFilterKey('territory_uid', params['filter_rules']) || [];
      }
    }
    else {
      const existingServiceTerritoryFilterRule = this._dispatchBoardService.getFilterRuleByKey('territory_uid', params['filter_rules']);
      if (existingServiceTerritoryFilterRule?.source === 'dispatch_board_global') {
        params['filter_rules'] = this._dispatchBoardService.removeFilterKey('territory_uid', params['filter_rules']) || [];
      }
    }
    this.loadingGridData = true;
    return new Promise((resolve) => {
      this._dataCollectorService.postData(this._dispatchBoardService.gridDataUrl, params)
        .subscribe((response: any) => {
          this.gridData.JOBS = response.data?.[this.gridJobTypeMap[params?.type]].map((ele: any) => ({ ...ele, id: ele.job_uid, detailsType: 'job' }));
          this._dispatchBoardService.setRouteTabGridRecords(this.gridData.JOBS);
          this._dispatchBoardService.injectJobLocationMapData('ROUTES', 'gridJob', this.metaData, this.gridData.JOBS);
          this._dispatchBoardService.injectDrawOnMapData('ROUTES', this.selectedPlanningTab, this.metaData, this.gridData.JOBS);
          this.updateMapRouteFilter();
          this._configurationService.saveGridPreference(params, 'route');
          this.gridViewParamData.JOBS = _.cloneDeep(params);
          this.gridTbarData.JOBS.type = params?.type;
          this.gridBbarData.JOBS.totalGridPage = response.total_pages || 1;
          this.gridBbarData.JOBS.totalGridRecords = response.total_records || 1;
          this.gridBbarData.JOBS.gridPageNumber = Number(response?.current_page) || 1;
          this.gridTbarData.JOBS.gridSearchKeyword = this._dispatchBoardService.getFilterValue('keyword', params?.filter_rules) || '';
          //set grid sort values
          this.gridTbarData.JOBS.sortOptions.sort = params?.sort;
          this.gridTbarData.JOBS.sortOptions.sort_by = params?.sort_by;
          this.updateSearchFilterValue('grid');
          this.drawOnMapDrawCreatedEvent({ type: 'delete' });
          this.loadingGridData = false;
          resolve(this.gridData.JOBS);
        },
          () => {
            this.gridData.JOBS = [];
            this.loadingGridData = false;
            resolve([]);
          });
    });
  }

  getRouteData(updateParam: boolean = false): Promise<any> {
    if (updateParam) {
      this.updateGridParams('ROUTES');
    }
    let params: any = this.routeParam;
    params['count'] = this.metaData?.grid.job_count || 10;
    if (this.gridViewType === 'listView') {
      this.routeCardData = this.initiateGridShimmer(7);
    } else if (this.gridViewType === 'tableView') {
      this.tableData = this.initiateGridShimmer(7);
    }
    params['filter_rules'] = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', params?.filter_rules || []);
    if (this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
      return new Promise((resolve) => {
        if (updateParam) {
          this.updateGridParams('RECURRING_ROUTES');
        }
        const recurringRouteParam = _.cloneDeep(this.recurringRouteParam);
        this._dataCollectorService.getData(this._dispatchBoardService.recurringRoutesDataUrl, recurringRouteParam).subscribe((response) => {
          this.gridData.ROUTES = response.data?.map((ele: any) => ({ ...ele, id: ele.recurring_route_uid, detailsType: 'recurringRoute' }));
          this.gridViewParamData.RECURRING_ROUTES = _.cloneDeep(recurringRouteParam);;
          this.gridBbarData.ROUTES.totalGridPage = response.total_pages || 1;
          this.gridBbarData.ROUTES.totalGridRecords = response.total_records || 1;
          this.gridBbarData.ROUTES.gridPageNumber = Number(recurringRouteParam?.page) || 1;
          this.gridTbarData.ROUTES.gridSearchKeyword = recurringRouteParam?.['filter.keyword'];
          this.updateMapRouteFilter();
          this.drawOnMapDrawCreatedEvent({ type: 'delete' });
          resolve(this.gridData.ROUTES);
        },
          () => {
            this.gridData.ROUTES = [];
            resolve([]);
          });
      });
    }
    else {
      params = this.updateGridRouteTypeParam(params);
      return new Promise((resolve) => {
        this._dataCollectorService.postData(this._dispatchBoardService.routesFilterDataUrl, params).subscribe((response) => {
          this.gridData.ROUTES = response.data?.map((ele: any) => ({ ...ele, id: ele.route_uid, detailsType: 'route' }));
          this._dispatchBoardService.setRouteTabRoutesRecord(this.gridData.ROUTES);
          this.updateMapRouteFilter();
          this._dispatchBoardService.injectDrawOnMapData('ROUTES', this.selectedPlanningTab, this.metaData, this.gridData.ROUTES);
          this.gridViewParamData.ROUTES = _.cloneDeep(params);
          this.gridBbarData.ROUTES.totalGridPage = response.total_pages || 1;
          this.gridBbarData.ROUTES.totalGridRecords = response.total_records || 1;
          this.gridBbarData.ROUTES.gridPageNumber = Number(params?.page) || 1;
          this.drawOnMapDrawCreatedEvent({ type: 'delete' });
          this.gridTbarData.ROUTES.gridSearchKeyword = this._dispatchBoardService.getFilterValue('keyword', params?.filter_rules) || '';;
          resolve(this.gridData.ROUTES);
        },
          () => {
            this.gridData.ROUTES = [];
            resolve([]);
          });
      });
    }
  }

  changeGridJobType(): void {
    this.updateMetaData();
    if (this.gridTbarData[this.selectedGridTab].type === 'UNSCHEDULED') {
      if (this.gridTbarData.JOBS.sortOptions.sort_by === 'scheduled_start_time') {
        this.gridTbarData.JOBS.sortOptions.sort_by = 'due_date';
      }
    }
    this.gridBbarData[this.selectedGridTab].gridPageNumber = 1;
    this.updateGridData();
  }

  applyGridSearch(event: any, action?: string): void {
    if (event?.keyCode === 13 || action === 'clear') {
      const searchKeyword = this.gridTbarData[this.selectedGridTab].gridSearchKeyword.trim();
      let oldFilterKeyword: string = null;
      let gridFilterRules: any;
      if (this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
        oldFilterKeyword = this.recurringRouteParam['filter.keyword'] || '';
      }
      else {
        gridFilterRules = this.getGridParam('filter_rules');
        oldFilterKeyword = this._dispatchBoardService.getFilterValue('keyword', gridFilterRules) || '';
      }
      if (oldFilterKeyword !== searchKeyword) {
        if (this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
          this.updateGridParamValue('filter.keyword', searchKeyword);
        }
        else {
          this.updateSearchFilterValue('routeGrid');
          const updatedFilterRules = this._dispatchBoardService.addSearchKeywordFilterRule(searchKeyword, gridFilterRules);
          this.updateGridParamValue('filter_rules', updatedFilterRules);
        }
      }
      this.updateGridParamValue('page', 1);
      this.gridBbarData[this.selectedGridTab].gridPageNumber = 1;
      this.updateGridData(false, true);
    }
  }

  setGridSort(key: string, value: string): void {
    this.gridTbarData[this.selectedGridTab].sortOptions[key] = value;
  }

  setRecurringRouteGridSort(key: string, value: string): void {
    this.recurringRouteSortOptions[key] = value;
  }

  updateSearchFilterValue(filterOption: 'grid' | 'scheduler' | 'routeGrid'): void {
    const quickFilterOptions = this.getDispatchFilterValues();
    if (filterOption === 'grid') {
      quickFilterOptions.filterOptions.grid = this._dispatchBoardService.addSearchKeywordFilterRule(this.gridTbarData[this.selectedGridTab].gridSearchKeyword, quickFilterOptions.filterOptions?.grid);
    }
    else if (filterOption === 'scheduler') {
      quickFilterOptions.filterOptions.employee = this._dispatchBoardService.addSearchKeywordFilterRule(this.employeeSearchKeyword, quickFilterOptions.filterOptions?.employee);
    }
    else if (filterOption === 'routeGrid') {
      if (this.selectedGridTab === 'JOBS') {
        quickFilterOptions.filterOptions.grid = this._dispatchBoardService.addSearchKeywordFilterRule(this.gridTbarData[this.selectedGridTab].gridSearchKeyword, quickFilterOptions.filterOptions?.grid);
      }
      else if (this.selectedGridTab === 'ROUTES') {
        quickFilterOptions.filterOptions.grid_route = this._dispatchBoardService.addSearchKeywordFilterRule(this.gridTbarData[this.selectedGridTab].gridSearchKeyword, quickFilterOptions.filterOptions?.grid_route);;
      }
    }
    this.filterCount = this._dispatchFilterService.getFilterCount(quickFilterOptions?.filterOptions, this.selectedDispatchTab);
    quickFilterOptions['filterCount'] = this.filterCount;
    this.updateDispatchBoardFilterValuesLocal('route', quickFilterOptions);
    this.updateFilterCount();
  }

  applyGridSort(tipptName: string): void {
    const selectedTab = this.selectedGridTab;
    this.ngxTippyService.hide(tipptName);
    const rollBackParams = { ...this.getGridParam('all') };
    rollBackParams['page'] = this.gridBbarData[selectedTab].gridPageNumber;
    this.gridBbarData[selectedTab].gridPageNumber = 1;
    this.updateGridData().then((status: boolean) => {
      if (status) {
        this.updateTableSort();
        this.injectGridDataIntoView();
        this.gridBbarData[selectedTab].gridPageNumber = 1;
      }
    }, () => {
      this.injectGridDataIntoView(this.gridData.JOBS);
      this.gridParam = rollBackParams;
      this.gridTbarData[selectedTab].sortOptions.sort = rollBackParams?.sort;
      this.gridTbarData[selectedTab].sortOptions.sort_by = rollBackParams?.sort_by;
      this.gridBbarData[selectedTab].gridPageNumber = rollBackParams?.page;
    });
  }

  updateTableSort(): void {
    if (this.gridViewType === 'tableView' && this.tableViewInstance) {
      this.tableViewInstance.store.sorters = [];
      const sortableColumn = _.findKey(this.gridSortableColumns, value => value === this.gridTbarData[this.selectedGridTab].sortOptions.sort_by);
      if (sortableColumn) {
        const sorters = {
          'ascending': this.gridTbarData[this.selectedGridTab].sortOptions.sort === 'ASC' ? true : false,
          'columnOwned': true,
          'field': sortableColumn
        };
        this.tableViewInstance.store.sorters.push(sorters);
      }
      this.tableViewInstance?.renderHeader();
    }
  }

  updateGridPageNumber(event: any): void {
    const selectedTab = this.selectedGridTab;
    const previousPage = selectedTab === 'JOBS' ? this.gridParam['page'] : this.routeParam['page'];
    if (event?.keyCode === 13) {
      const currentPage = _.cloneDeep(this.gridBbarData[selectedTab].gridPageNumber);
      if (currentPage.toString().length === 0 || this.gridBbarData?.[selectedTab].gridPageNumber === 0) {
        this.gridBbarData[selectedTab].gridPageNumber = 1;
      }
      if (this.gridBbarData[selectedTab].gridPageNumber > this.gridBbarData[selectedTab].totalGridPage) {
        this.gridBbarData[selectedTab].gridPageNumber = this.gridBbarData[this.selectedGridTab].totalGridPage;
      }
      if (previousPage !== this.gridBbarData[selectedTab].gridPageNumber) {
        this.updateGridData();
      }
    }
  }

  gridPageIncrement(type: 'next' | 'prev'): void {
    const currentGridPageNumber: number = Number(this.gridBbarData[this.selectedGridTab].gridPageNumber);
    const updatedPageNumber = type === 'next' ? currentGridPageNumber + 1 : currentGridPageNumber - 1;
    if (updatedPageNumber > 0 && updatedPageNumber <= this.gridBbarData[this.selectedGridTab].totalGridPage) {
      this.gridBbarData[this.selectedGridTab].gridPageNumber = updatedPageNumber;
      this.updateGridData(false, true, true);
    }
  }

  getGridParam(key: string): any {
    if (!key) { return; };
    let paramValue: string = '';
    if (this.selectedGridTab === 'JOBS') {
      paramValue = key === 'all' ? this.gridParam : this.gridParam?.[key];
    }
    else if (this.selectedGridTab === 'ROUTES') {
      if (this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
        paramValue = key === 'all' ? this.recurringRouteParam : this.recurringRouteParam?.[key];
      }
      else {
        paramValue = key === 'all' ? this.routeParam : this.routeParam?.[key];
      }
    }
    return paramValue;
  }

  setCardConfig(): void {
    const _this = this;
    this.cardConfig = {
      autoHeight: false,
      height: '100%',
      columns: [{
        type: 'template',
        readOnly: true,
        autoHeight: true,
        template: (record: any): string => {
          if (record.record.data?.showShimmer) {
            return this.templateService.getCardShimmer();
          }
          else {
            const cardType = record.record.data?.detailsType;
            let template: string = '';
            if (cardType === 'job') {
              const jobUid = record.record.data?.job_uid;
              template = _this.templateService.getJobRendererTemplate('routes', 'jobGridCard', jobUid);
            }
            else if (cardType === 'route') {
              const routeDetails = record.record?.data;
              const routeGridcardSelectors = this.getRouteCardSelectors();
              template = _this.templateService.getRouteCardRenderer(routeDetails, routeGridcardSelectors);
            }
            else if (cardType === 'recurringRoute') {
              const rrRouteDetails = record.record?.data;
              template = _this.templateService.getRecurringRouteCardRenderer(rrRouteDetails);
            }
            return template;
          }
        }
      }],
      onCellClick: (row: any): any => {
        this.gridOnCellClickToastRef?.close();
        const detailsType = row?.record.data.detailsType;
        if (detailsType === 'job') {
          if (!this.metaData?.map?.layers?.jobs) {
            return;
          }
          const jobDetails = row?.record.data;
          const jobUid = jobDetails?.job_uid;
          if (jobUid) {
            if (jobDetails?.route?.route_uid) {
              if (this.moduleAccess.map && this.metaData?.map?.enable_map_view) {
                this.gridOnCellClickToastRef = this._toastService.warning(this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.error.associated_with_route', 'Click on Associated Route for Job Location'));
              }
              else {
                this.openJobPreviewDrawer(jobUid, 'grid');
                this._dispatchBoardService.trackEvent('grid_job_preview');
              }
            }
            else {
              if (this.moduleAccess?.map && this.metaData?.map?.enable_map_view) {
                if (this._utilityService.isValidGeoCords(jobDetails?.customer_address?.geo_cordinates)) {
                  if (this.selectedRouteTab === 'PLANNING' && this.selectedSchedulerPlanningNavTab === 'DISPATCH_BOARD') {
                    this.onSchedulerPlanningNavTabChange('MAP');
                  }
                  this._mapService.showOnMap.next({ module: 'JOBS', eventUid: jobUid });
                }
                else {
                  this.gridOnCellClickToastRef = this._toastService.error(this._utilityService.getLocaleValue('dataPicker.job.geo_coordinates.alert_text', 'Geo Co-ordinates not found for this job'));
                }
              }
              else {
                this.openJobPreviewDrawer(jobUid, 'grid');
                this._dispatchBoardService.trackEvent('grid_job_preview');
              }
            }
          }
        }
        else if (detailsType === 'route') {
          if (!this.metaData?.map?.layers?.routes) {
            return;
          }
          const routeDetails = row?.record.data;
          if (this.moduleAccess?.map && this.metaData?.map?.enable_map_view) {
            const routeUid = routeDetails?.route_uid;
            if (routeUid) {
              if (this.selectedRouteTab === 'PLANNING' && this.selectedSchedulerPlanningNavTab === 'DISPATCH_BOARD') {
                this.onSchedulerPlanningNavTabChange('MAP');
              }
              this._mapService.showOnMap.next({ module: 'ROUTES', eventUid: routeUid });
            }
          }
          else {
            if (routeDetails?.route_uid) {
              this.openRoutePreviewDrawer(routeDetails?.route_uid, 'grid');
              this._dispatchBoardService.trackEvent('grid_route_preview');
            }
          }
        }
        else if (detailsType === 'recurringRoute') {
          const rrDetails = row?.record?.data;
          const routeUid = rrDetails?.recurring_route_uid;
          if (routeUid) {
            this._dispatchBoardService.trackEvent('grid_recurring_route_preview');
            this.openRecurringRoutePreview(routeUid);
          }
        }
      },
      onScroll: (): any => {
        if (this.routeGridAssignedToTippyRef) {
          this.closeRouteGridAssignedToTippy();
        }
      },
      listeners: {
        rowmouseenter: (context: any): any => {
          if (this.selectedGridTab === 'ROUTES' && !context?.record?.data?.is_locked) {
            //Assigned to event
            const assignToBtn = context.cellElement.querySelector('#assign-user-btn');
            if (assignToBtn) {
              this.routeGridCardUserAssignTippyData.assignedToBtnRef = assignToBtn;
              this.routeGridCardUserAssignTippyData.updatedRouteDetails = context?.record?.data;

              if (!this.routeGridAssignedToTippyRef?.state?.isShown) {
                this.routeGridCardUserAssignTippyData.routeDetails = context?.record?.data;
              }
              assignToBtn.addEventListener('click', this.addRouteGridCardAssignedToClickEvent, true);
            }
          }
        },
        rowMouseLeave: (event: any): any => {
          if (this.selectedGridTab === 'ROUTES') {
            const assignToBtn = event.cellElement.querySelector('#assign-user-btn');
            if (assignToBtn) {
              assignToBtn.removeEventListener('click', this.addRouteGridCardAssignedToClickEvent, true);
            }
          }
        },
      },
      features: {
        cellMenu: {
          triggerEvent: false,
          items: {
            removeRow: false,
            cut: false,
            copy: false,
            paste: false,
            viewRouteDetails: {
              text: this._utilityService.getLocaleValue('text.view_details', 'View Details'),
              weight: 300,
              cls: 'primary-font leading-normal font-normal text-base text-gray-700',
              icon: 'ti ti-file-description text-xl',
              onItem(event: any): any {
                const routeDetails = event?.record?.originalData;
                if (routeDetails?.route_uid) {
                  _this.openRoutePreviewDrawer(routeDetails?.route_uid, 'grid');
                  _this._dispatchBoardService.trackEvent('grid_route_preview');
                }
              }
            },
            viewJobDetails: {
              text: this._utilityService.getLocaleValue('text.view_details', 'View Details'),
              weight: 300,
              cls: 'primary-font leading-normal font-normal text-base text-gray-700',
              icon: 'ti ti-file-description text-xl',
              onItem(event: any): any {
                const jobDetails = event?.record?.originalData;
                if (jobDetails?.job_uid) {
                  _this.openJobPreviewDrawer(jobDetails?.job_uid, 'grid');
                  _this._dispatchBoardService.trackEvent('grid_job_preview');
                }
              } 
            },
            openRouteMaster: {
              icon: 'ti ti-route text-xl',
              text: this._utilityService.getLocaleValue('text.open_route_master', 'Open Route Master'),
              weight: 300,
              cls: 'primary-font leading-normal font-normal text-base text-gray-700',
              onItem: (event: any): any => {
                const routeDetails = event.record.data;
                if (routeDetails?.is_recurrence) {
                  const recurringRouteMasterUid = routeDetails?.recurring_route?.recurring_route_uid;
                  if (recurringRouteMasterUid) {
                    this.openRecurringRoutePreview(recurringRouteMasterUid, routeDetails);
                  }
                }
              }
            },
            removeRouteInstance: {
              icon: 'ti ti-trash text-xl text-red-600',
              text: this._utilityService.getLocaleValue('text.delete_route_instance', 'Delete Route Instance'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-red-600',
              onItem: (event: any): any => {
                const routeDetails = event.record.data;
                const routeUid = routeDetails?.route_uid;
                this._dispatchBoardService.trackEvent('grid_delete_route');
                const deleteConfirmationDialogRef = this._dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, 'deleteRoute');
                deleteConfirmationDialogRef.afterClosed()
                  .subscribe((_result: any) => {
                    if (_result) {
                      this._dispatchBoardService.deleteRoute(routeUid, (status: true) => {
                        if (status) {
                          this.schedulerInstance?.eventStore.remove(routeUid);
                          this.removeEventFromGrid(routeUid);
                          this.updateLocalRecordsAfterChanges('ROUTES', routeDetails, 'delete');
                          this.updateMapRouteFilter();
                        }
                      });
                    }
                  });
              }
            },
          },
          processItems: (event: any): any => {
            const items: any = event.items;
            if (this.selectedGridTab == 'JOBS') { 
              const jobDetails = event.record?.['originalData'];
              if (!jobDetails?.job_uid) {
                return false;
              }
              items.viewRouteDetails.hidden = true;
              items.openRouteMaster.hidden = true;
              items.removeRouteInstance.hidden = true;
              items.viewJobDetails.hidden = false;
            }
            else if (this.selectedGridTab == 'ROUTES') {
              const routeDetails = event.record.data;
              if (!routeDetails?.route_uid) {
                return false;
              }
              items.openRouteMaster.hidden = !routeDetails?.is_recurrence;
              items.removeRouteInstance.text = routeDetails?.is_recurrence? this._utilityService.getLocaleValue('text.delete_route_instance', 'Delete Route Instance'): this._utilityService.getLocaleValue('text.delete_route', 'Delete Route');
              items.removeRouteInstance.hidden = routeDetails?.is_locked;
              items.viewRouteDetails.hidden = false;
              items.viewJobDetails.hidden = true;
            }
          }
        },
        headerMenu: false
      }
    };
  }

  addRouteGridCardAssignedToClickEvent(btnEvent: any): void {
      btnEvent.preventDefault();
      btnEvent.stopPropagation();
      const assignToBtn = this.routeGridCardUserAssignTippyData.assignedToBtnRef;
      if (!this.routeGridAssignedToTippyRef && !assignToBtn._tippy?.state?.isShown) {
        this.routeGridAssignedToTippyRef = tippy((assignToBtn), {
          allowHTML: true,
          theme: 'light',
          hideOnClick: false,
          trigger: 'manual',
          interactive: true,
          appendTo: this.gridSchedulerContainerRef.nativeElement,
          placement: 'right',
          zIndex: 100,
          content: this.routeGridAssignedToContent.nativeElement,
          onShow: (instance: any) => {
            const popperElement: any = instance.popper.querySelector('.tippy-content');
            if (popperElement) {
              popperElement.firstChild.classList.remove('hidden');
            }
            const routeDetails = this.routeGridCardUserAssignTippyData.routeDetails;
            if (routeDetails) {
              this.routeGridCardUserAssignTippyData.prefillUsers = routeDetails?.assigned_to;
            }
          },
          onClickOutside: (instance: any, _event: any) => {
            const ngSelectDropdown = document.querySelector('.ng-dropdown-panel');
            const assignToButtons = (this.cardViewComponent?.['elementRef']?.['nativeElement'] as HTMLElement).querySelectorAll('#assign-user-btn');
            let isClickedOnAssignedToBtn: boolean = false;
            _.forEach(assignToButtons, (_assignToBtn: any) => {
              if (_assignToBtn.contains(_event.target)) {
                isClickedOnAssignedToBtn = true;
                return false;
              }
            });
            if (ngSelectDropdown && ngSelectDropdown.contains(_event.target)) {
              return false; // Prevent onClickOutside for ng-select dropdown clicks
            }
            if (isClickedOnAssignedToBtn) {
              this.closeRouteGridAssignedToTippy(true);
            }
            else {
              this.closeRouteGridAssignedToTippy();
            }
          }
        });
      }
      else {
        if (this.routeGridAssignedToTippyRef) {
          this.routeGridAssignedToTippyRef.hide();
        }
        this.routeGridCardUserAssignTippyData.routeDetails = this.routeGridCardUserAssignTippyData.updatedRouteDetails;
      }
      this.routeGridAssignedToTippyRef.show();
  }

  setTableConfig(): void {
    this.tableConfig = {
      autoHeight: false,
      height: '100%',
      features: {
        cellMenu: {
          items: {
            copy: false,
            cut: false,
            edit: false,
            paste: false,
            removeRow: false,
            viewRouteDetails: {
              text: this._utilityService.getLocaleValue('text.view_details', 'View Details'),
              weight: 300,
              cls: 'primary-font leading-normal font-normal text-base text-gray-700',
              icon: 'ti ti-file-description text-xl',
              onItem: (event: any): any => {
                const routeDetails = event?.record?.originalData;
                if (routeDetails?.id) {
                  this.openRoutePreviewDrawer(routeDetails?.id, 'grid');
                  this._dispatchBoardService.trackEvent('grid_route_preview');
                }
              }
            },
            viewJobDetails: {
              text: this._utilityService.getLocaleValue('text.view_details', 'View Details'),
              weight: 300,
              cls: 'primary-font leading-normal font-normal text-base text-gray-700',
              icon: 'ti ti-file-description text-xl',
              onItem: (event: any): any => {
                const jobDetails = event?.record?.originalData;
                if (jobDetails?.id) {
                  this.openJobPreviewDrawer(jobDetails?.id, 'grid');
                  this._dispatchBoardService.trackEvent('grid_job_preview');
                }
              }
            }
          },
          processItems: (event: any): any => {
            const items: any = event.items;
            if (this.selectedGridTab == 'JOBS') {
              const jobDetails = event.record?.['originalData'];
              if (jobDetails?.showShimmer) {
                return false;
              }
              items.viewRouteDetails.hidden = true;
              items.viewJobDetails.hidden = false;
            }
            else if (this.selectedGridTab == 'ROUTES') {
              const routeDetails = event.record.data;
              if (routeDetails?.showShimmer) {
                return false;
              }
              items.viewRouteDetails.hidden = false;
              items.viewJobDetails.hidden = true;
            } 
          }
        }
      },
      onCellClick: (row: any): any => {
        this.gridOnCellClickToastRef?.close();
        const detailsType = row?.record.data.detailsType;
        if (detailsType === 'job') {
          if (!this.metaData?.map.layers.jobs) {
            return;
          }
          const jobDetails = row?.record?.data;
          if (jobDetails?.id) {
            if (jobDetails?.routeDetails?.isRouteJob) {
              if (this.moduleAccess.map && this.metaData?.map?.enable_map_view) {
                this.gridOnCellClickToastRef = this._toastService.warning(this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.error.associated_with_route', 'Click on Associated Route for Job Location'));
              }
              else {
                this.openJobPreviewDrawer(jobDetails?.id, 'grid');
                this._dispatchBoardService.trackEvent('grid_job_preview');
              }
            }
            else {
              if (this.moduleAccess?.map && this.metaData?.map?.enable_map_view) {
                if (this._utilityService.isValidGeoCords(jobDetails?.customer_address?.geo_cordinates)) {
                  this._mapService.showOnMap.next({ module: 'JOBS', eventUid: jobDetails?.id });
                }
                else {
                  this.gridOnCellClickToastRef = this._toastService.error(this._utilityService.getLocaleValue('dataPicker.job.geo_coordinates.alert_text', 'Geo Co-ordinates not found for this job'));
                }
              }
              else {
                this.openJobPreviewDrawer(jobDetails?.id, 'grid');
                this._dispatchBoardService.trackEvent('grid_job_preview');
              }
            }
          }
        }
        else if (detailsType === 'route') {
          if (!this.metaData?.map.layers.routes) {
            return;
          }
          const routeDetails = row?.record?.data;
          if (this.moduleAccess?.map && this.metaData?.map?.enable_map_view) {
            if (routeDetails?.id) {
              this._mapService.showOnMap.next({ module: 'ROUTES', eventUid: routeDetails?.id });
            }
          }
          else {
            if (routeDetails?.id) {
              this.openRoutePreviewDrawer(routeDetails?.id, 'grid');
              this._dispatchBoardService.trackEvent('grid_route_preview');
            }
          }
        }
        else if (detailsType === 'recurringRoute') {
          const rrDetails = row?.record?.data;
          const routeUid = rrDetails?.recurring_route_uid;
          if (routeUid) {
            this._dispatchBoardService.trackEvent('grid_recurring_route_preview');
            this.openRecurringRoutePreview(routeUid, rrDetails);
          }
        }
      }
    };
    this.updateTableColumns();
  }

  updateTableColumns(): void {
    this.updateMetaData();
    this.suspendAllGridEvents();
    if (this.metaData) {
      let tableView: any;
      if (this.selectedGridTab === 'JOBS') {
        tableView = this.metaData?.grid.table_view;
      }
      else if (this.selectedGridTab === 'ROUTES') {
        tableView = this.metaData?.grid.route_table_view;
      }
      this.tableConfig.columns = [];
      this.tableConfig.columns = tableView.map((column: any): Partial<GridColumnConfig> => (
        {
          field: column.key,
          text: column?.displayKeyValue || column.label,
          htmlEncode: false,
          sortable: Object.keys(this.gridSortableColumns).includes(column.key),
          editor: false,
          draggable: false,
          width: 200,
          renderer: (record: any): string => {
            if (record.record.data?.showShimmer) {
              return this.templateService.getTableShimmer();
            }
            else {
              return this.tableViewRendererMap(column)(record);
            }
          }
        }
      ));
    }
    if (this.tableViewInstance?.columns) {
      this.tableViewInstance.columns.removeAll();
      this.tableViewInstance.columns = this.tableConfig.columns;
    }
    this.resumeAllGridEvents();
  }

  updateTableContent(jobs: any[]): void {
    this.suspendAllGridEvents();
    let tableData = [];
    if (this.metaData) {
      let tableView: any;
      if (this.selectedGridTab === 'JOBS') {
        tableView = this.metaData?.grid.table_view;
      }
      else if (this.selectedGridTab === 'ROUTES') {
        tableView = this.metaData?.grid.route_table_view;
      }
      let customRow = {};
      if (!jobs?.[0]?.showShimmer) {
        jobs?.forEach((job: any) => {
          customRow = this._dispatchBoardService.formatEventDetails(tableView, job, { isRecurringRoute: this.selectedGridTab === 'ROUTES' && this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES' });
          tableData.push(customRow);
        });
      }
      else {
        tableData = jobs;
      }
      this.tableData = tableData;
      this.resumeAllGridEvents();
    }
  }

  tableViewRendererMap(column: any): any {
    const key = column?.group_uid;
    const isDefaultField = column?.isDefaultField;
    if (isDefaultField) {
      return this.templateService.getTableDefaultFieldColumn('routes', key, column);
    }
    else {
      const fieldType = column?.field_type;
      return this.templateService.getTableCustomFieldColumn(fieldType, column);
    }
  }

  initiateGridShimmer(count: number): any[] {
    return Array(count).fill({ showShimmer: true });
  }

  onToggleGridTab(selectedTab: 'JOBS' | 'ROUTES'): void {
    if (selectedTab !== this.selectedGridTab) {
      this.selectedGridTab = selectedTab;
      this.openGridSearch = false;
      this.gridSortTippyProps.offset = selectedTab === 'JOBS' ? [80, 10] : [40, 0];
      this.updateGridData();
      this.setGridEmptyText();
      this.initiateDragHelper(this.gridViewType);
      this._dispatchBoardService.trackEvent('grid_' + selectedTab);
    }
  }

  updateGridData(loadAllData: boolean = false, refreshParam: boolean = true, forceUpdate: boolean = false, selectedTab?: 'JOBS' | 'ROUTES'): Promise<boolean> {
    return new Promise(async (reoslve) => {
      if (refreshParam) {
        this.updateGridParams('JOBS');
        this.updateGridParams('ROUTES');
        this.updateGridParams('RECURRING_ROUTES');
      }
      if (loadAllData) {
        await this.getGridData(refreshParam);
        await this.getRouteData(refreshParam);
        this.injectGridDataIntoView();
        reoslve(true);
      }
      else {
        const skipKeys = ['populate_route', 'filter_rules'];
        const oldGridFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.gridViewParamData.JOBS?.filter_rules) || [];
        const newGridFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.gridParam?.filter_rules) || [];
        const oldRouteGridFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.gridViewParamData.ROUTES?.filter_rules) || [];
        const newRouteGridFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.routeParam?.filter_rules) || [];
        const isGridFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(oldGridFilter, newGridFilter);
        const isRouteGridFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(oldRouteGridFilter, newRouteGridFilter);
        const isJobParamChanged = !this._sharedService.isEqualObjects(this.gridParam, this.gridViewParamData.JOBS, skipKeys);
        const isRouteParamChanged = !this._sharedService.isEqualObjects(this.routeParam, this.gridViewParamData.ROUTES, skipKeys);
        if (this.selectedGridTab === 'JOBS' || selectedTab === 'JOBS') {
          if (isGridFilterRuleChanged || isJobParamChanged || Object.keys(this.gridViewParamData.JOBS).length <= 0 || forceUpdate) {
            await this.getGridData(refreshParam);
          }
          else {
            reoslve(false);
          }
        } else if (this.selectedGridTab === 'ROUTES' || selectedTab === 'ROUTES') {
          if (this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
            if (!this._sharedService.isEqualObjects(this.recurringRouteParam, this.gridViewParamData.RECURRING_ROUTES) || Object.keys(this.gridViewParamData.RECURRING_ROUTES).length <= 0 || forceUpdate) {
              await this.getRouteData(refreshParam);
            }
            else {
              reoslve(false);
            }
          }
          else {
            if (isRouteGridFilterRuleChanged || isRouteParamChanged || Object.keys(this.gridViewParamData.ROUTES).length <= 0 || forceUpdate) {
              await this.getRouteData(refreshParam);
            }
            else {
              reoslve(false);
            }
          }
        }
        this.injectGridDataIntoView();
        this.updateFilterCount();
        reoslve(true);
      }
    });
  }

  injectGridDataIntoView(data?: any): void {
    this.setGridSchedulerInstance();
    this.suspendAllGridEvents();
    if (this.selectedGridTab === 'JOBS') {
      if (data) {
        data = data.map((_data: any) => ({ ...this._dataCollectorService, id: _data.job_uid, detailsType: 'job' }));
      }
      if (this.gridViewType === 'listView') {
        this.routeCardData = data || this.gridData.JOBS;
        this.cardViewInstance?.renderRows();
      }
      else if (this.gridViewType === 'tableView') {
        this.updateTableColumns();
        this.updateTableContent(data || this.gridData.JOBS);
      }
    }
    else if (this.selectedGridTab === 'ROUTES') {
      if (data) {
        data = data.map((_data: any) => ({ ...this._dataCollectorService, id: _data.route_uid, detailsType: 'route' }));
      }
      if (this.gridViewType === 'listView') {
        this.routeCardData = data || this.gridData.ROUTES;
        this.cardViewInstance?.renderRows();
      }
      else if (this.gridViewType === 'tableView') {
        this.updateTableColumns();
        this.updateTableContent(data || this.gridData.ROUTES);
      }
    }
    this.resumeAllGridEvents();
  }

  toggleGridSearch(): void {
    this.openGridSearch = !this.openGridSearch;
    if (this.openGridSearch) {
      this._dispatchBoardService.trackEvent('grid_' + this.selectedGridTab.toLowerCase() + '_search');
    }
  }

  updateDispatchRouteSplitSettings(): void {
    const tablePosition = this.metaData?.grid.table_grid_position;
    if (this.gridViewType === 'tableView') {
      this.dispatchRouteSplitSettings.grid.order = tablePosition === 'LEFT' ? 1 : 2;
      this.dispatchRouteSplitSettings.scheduler.order = tablePosition === 'LEFT' ? 2 : 1;
      this.dispatchRouteSplitSettings.orientation = tablePosition === 'LEFT' ? 'horizontal' : 'vertical';
    }
    if (this.gridViewType === 'tableView' && tablePosition === 'BOTTOM') {
      this.dispatchRouteSplitSettings.grid.size = 50;
      this.dispatchRouteSplitSettings.grid.minSize = 40;
      this.dispatchRouteSplitSettings.grid.maxSize = 60;
    } else {
      this.dispatchRouteSplitSettings.grid.order = 1;
      this.dispatchRouteSplitSettings.scheduler.order = 2;
      this.dispatchRouteSplitSettings.orientation = 'horizontal';
      this.dispatchRouteSplitSettings.grid.size = this.isMapViewEnabled ? 28 : 23;
      this.dispatchRouteSplitSettings.grid.minSize = this.isMapViewEnabled ? 25 : 20;
      this.dispatchRouteSplitSettings.grid.maxSize = this.isMapViewEnabled ? 33 : 28;
    }
    this.dispatchRouteSplitSettings.scheduler.size = 100 - this.dispatchRouteSplitSettings.grid.size;
    if (this.gridViewType === 'tableView' && this.metaData?.grid.table_grid_position === 'BOTTOM') {
      this.dispatchRouteSplitSettings.minSize = 45;
      this.dispatchRouteSplitSettings.maxSize = 75;
      this.dispatchRouteSplitSettings.map.maxSize = 50;
      this.dispatchRouteSplitSettings.map.minSize = 25;
    } else {
      this.dispatchRouteSplitSettings.minSize = 70;
      this.dispatchRouteSplitSettings.maxSize = 80;
    }
    this.showSchedulerPlanningNavTab = this.selectedRouteTab === 'PLANNING' && this.selectedPlanningTab === 'SCHEDULE';
    this.dispatchRouteSplitSettings.grid.size = Math.max(this.dispatchRouteSplitSettings.grid.minSize, Math.min(this.dispatchRouteSplitSettings.grid.size, this.dispatchRouteSplitSettings.grid.maxSize));
    this.dispatchRouteSplitSettings.scheduler.size = 100 - this.dispatchRouteSplitSettings.grid.size;
  }

  updateSplitVisibility(gutterIndex: number, position: 'left' | 'right') {
    const toggleState = this.dispatchRouteSplitSettings.gutter.toggleState;
    const mapSettings = this.dispatchRouteSplitSettings.map;
    const schedulerSettings = this.dispatchRouteSplitSettings.scheduler;
    const gridSettings = this.dispatchRouteSplitSettings.grid;

    const setMapSettings = (size: number, maxSize: number, minSize: number, visible: boolean) => {
      mapSettings.size = size;
      mapSettings.maxSize = maxSize;
      mapSettings.minSize = minSize;
      this.dispatchRouteSplitSettings.visible.map = visible;
      this.triggerMapResize();
    };

    const setSchedulerSettings = (size: number, maxSize: number, minSize: number, visible: boolean) => {
      schedulerSettings.size = size;
      schedulerSettings.maxSize = maxSize;
      schedulerSettings.minSize = minSize;
      this.dispatchRouteSplitSettings.visible.scheduler = visible;
    };

    switch (toggleState[gutterIndex]) {
      case 'left':
        if (position === 'right') {
          toggleState[gutterIndex] = 'neutral';
          setMapSettings(25, 30, 15, true);
          setSchedulerSettings(100 - gridSettings.size, 100 - gridSettings.minSize, 100 - gridSettings.maxSize, true);
        }
        break;
      case 'neutral':
        if (position === 'left') {
          toggleState[gutterIndex] = position;
          setMapSettings(80, 80, 70, true);
          setSchedulerSettings(0, 0, 0, false);
        } else if (position === 'right') {
          toggleState[gutterIndex] = position;
          setMapSettings(0, 0, 0, false);
        }
        break;
      case 'right':
        if (position === 'left') {
          toggleState[gutterIndex] = 'neutral';
          setMapSettings(25, 30, 15, true);
          setSchedulerSettings(100 - gridSettings.size, 100 - gridSettings.minSize, 100 - gridSettings.maxSize, true);
        }
        break;
    }

    if (this.gridViewType === 'tableView' && this.metaData?.grid.table_grid_position === 'BOTTOM') {
      this.dispatchRouteSplitSettings.minSize = 45;
      this.dispatchRouteSplitSettings.maxSize = 75;
      mapSettings.maxSize = 50;
      mapSettings.minSize = 25;
      setSchedulerSettings(50, 55, 45, true);
    } else {
      this.dispatchRouteSplitSettings.minSize = 70;
      this.dispatchRouteSplitSettings.maxSize = 80;
    }

    if (this.dispatchRouteSplitSettings.visible.scheduler) {
      if (this.gridViewType === 'tableView' && this.metaData?.grid.table_grid_position === 'BOTTOM') {
        gridSettings.size = 50;
        gridSettings.minSize = 40;
        gridSettings.maxSize = 60;
      }
      else {
        gridSettings.size = toggleState[gutterIndex] === 'neutral' ? 30 : 22;
        gridSettings.minSize = toggleState[gutterIndex] === 'neutral' ? 25 : 18;
        gridSettings.maxSize = toggleState[gutterIndex] === 'neutral' ? 35 : 25;
      }
      setSchedulerSettings(100 - gridSettings.size, 100 - gridSettings.minSize, 100 - gridSettings.maxSize, true);
    } else {
      setSchedulerSettings(0, 0, 0, false);
      gridSettings.size = 100;
      gridSettings.minSize = 0;
      gridSettings.maxSize = 100;
    }

    this.dispatchRouteSplitSettings.size = 100 - mapSettings.size;
    this.dispatchRouteSplitSettings.maxSize = 100 - mapSettings.minSize;
    this.dispatchRouteSplitSettings.minSize = 100 - mapSettings.maxSize;
  }

  resetSplitVisibility(gutterIndex: number): void {
    const toggleState = this.dispatchRouteSplitSettings.gutter.toggleState;
    if (toggleState[gutterIndex] === 'left') {
      this.updateSplitVisibility(gutterIndex, 'right');
    }
    else if (toggleState[gutterIndex] === 'right') {
      this.updateSplitVisibility(gutterIndex, 'left');
    }
  }
  
  triggerMapResize(): void {
    if (this.mapResizeTimeout) {
      cancelAnimationFrame(this.mapResizeTimeout);
    }
    this.mapResizeTimeout = requestAnimationFrame(() => {
      this._mapService.mapResizeIndicator.next(true);
    });
  }

  initiateTableSortEventListener(): void {
    const _this = this;
    _this.tableViewInstance?.store.addListener({
      beforeSort({ sorters }) {
        _this.tableViewInstance.store.removeAll();
        _this.gridTbarData[_this.selectedGridTab].sortOptions.sort = sorters[0]['ascending'] === true ? 'ASC' : 'DESC';
        _this.gridTbarData[_this.selectedGridTab].sortOptions.sort_by = _this.gridSortableColumns[sorters[0]['field']];
        _this.gridBbarData[_this.selectedGridTab].gridPageNumber = 1;
        _this.updateGridData();
      }
    });
  }

  getGridTemplateType(): TemplateType {
    let gridTemplateType: TemplateType;
    if (this.gridViewType === 'tableView') {
      gridTemplateType = 'tableProxy';
    }
    else if (this.gridViewType === 'listView') {
      if (this.selectedGridTab === 'JOBS') {
        gridTemplateType = 'jobGridCard';
      }
      else if (this.selectedGridTab === 'ROUTES') {
        gridTemplateType = 'routeGridCard';
      }
    }
    return gridTemplateType;
  }

  createDragerInstance(dragConfig: Partial<DragHelperConfig>): DragHelper {
    return new DragHelper(dragConfig);
  }

  initiateDragHelper(viewType: any): any {
    this.dragInstance?.destroy();
    let targetSelector: any;
    if (viewType === 'tableView') {
      targetSelector = '#route-table-view';
    }
    else if (viewType === 'listView') {
      targetSelector = '#route-card-view';
      if (this.selectedGridTab === 'JOBS') {
      }
      else if (this.selectedGridTab === 'ROUTES') {
      }
    }
    targetSelector += ' .b-grid-row:not(.b-group-row)';
    const blockDrag: boolean = this.selectedGridTab === 'JOBS' ? (!this.permissions.updateJobAssignment || !(this.permissions.scheduleJob || this.permissions.rescheduleJob)) : (!this.permissions.updateRouteAssignment || !this.permissions.updateRoute);
    this.dragConfig = {
      cloneTarget: true,
      autoSizeClonedTarget: false,
      mode: 'translateXY',
      dropTargetSelector: '.b-timeline-subgrid',
      targetSelector: targetSelector,
      lockX: blockDrag,
      lockY: blockDrag,
      createProxy: (element: any): any => {
        const proxy = document.createElement('div');
        const record = this.gridViewInstance?.getRecordFromElement(element);
        const getGridTemplateType = this.getGridTemplateType();
        const event = record?.data;
        if (this.selectedGridTab === 'JOBS') {
          if (!this.permissions.updateJobAssignment || !(this.permissions.scheduleJob || this.permissions.rescheduleJob)) {
            return proxy;
          }
        }
        else if (this.selectedGridTab === 'ROUTES') {
          const isRouteLocked = event?.is_locked;
          if (!this.permissions.updateRouteAssignment || !this.permissions.updateRoute || isRouteLocked) {
            return proxy;
          }
        }
        let id = '';
        if (getGridTemplateType !== 'tableProxy') {
          if (this.selectedGridTab === 'JOBS') {
            id = event.job_uid;
          }
          else if (this.selectedGridTab === 'ROUTES') {
            id = event.route_uid;
          }
        }
        proxy.style.maxWidth = '400px';
        this._dispatchBoardService.setTableProxyRecords(event);
        proxy.innerHTML = this.templateService.getJobRendererTemplate('routes', getGridTemplateType, id, null, { selectedGridTab: this.selectedGridTab });
        return proxy;
      }
    };
    this.dragInstance = this.createDragerInstance(this.dragConfig);
    if (blockDrag) {
      this.dragInstance.removeAllListeners();
      return;
    }
    //Drag from grid to scheduler
    this.dragInstance.on({
      beforeDragStart: (event: any) => {
        this.setGridSchedulerInstance();
        const context = event.context;
        const task = this.gridViewInstance?.getRecordFromElement(context.element);
        const eventDetails = task?.data;
        if (this.selectedGridTab === 'ROUTES' && eventDetails && eventDetails?.detailsType === 'route') {
          const isRouteLocked = eventDetails?.is_locked || eventDetails?.routeDetails?.isLocked;
          if (isRouteLocked) {
            this.routeLockedMsgToastRef?.close();
            this.routeLockedMsgToastRef = this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.lock_confirmation.dialog_alert'));
          }
          return !isRouteLocked;
        }
        if (this.selectedGridTab === 'JOBS' && eventDetails?.current_job_status?.status_type === 'CLOSED') {
          this.closedJobScheduleErrorToastRef?.close();
          event.context.valid = false;
          this.closedJobScheduleErrorToastRef = this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.error.job_status_closed', 'This job is closed and can’t be updated'));
          return false;
        }
      },
      dragstart: (event: any) => {
        const context = event.context;
        this.schedulerInstance.features.eventTooltip.disabled = true;
        this.schedulerInstance.features.cellTooltip.disabled = true;
        let task: any;
        if (this.gridViewInstance && context) {
          task = event?.context?.task || this.gridViewInstance?.getRecordFromElement(context.grabbed);
          context.task = task;
        }
      },

      drag: _.debounce((event: any) => {
        const context = event.context;
        const routeDetails: any = this.schedulerInstance?.resolveEventRecord(context.target.closest('.b-nested-events-parent'));
        const isDropOnValidParent = context.target && routeDetails && !routeDetails?.is_locked;
        if (context.task.data.detailsType === 'job') {
          if (context.valid && !isDropOnValidParent) {
            context.element.firstChild.classList.remove('bg-white');
            context.element.firstChild.classList.add('bg-red-100');
            if (routeDetails?.is_locked) {
              event.event.target.classList.add('cursor-not-allowed');
            }
          }
          else if (isDropOnValidParent) {
            context.element.firstChild.classList.remove('bg-red-100');
            context.element.firstChild.classList.add('bg-white');
            event.event.target.classList.remove('cursor-not-allowed');
          }
          context.isDropOnParent = isDropOnValidParent;
          context.dropParentDetails = routeDetails;
        }
        if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
          const date = this.schedulerInstance?.getDateFromCoordinate(context.clientX, 'round', false);
          const resource = context.target && this.schedulerInstance?.resolveResourceRecord(context.target);
          context.valid = context.valid && (date && resource);
          context.resource = resource;
          context.date = date;
        }
      }, 100, { leading: true }),

      drop: (event: any) => {
        const context = event.context;
        const eventDetails = context.task.data;
        const detailsType: 'job' | 'route' = context.task.data.detailsType;
        let hasPermission: boolean = false;
        const task = context.task;
        const resouce = context.resource;
        let jobDetails = task?.originalData;
        const userDetails = resouce?.data;
        const dropDateTime = this.schedulerInstance?.getDateFromCoordinate(event.event.clientX, 'round', false);
        this.schedulerInstance.features.eventTooltip.disabled = false;
        this.schedulerInstance.features.cellTooltip.disabled = false;
        if (this.gridViewType === 'tableView') {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          jobDetails = _.find(this._dispatchBoardService.getGridRecords(), { 'job_uid': jobDetails?.id });
        }

        if (detailsType === 'job' && context.valid) {
          if (context.valid) {
            context.async = true;
          }
          if (context.valid && !context.isDropOnParent) {
            context.finalize(false);
          }
          if (context.valid) {
            context.finalize(true);
          }
          event.event.target.classList.remove('cursor-not-allowed');
          if (this.gridViewType === 'tableView') {
            const tableJobUid = task?.data.id;
            // eslint-disable-next-line @typescript-eslint/naming-convention
            jobDetails = _.find(this.gridData[this.selectedGridTab], { 'job_uid': tableJobUid });
          }

          if (context.isDropOnParent) {
            const jobUid = jobDetails?.job_uid;
            const jobGeoCords: any[] = jobDetails?.customer_address?.geo_cordinates || null;
            if (jobGeoCords && jobGeoCords.length === 2 && jobUid) {
              const droppedParentRoute = context.dropParentDetails.data;
              const routeUid = droppedParentRoute?.route_uid;
              let openRescheduleDialog: boolean = true;
              let scheduledStartTime = jobDetails?.scheduled_start_time;
              let scheduledEndTime = jobDetails?.scheduled_end_time;
              if (!this._utilityService.isEmptyOrUndefined(scheduledStartTime) && !this._utilityService.isEmptyOrUndefined(scheduledEndTime)) {
                scheduledStartTime = moment(scheduledStartTime);
                scheduledEndTime = moment(scheduledEndTime);
                hasPermission = this.permissions.updateJobAssignment && this.permissions.rescheduleJob;
                openRescheduleDialog = !this._dispatchBoardService.isJobScheduledWithInRouteDuration(droppedParentRoute, jobDetails);
              }
              else {
                hasPermission = this.permissions.updateJobAssignment && this.permissions.scheduleJob;
              }
              if (openRescheduleDialog && context.valid) {
                if (hasPermission) {
                  this._dispatchBoardService.trackEvent('grid_drag_and_drop_job');
                  this._sdkEventService
                    .openCustomWithPreEventListener(RescheduleJobComponent, {
                      dialogId: 'dispatch_board.job_reschedule',
                      data: {
                        holidays: this.holidays,
                        userDetails: userDetails,
                        jobDetails: jobDetails,
                        dropDateTime: dropDateTime,
                        customUserDetails: this.customUserDetails,
                        teamUid: this.selectedTeam,
                        routeDetails: droppedParentRoute,
                        targetRouteDetails: droppedParentRoute,
                        checkRouteJobConflict: true,
                        checkRouteDurationExceed: true,
                      },
                      extraClass: 'w-fit',
                    }, {
                      ...jobDetails, dispatch_details: {
                        user_details: userDetails,
                        drop_date_time: moment(dropDateTime).format('YYYY-MM-DD HH:mm:ss'),
                        route_details: droppedParentRoute,
                        selected_team: {
                          team_uid: this.selectedTeam,
                          team_name: this.getTeamName(this.selectedTeam)
                        }
                      }
                    })
                    .then(
                      (
                        rescheduleDialogInstance: MatDialogRef<RescheduleJobComponent> | null
                      ) => {
                        rescheduleDialogInstance
                          ?.afterClosed()
                          .subscribe((dialogData: any) => {
                            if (dialogData) {
                              if (!dialogData?.skipAssignJobToRoute) {
                                const assignRouteJobParam = {
                                  jobs: [
                                    // eslint-disable-next-line @typescript-eslint/naming-convention
                                    { job_uid: jobUid, geo_cords: jobGeoCords },
                                  ],
                                };
                                this._dispatchBoardService.assignRouteJob(
                                  routeUid,
                                  assignRouteJobParam,
                                  (status: boolean) => {
                                    if (status) {
                                      jobDetails =
                                        this.assignJobToRouteAssignees(
                                          jobDetails,
                                          droppedParentRoute
                                        );
                                      this._dispatchBoardService.trackEvent([
                                        'drag_drop_job_user',
                                        'drag_drop_job_reschedule',
                                      ]);
                                      this.updateGridJobRecords(
                                        jobDetails,
                                        task
                                      );
                                      this.getSchedulerData(true, false);
                                    }
                                  }
                                );
                              }
                            }
                          });
                      }
                    );
                }
                else {
                  this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.permission.error', 'You don\'t have permission to perform this action'));
                }
              }
              else if (!openRescheduleDialog && context.valid) {
                if (hasPermission) {
                  const userUid = userDetails?.user_uid;
                  const teamUid = this.selectedTeam;
                  const startDateTime = scheduledStartTime;
                  const endDateTime = scheduledEndTime;
                  const warnings: any[] = this._dispatchBoardService.getScheduleWarningMsg('job', jobDetails, userDetails, startDateTime, endDateTime, this.customUserDetails, true);
                  const openJobAssignConfirmationDialog = Object.values(warnings).filter((warning: any) => warning.show).length > 0;
                  let jobAssignConfirmation: any;

                  //Open confirmation dialog with warnings
                  if (openJobAssignConfirmationDialog) {
                    jobAssignConfirmation = this._dispatchBoardService.scheduleConfirmationDialog('job', jobDetails, warnings);
                    jobAssignConfirmation?.afterClosed()
                      .subscribe((_result: boolean) => {
                        if (_result) {
                          this._dispatchBoardService.assignJob(jobUid, userUid, teamUid, (status: boolean) => {
                            if (status) {
                              const assignRouteJobParam = {
                                jobs: [
                                  // eslint-disable-next-line @typescript-eslint/naming-convention
                                  { job_uid: jobUid, geo_cords: jobGeoCords }
                                ]
                              };
                              this._dispatchBoardService.assignRouteJob(routeUid, assignRouteJobParam, (_status: boolean) => {
                                if (_status) {
                                  jobDetails = this.assignJobToRouteAssignees(jobDetails, droppedParentRoute);
                                  this.updateGridJobRecords(jobDetails, task);
                                  this._dispatchBoardService.trackEvent('drag_drop_job_user');
                                  this.getSchedulerData(true, false);
                                }
                              });
                            }
                          });
                        }
                      });
                  }
                  else {
                    this._dispatchBoardService.assignJob(jobUid, userUid, teamUid, (status: boolean) => {
                      if (status) {
                        if (['UNSCHEDULED', 'UNASSIGNED'].includes(this.getGridJobType())) {
                          this.gridData[this.selectedGridTab] = this.gridData[this.selectedGridTab].filter((job: any) => job.job_uid !== jobUid);
                          this.removeEventFromGrid(task);
                        }
                        const assignRouteJobParam = {
                          jobs: [
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            { job_uid: jobUid, geo_cords: jobGeoCords }
                          ]
                        };
                        this._dispatchBoardService.assignRouteJob(routeUid, assignRouteJobParam, (_status: boolean) => {
                          if (_status) {
                            jobDetails = this.assignJobToRouteAssignees(jobDetails, droppedParentRoute);
                            this.updateGridJobRecords(jobDetails, task);
                            this._dispatchBoardService.trackEvent('drag_drop_job_user');
                            this.getSchedulerData(true, false);
                          }
                        });
                      }
                    });
                  }
                }
                else {
                  this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.permission.error', 'You don\'t have permission to perform this action'));
                }
              }
            }
            else {
              this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.error.geo_cords_not_found', 'Geo co-ordinates not found for the job'));
            }
          }
        }
        else if (detailsType === 'route' && context.valid) {
          let routeDetails = _.cloneDeep(eventDetails);
          this._dispatchBoardService.trackEvent('grid_drag_and_drop_route');
          if (this.gridViewType === 'tableView') {
            const tableRouteUid = task?.data.id;
            // eslint-disable-next-line @typescript-eslint/naming-convention
            routeDetails = _.find(this.gridData[this.selectedGridTab], { 'route_uid': tableRouteUid });
          }
          const startDateTime = moment(dropDateTime).toISOString();
          const endDateTime = moment(dropDateTime).add(eventDetails?.duration || 1, 'h').toISOString();
          const routeDuration = eventDetails?.duration || 1;
          const rescheduleRouteDialogInstance = this._zuperDialogService.openCustom(RescheduleRouteComponent,
            {
              data:
              {
                routeDetails: routeDetails,
                userDetails: userDetails,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                duration: routeDuration,
                customUserDetails: this.customUserDetails,
                showRescheduleSuccessToast: false
              },
              extraClass: 'route-schdule-dialog'
            });
          rescheduleRouteDialogInstance?.afterClosed()
            .subscribe((status: boolean) => {
              if (status) {
                const routeUid: string = routeDetails?.route_uid;
                const assignRouteUserDetails = {
                  users: [
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    { team_uid: this.selectedTeam, user_uid: userDetails?.user_uid }
                  ]
                };
                this._dispatchBoardService.trackEvent('drag_drop_route_reschedule');
                this._dispatchBoardService.assignRoute(routeUid, assignRouteUserDetails, true, (_status: boolean) => {
                  if (_status) {
                    this.getSchedulerData(true, false);
                    if (this.gridTbarData.ROUTES.type === 'UNASSIGNED') {
                      this.removeEventFromGrid(routeUid);
                    }
                    this.updateGridData(false, false, true);
                    this.gridData.ROUTES = this.gridData.ROUTES.filter((route: any) => route.route_uid !== routeUid);
                    this._dispatchBoardService.trackEvent('drag_drop_route_user');
                  }
                });
              }
              else {
                context.finalize(true);
              }
            });
        }
      },

      abort: (event: any) => {
        const eventDetails = event.context.task.data;
        event.context.target.classList.remove('cursor-not-allowed');
        this.schedulerInstance.features.eventTooltip.disabled = false;
        this.schedulerInstance.features.cellTooltip.disabled = false;
      }
    });
  }

  updateGridJobRecords(jobDetails: any, task: any): void {
    setTimeout(() => {
      const jobUid = jobDetails?.job_uid;
      if (['UNSCHEDULED', 'UNASSIGNED'].includes(this.getGridJobType())) {
        this.gridData[this.selectedGridTab] = this.gridData[this.selectedGridTab].filter((job: any) => job.job_uid !== jobUid);
        this.schedulerRoutes.push(jobDetails);
        this._dispatchBoardService.setSchedulerRecords(this.schedulerRoutes);
        this.removeEventFromGrid(task);
      }
    }, 100);
  }

  updateJobAssignment(jobDetails: any, userDetails: any, type: 'ASSIGN' | 'UNASSIGN'): any {
    let assignedTo: any[] = jobDetails?.assigned_to || [];
    if (type === 'UNASSIGN') {
      assignedTo = assignedTo.filter((assignee: any) => assignee.user.user_uid !== userDetails?.user_uid);
    }
    else if (type === 'ASSIGN') {
      const newUser = {
        user: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          user_uid: userDetails?.user_uid, first_name: userDetails?.first_name, last_name: userDetails?.last_name,
        },
        team: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          team_uid: this.selectedTeam
        }
      };
      const isUserAlreadyAssigned = assignedTo.filter((assignee: any) => assignee?.user.user_uid === userDetails?.user_uid).length > 0;
      if (!isUserAlreadyAssigned) {
        assignedTo.push(newUser);
      }
    }
    jobDetails.assigned_to = assignedTo;
    return jobDetails;
  }

  assignJobToRouteAssignees(jobDetails: any, routeDetails: any): any {
    routeDetails.assigned_to?.forEach((assignee: any) => {
      jobDetails = this.updateJobAssignment(jobDetails, assignee.user, 'ASSIGN');
    });
    return jobDetails;
  }

  getGridJobType(): string {
    return this.gridParam?.type;
  }

  removeEventFromGrid(task: any): void {
    this.gridViewInstance?.store.remove(task);
    const gridDataCount = this.gridViewInstance?.data.length || 0;
    if (gridDataCount === 0) {
      this.updateGridData(false, true, true);
    }
  }

  routeGridCardUserAssignEmitter(event: any): void {
    if (!event?.isConfirmed) {
      this.closeRouteGridAssignedToTippy();
    }
    else if (event.isConfirmed) {
      const newAssignedUsers = event?.users || [];
      const oldAssignedUsers = this.routeGridCardUserAssignTippyData.routeDetails?.assigned_to || [];
      const routeUid = this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES' ? this.routeGridCardUserAssignTippyData.routeDetails?.recurring_route_uid:  this.routeGridCardUserAssignTippyData.routeDetails?.route_uid;
      if(this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
        this.recurringRouteService.updateRecurringRouteUserAssignments(routeUid, oldAssignedUsers, newAssignedUsers, false, (completedStatus: any[])=> {
          this.afterRouteAssignmentUpdate(routeUid, completedStatus);
        });
      }
      else {
        this.recurringRouteService.updateRouteAssignments(routeUid, oldAssignedUsers, newAssignedUsers, false, (completedStatus: any[])=> {
          this.afterRouteAssignmentUpdate(routeUid, completedStatus);
        });
      }
      this.closeRouteGridAssignedToTippy();
    }
  }

  afterRouteAssignmentUpdate(routeUid: string, completedStatus: any[]): void {
    if (completedStatus.length) {
      this.updateGridData(false, false, true).then((status: boolean) => {
        if (status) {
          //Added timeout to wait until grid data updates
          setTimeout(()=> {
            const routeFromGrid = this.gridViewInstance?.store.getById(routeUid);
            if (routeFromGrid) {
              const scrollOptions: any = {
                highlight: true,
                animate: {
                  easing: 'easeFromTo',
                  duration: 500
                },
                extendTimeAxis: false
              };
              this.gridViewInstance?.scrollRowIntoView(routeFromGrid, scrollOptions);
            }
          }, 200);
        }
      });
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        const routePresetInScheduler = this.schedulerInstance?.eventStore.getById(routeUid);
        if (routePresetInScheduler) {
          this.getSchedulerData(true, false);
        }
      }
    }
  }

  closeRouteGridAssignedToTippy(updateNewRouteDetails: boolean = false): void {
    if (this.routeGridAssignedToTippyRef) {
      this.routeGridAssignedToTippyRef.hide();
    }
    this.routeGridAssignedToTippyRef = null;
    if (updateNewRouteDetails) {
      this.routeGridCardUserAssignTippyData.routeDetails = this.routeGridCardUserAssignTippyData.updatedRouteDetails;
      const routeDetails = this.routeGridCardUserAssignTippyData.routeDetails;
      if (routeDetails) {
        this.routeGridCardUserAssignTippyData.prefillUsers = routeDetails?.assigned_to;
      }
    }
    else {
      this.routeGridCardUserAssignTippyData.routeDetails = null;
      this.routeGridCardUserAssignTippyData.prefillUsers = [];
    }
  }

  //Scheduler
   getSchedulerData(forceUpdate: boolean = false, updateResource: boolean = true): void {
    if (this.selectedRouteTab === 'TRACKING') {
      this.schedulerParams['from_date'] = this.schedulerTbarForm.get('schedulerDate')?.value.format('YYYY-MM-DD');
      this.schedulerParams['to_date'] = this.schedulerTbarForm.get('schedulerDate')?.value.format('YYYY-MM-DD');
    }
    else if (this.selectedRouteTab === 'PLANNING') {
      this.schedulerParams['from_date'] = this.schedulerTbarForm.get('scheduleStartDate')?.value.format('YYYY-MM-DD');
      this.schedulerParams['to_date'] = this.schedulerTbarForm.get('scheduleEndDate')?.value.format('YYYY-MM-DD');
    }

    this.schedulerParams['populate_detailed_route'] = true;
    this.schedulerParams['populate_user_shift'] = true;
    this.schedulerDateIncrementBtnState('disable');
    this.currentDay = this.schedulerTbarForm.get('schedulerDate')?.value.format('dddd');
    this.schedulerParams['filter_rules'] = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.schedulerParams?.filter_rules || []); //Workaround untill API bug fix on keyword empty search
    this.schedulerParams['route_filter_rules'] = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.schedulerParams?.route_filter_rules || []);
    this.schedulerParams['use_color_profile'] = this.useColorProfile;
    const params: any = this.schedulerParams;
    const isSchedulerFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(this.schedulerParamData?.filter_rules || [], params?.filter_rules || []) || !this._dispatchBoardService.isSameFilterRule(this.schedulerParamData?.route_filter_rules || [], params?.route_filter_rules || []) || !this._sharedService.isEqualObjects(this.schedulerParamData, params);
    this.schedulerSearchKeyword = this._dispatchBoardService.getFilterValue('keyword', this.schedulerParams?.route_filter_rules);
    this.employeeSearchKeyword = this._dispatchBoardService.getFilterValue('keyword', this.schedulerParams?.employee_filter_rules);
    this.schedulerParams['filter.team_uid'] = this.selectedTeam || '';
    this.schedulerParams['timezone'] = this.selectedTimezone;
    this.updateSearchFilterValue('scheduler');
    if ((!isSchedulerFilterRuleChanged && !forceUpdate) || !this.schedulerParams['filter.team_uid']) {
      return;
    }
    if (updateResource && this.schedulerInstance) {
      this.schedulerInstance.resourceStore.removeAll();
      this.schedulerInstance.resourceStore.add(this.initiateGridShimmer(7));
    }
    this.schedulerParamData = _.cloneDeep(params);
    this._dataCollectorService.postData(this._dispatchBoardService.schedulerDataUrl, params)
      .subscribe({
        next: (schedulerResponse: any) => {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          this.suspendAllSchedulerEvents({ resource: true });
          this.resetEventSearch();
          this.schedulerData = schedulerResponse;
          this.constructSchedulerData(schedulerResponse, updateResource);
          this.drawOnMapDrawCreatedEvent({ type: 'delete' });
          this._dispatchBoardService.setRouteTabEmployeeRecords(this.schedulerEmployees);
          this.schedulerDateIncrementBtnState('enable');
          this.resumeAllSchedulerEvents({ resource: true });
          if (!this.isSchedulerInitialLoad && (this.schedulerFocusData.eventUid || this.schedulerFocusData.userUid)) {
            this.removeSchedulerEventLisners();
          }
          if (this.isSchedulerInitialLoad) {
            this.isSchedulerInitialLoad = false;
          }
        },
        error: () => {
          this.schedulerDateIncrementBtnState('enable');
          this.schedulerProConfig.events = this.schedulerRoutes;
          this.schedulerProConfig.resources = this.schedulerEmployees;
          this.schedulerProConfig.assignments = this.schedulerAssignments;
        }
      });
  }

  refreshScheduler(): void {
    requestAnimationFrame(() => {
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        this.schedulerInstance.resourceStore.refreshData();
        this.schedulerInstance.eventStore.refreshData();
      }
    });
  }

  commitFinalizedHandler = () => {
    if (this.schedulerFocusData.eventUid || this.schedulerFocusData.userUid) {
      this.applyQueryParams();
    }
    else {
      //Added more timeout to avoid tick issue for scheduler summary
      setTimeout(() => {
        this.toggleSchedulerSummary(this.metaData?.scheduler?.display?.job_summary ?? false)
      }, 2000)
      this.removeSchedulerEventLisners();
    }
  };

  setSchedulerEventLisners(): void {
    this.schedulerInstance.project.on('commitfinalized', this.commitFinalizedHandler);
  }

  removeSchedulerEventLisners(): void {
    this.schedulerFocusData.eventUid = null;
    this.schedulerFocusData.userUid = null;
    this.schedulerInstance.project.un('commitfinalized', this.commitFinalizedHandler);
  }

  constructSchedulerData(response: any, updateResource: boolean): void {
    this.customUserDetails = {};
    this.schedulerRoutes = [];
    this.schedulerJobs = [];
    this.schedulerAssignments = [];
    if (updateResource) {
      this.schedulerEmployees = [];
    }
    this.suspendAllSchedulerEvents({ event: true, resource: true });
    const routes = response.data?.routes?.map((ele: any) => ({
      ...ele, id: ele.route_uid, detailsType: 'route', jobs: _.compact(ele.jobs.map((routeJob: any) => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const jobDetails = _.find(response.data?.jobs, { 'job_uid': routeJob?.job_uid });
        if (jobDetails) {
          jobDetails.distance = routeJob?.distance || 0;
          jobDetails.sequence = routeJob?.sequence;
          jobDetails.time = routeJob?.time || 0;
          // eslint-disable-next-line @typescript-eslint/naming-convention
          jobDetails.route = { route_uid: ele.route_uid, route_name: ele.route_name };
        }
        return { ...routeJob, job: jobDetails };
      }))
    }));
    this.updateFilterCount();
    routes?.forEach((routeDetails: any) => {
      let assignments: any[] = [];
      [routeDetails, assignments] = this.formatRouteJobDetails(routeDetails);
      this.schedulerRoutes.push(routeDetails);
      this.schedulerJobs.push(...routeDetails?.children);
      this.schedulerAssignments.push(...assignments);
    });
    const users = response.data?.users;
    this.userSortData.skillSubMenu.skillList = [];
    const userSkillsMap = new Map<string, any>();
    users?.forEach((user: any) => {
      if (!user?.user_uid) {
        return;
      }
      user.name = user.first_name + ' ' + user.last_name;
      user.role_name = user.role?.role_name || '';
      if (user.profile_picture && this._utilityService.hasValidProfilePicture(user.profile_picture)) {
        user.imageUrl = user.profile_picture;
      }
      else {
        user.image = false;
        user.eventColor = 'indigo';
      }
      user.role_name = user.role.role_name;
      user.id = user?.user_uid;
      this.schedulerEmployees.push(user);
      user.skills = [];
      user?.user_skills?.forEach((skill: any) => {
        const skillsetUid = skill?.skillsets?.skillset_uid;
        user.skills.push({ id: skillsetUid, percentage: skill?.skill_level || 0 });
        if (!userSkillsMap.has(skillsetUid)) {
          userSkillsMap.set(skillsetUid, { ...skill, ...skill?.skillsets, selected: this.userSortData.selectedSkill === skillsetUid });
        }
      });
    });
    this.schedulerEmployees = this.schedulerEmployees.sort((userOne: any, userTwo: any) => {
      return userOne?.name.localeCompare(userTwo?.name);
    });
    this.userSortData.skillSubMenu.skillList = Array.from(userSkillsMap.values());
    this.userSortData.skillSubMenu.filteredSkillset = [...this.userSortData.skillSubMenu.skillList];
    if (this.sortOptions.user.sort_by === 'skill' && !userSkillsMap.get(this.userSortData.selectedSkill)) {
      this.resetUserSortSkill();
    }
    this.schedulerAssignments = _.uniqBy(this.schedulerAssignments, 'id');
    this.updateMapRouteFilter();
    setTimeout(() => {
      this._dispatchBoardService.injectJobLocationMapData('ROUTES', 'schedulerJob', this.metaData, this.schedulerJobs);
      this._dispatchBoardService.setResourceTimeoff(this.schedulerInstance, this.schedulerEmployees);
      this._dispatchBoardService.setResourceShift(this.schedulerInstance, this.schedulerEmployees, this.currentView);
      this.getEmployeeLocationData(users?.length);
      this.customUserDetails = this._dispatchBoardService.getCustomEmployeeDetailsLocal(startDate, endDate, users, routes);
    });
    const startDate = moment(this.schedulerParams?.from_date, 'YYYY-MM-DD').startOf('day');
    const endDate = moment(this.schedulerParams?.to_date, 'YYYY-MM-DD').endOf('day');
    this._dispatchBoardService.setSchedulerRoutesRecords(this.schedulerRoutes);
    if (updateResource) {
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        this.schedulerInstance.resourceStore.removeAll();
      }
    }
    this.schedulerInstance.eventStore.removeAll();
    this.schedulerInstance.assignmentStore.removeAll();
    this.schedulerInstance.resourceTimeRangeStore.removeAll();
    this.schedulerProConfig.events = this.schedulerRoutes;
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      this.schedulerInstance.eventStore.add(this.schedulerRoutes);
    }
    if (updateResource) {
      this.schedulerProConfig.resources = this.schedulerEmployees;
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        this.schedulerInstance.resourceStore.add(this.schedulerEmployees);
        this.sortSchedulerResources();
      }
    }
    else {
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        const _schedulerEmployee = this.schedulerEmployees.reduce((acc, userDetails) => {
          acc[userDetails?.id] = userDetails;
          return acc;
        }, {});
        this.schedulerInstance.resourceStore.forEach((resource: any) => {
          const updatedUserDetails = _schedulerEmployee[resource?.id];
          if (updatedUserDetails) {
            resource.set(updatedUserDetails, true);
          }
        })
      }
    }
    this.schedulerInstance.assignmentStore.add(this.schedulerAssignments);
    this.schedulerProConfig.assignments = this.schedulerAssignments;
    this.resumeAllSchedulerEvents({ event: true, resource: true });
  }

  formatRouteJobDetails(routeDetails: any): any[] {
    const schedulerAssignments: any[] = [];
    const routeJobs: any[] = [];
    const isRouteLocked = routeDetails.is_deleted || routeDetails.is_locked;

    routeDetails.id = routeDetails.route_uid;
    routeDetails.name = routeDetails.route_name;
    routeDetails.manuallyScheduled = true;
    routeDetails.durationUnit = 'hour';
    routeDetails.duration = routeDetails.duration || 1;
    routeDetails.startDate = new Date(moment(routeDetails.departure).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss'));
    routeDetails.endDate = new Date(moment(routeDetails.departure).add(routeDetails.duration, 'h').tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss'));
    routeDetails.resizable = !isRouteLocked;
    routeDetails.draggable = !isRouteLocked;

    routeDetails.jobs.forEach((routeJob: any, index: number) => {
      const job = routeJob.job;
      if (job) {
        const jobStartDate = moment.utc(job.scheduled_start_time);
        const jobEndTimeDate = moment.utc(job.scheduled_end_time);
        const routeStartDate = moment.utc(routeDetails.departure);
        const routeEndDate = moment.utc(routeDetails.departure).add(routeDetails.duration, 'h');

        if (jobStartDate.isBetween(routeStartDate, routeEndDate, null, '[]') || jobEndTimeDate.isBetween(routeStartDate, routeEndDate, null, '[]')) {
          job.id = job.job_uid;
          job.name = this._dispatchBoardService.getJobTitle(job.prefix, job.work_order_number, job.job_title);
          job.preamble = Number(Number((job.time || 0) / 60).toFixed(0)) > 0 ? `${Number((job.time || 0) / 60).toFixed(0)} minutes` : '';
          if (index === routeDetails.jobs?.length - 1) {
            job.postamble = Number(Number((routeDetails.end_location?.time || 0) / 60).toFixed(0)) > 0 ? `${Number((routeDetails.end_location?.time || 0) / 60).toFixed(0)} minutes` : '';
            job.end_location_time = routeDetails.end_location?.time || 0;
            job.end_location_distance = routeDetails.end_location?.distance || 0;
          }
          job.detailsType = 'job';
          job.transport_mode = routeDetails.transport_mode;
          job.startDate = new Date(moment(job.scheduled_start_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm'));
          job.endDate = new Date(moment(job.scheduled_end_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm'));
          job.eventColor = '#3c763d';
          job.resizable = !(job.current_job_status && job.current_job_status.status_type === 'CLOSED');
          job.draggable = !isRouteLocked;

          routeDetails.assigned_to.forEach((assignment: any) => {
            if (!assignment?.user?.user_uid) {
              return;
            }
            schedulerAssignments.push({
              id: `${job.job_uid}_${assignment.user.user_uid}`,
              eventId: job.job_uid,
              resourceId: assignment.user.user_uid,
              routeUid: routeDetails.route_uid
            });
          });

          routeJobs.push(job);
        }
      }
    });

    routeDetails.assigned_to.forEach((assignment: any) => {
      if (!assignment?.user?.user_uid) {
        return;
      }
      schedulerAssignments.push({
        id: `${routeDetails.route_uid}_${assignment.user.user_uid}`,
        eventId: routeDetails.route_uid,
        resourceId: assignment.user.user_uid,
        routeUid: routeDetails.route_uid
      });
    });

    routeDetails.children = routeJobs;
    return [routeDetails, schedulerAssignments];
  }

  updateRouteInScheudler(routeUid: any): void {
    if (routeUid) {
      this._dispatchBoardService.getRouteDetails(routeUid).subscribe((response: any) => {
        const routeDetails: any = response?.data;
        if (routeDetails) {
          this.suspendAllSchedulerEvents({ event: true });
          const routeEvent = this.schedulerInstance.eventStore.getById(routeUid);
          if (routeEvent) {
            const [updatedRouteDetails, updatedAssignments]: any = this.formatRouteJobDetails(routeDetails);
            const childrenMap = updatedRouteDetails.children?.reduce((_map: any, job: any) => {
              _map[job?.job_uid] = job;
              return _map;
            }, {});
            routeEvent.set({ ...updatedRouteDetails }, true);
            routeEvent.children.forEach((jobEvent: any) => {
              if (childrenMap[jobEvent?.id]) {
                jobEvent.set({...childrenMap[jobEvent?.id]}, true);
              }
            });
            this.updateAssignments(updatedRouteDetails, updatedAssignments);
            this.resumeAllSchedulerEvents({ event: true });
            setTimeout(() => {this.schedulerInstance.eventStore.commit(); this.schedulerInstance.eventStore.refreshData();});

            //Update schduler route local details
            const routeIndex: number = this.schedulerRoutes.findIndex((route: any) => route?.route_uid === routeUid);
            if (routeIndex > -1) {
              this.schedulerRoutes.splice(routeIndex, 0, updatedRouteDetails);
              this.updateSchedulerRouteMasterRecords('route', routeUid, updatedRouteDetails);
              this.updateMapRouteFilter();
            }
          }
        }
      });
    }
  }

  updateAssignments(updatedRouteData: any, assignmentData?: any[]): void {
    this.suspendAllSchedulerEvents({ assignment: true });
    let newAssignments: any = {};
    if (!assignmentData) {
      updatedRouteData.assigned_to.forEach((assignment: any) => {
        const assignmentRecord = {
          id: `${updatedRouteData.route_uid}_${assignment.user.user_uid}`,
          eventId: updatedRouteData.route_uid,
          resourceId: assignment.user.user_uid,
          routeUid: updatedRouteData.route_uid
        };
        newAssignments[assignmentRecord.id] = assignmentRecord;
      });
      updatedRouteData.jobs.forEach((jobDetail: any) => {
        updatedRouteData.assigned_to.forEach((assignment: any) => {
          const assignmentRecord = {
            id: `${jobDetail.job.job_uid}_${assignment.user.user_uid}`,
            eventId: jobDetail.job.job_uid,
            resourceId: assignment.user.user_uid,
            routeUid: updatedRouteData?.route_uid
          };
          newAssignments[assignmentRecord.id] = assignmentRecord;
        });
      });
    }
    else {
      newAssignments = assignmentData.reduce((_map: any, assignment: any) => {
        _map[assignment?.id] = assignment;
        return _map;
      }, {});
    }

    const existingRouteAssignmnets = this.schedulerInstance.assignmentStore.findByField('routeUid', updatedRouteData?.route_uid);
    const exisitngAssignmentIds = existingRouteAssignmnets.map((assignment: any) => assignment?.id);
    const newAssignmentIds = Object.keys(newAssignments);
    const toBeAddedAssignments = _.difference(newAssignmentIds, exisitngAssignmentIds);
    const toBeRemovedAssignments = _.difference(exisitngAssignmentIds, newAssignmentIds);
    //Remove existing assignments
    this.schedulerInstance.assignmentStore.remove(toBeRemovedAssignments);

    //Add New assignments
    toBeAddedAssignments.forEach((assignmentId: any) => {
      this.schedulerInstance.assignmentStore.add(newAssignments[assignmentId]);
    });
    this.resumeAllSchedulerEvents({ assignment: true });
  }

  setSchedulerConfig(): void {
    const _this = this;
    this.schedulerSummaryTooltipInstance?.destroy();
    this.timeoffTooltipInstance?.destroy();
    this.schedulerProConfig = {
      resourceTimeRanges: [],
      zoomOnTimeAxisDoubleClick: false,
      zoomOnMouseWheel: false,
      createEventOnDblClick: false,
      autoAdjustTimeAxis : false,
      fillTicks: false,
      viewPreset: 'customHourAndDay',
      autoHeight: false,
      height: '100%',
      resources: this.initiateGridShimmer(7),
      resourceStore: {
        sorters: [
          { field: 'name', ascending: true }
        ],
        listeners: {
          add: (event: any): void => {
            if (event?.records?.length && !event.records[0]?.data?.showShimmer) {
              this.sortSchedulerResources();
            }
          }
        }
      },
      columns: [
        {
          text: 'Name',
          field: 'name',
          autoWidth: false,
          autoHeight: false,
          editor: false,
          enableHeaderContextMenu: false,
          enableCellContextMenu: false,
          sortable: false,
          minWidth: 250,
          fitMode: 'value',
          cls: 'min-w-72',
          htmlEncode : false,
          headerRenderer: (): string => {
            this.addSchedulerEmpHeaderOnClickListener();
            return this.templateService.getSchedulerResourceHeader(this.filterCount.employee, 'ROUTES');
          },
          summaries: [{
            sum: 'count',
            renderer: (resource: any): string => `<span class='text-medium font-medium'>${this._utilityService.getLocaleValue('text.total_users', 'Total Users')} : ${resource?.sum || 0}</span>`
          }],
          renderer: (event: any): string => {
            if (event.record?.originalData?.showShimmer) {
              return this.templateService.getUserCardShimmer();
            }
            else {
              const userUid = event.record?._data.user_uid;
              const additionalParams = {
                currentView: this.currentView,
                currentDay: this.currentDay,
                jobsCount:  this._dispatchBoardService.getUserJobCount(this.schedulerRoutes, userUid),
                preferences: { display: this.metaData?.employee.more_information },
                dateRange: { fromDate: this.schedulerParams['from_date'], toDate: this.schedulerParams['to_date'] }
              };
              event.size.height = this.schedulerResourceRowHeight;
              return this.templateService.getJobRendererTemplate('routes', 'employee', null, userUid, additionalParams);
            }
          }
        }
      ],
      eventRenderer: (event: any): string => {
        const eventRecord: any = event.eventRecord;
        const renderData: any = event.renderData;
        const details = eventRecord.data;
        let template: string;
        if (details?.detailsType === 'route') {  
          const routeDetails = details;
          template = this.templateService.getRouteEventHeaderTemplate(routeDetails);
          const routeColor = this._utilityService.convertHexToRgba(routeDetails?.color || '#e67e22', '0.20');
          renderData.eventColor = '#ffffff';
          renderData.eventStyle = 'border';
          renderData.style += `border-width: 1.2px; border-color: ${routeColor || '#e67e22'};`;
          this.schedulerInstance.rowHeight = this.schedulerRouteEventRowHeight;
        }
        else if (details?.detailsType === 'job') {
          const jobDetails = details;
          const jobUid = jobDetails?.job_uid;
          let eventBorderColor = this.templateService.getCardColor(jobDetails, this.metaData?.scheduler.secondary_color);
          if (this.metaData?.scheduler.secondary_color === 'team') {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const team = _.find(this.allTeams, { 'team_uid': this.selectedTeam });
            eventBorderColor = team?.team_color;
          }
          renderData.eventStyle = 'border';
          renderData.eventColor = `${this._utilityService.convertHexToRgba(this.templateService.getCardColor(jobDetails, this.metaData?.scheduler.primary_color) || '#887ECB')}`;
          renderData.style += `${this.metaData?.scheduler.primary_color === 'none' ? 'border-width: 2.5px; border-color: rgba(210 ,200,200, 0.3);' : ''} border-left-width: 5px; border-left-color: ${eventBorderColor || '#e67e22'};`;
          renderData.style += `height: ${this.schedulerJobEventRowHeight}px`;
          template = this.templateService.getJobRendererTemplate('routes', 'scheduler', jobUid);
        }
        return template;
      },
      features: {
        dependencies: false,
        eventDragCreate: false,
        scheduleTooltip: {
          generateTipContent: ({ date }): any => {
            const hoveringDate = dayjs(date).format(this.dateTimeFormat);
            return `<div class='flex flex-col space-y-1.5'>
                      <div class='flex items-center space-x-1.5'>
                        <i class='ti ti-clock text-2xl'></i>
                        <span>${hoveringDate}</span>
                      </div>
                    </div>  `;
          }
        },
        eventBuffer: {
          showDuration: true,
          renderer: ({ eventRecord, postambleConfig, preambleConfig }: any): any => {
            const jobDetails = eventRecord.data;
            const modeOfTransport = jobDetails?.transport_mode || 'CAR';
            let travelTime: number = 0;
            if (eventRecord?.preamble) {
              travelTime = (eventRecord?.preamble?._magnitude || 0) * 60;
              preambleConfig.icon = `text-gray-500 b-icon b-fa-${this._dispatchBoardService.modeOfTransportIcons[modeOfTransport]}`;
              preambleConfig.text = travelTime !== 0 ? `${this._utilityService.convertSecondsToHours(travelTime, true)}` : `- ${this._utilityService.getLocaleValue('users.preview.work_hours.mins.label')}`;
            }

            if (eventRecord?.postamble) {
              travelTime = (eventRecord?.postamble?._magnitude || 0) * 60;
              postambleConfig.icon = `text-gray-500 b-icon b-fa-${this._dispatchBoardService.modeOfTransportIcons[modeOfTransport]}`;
              postambleConfig.text = travelTime !== 0 ? `${this._utilityService.convertSecondsToHours(travelTime, true)}` : `- ${this._utilityService.getLocaleValue('users.preview.work_hours.mins.label')}`;
            }
          },
          tooltipTemplate: (event: any): any => {
            const jobDetails = event.eventRecord.data;
            const type: 'preamble' | 'postamble' = event.before ? 'preamble' : 'postamble';
            const modeOfTransport = jobDetails?.transport_mode || 'CAR';
            let travelTime: number;
            let travelDistance: number;
            this.schedulerInstance?.features.eventTooltip.tooltip?.close();
            if (type === 'preamble') {
              travelTime = jobDetails?.time || 0;
              travelDistance = jobDetails?.distance || 0;
            }
            else if (type === 'postamble') {
              travelTime = jobDetails?.end_location_time || 0;
              travelDistance = jobDetails?.end_location_distance || 0;
            }
            return this.templateService.getRouteTravelDistanceTooltipTemplate(travelTime, travelDistance, modeOfTransport);
          }
        },
        timeAxisHeaderMenu: false,
        cellTooltip: {
          hoverDelay: 200,
          hideDelay: 100,
          allowOver: true,
          scrollAction: 'hide',
          anchorToTarget: false,
          maxWidth: 500,
          hideOnDelegateChange: true,
          style: 'min-width : 400px !important;overflow : hidden;max-height:98% !important;',
          loadingMsg: this._utilityService.getLocaleValue('dispatchBoard.scheduler.employee.loading_details', 'Loading Details'),
          tooltipRenderer: async (context: any): Promise<string> => {
            const userDetails = context.record.data;
            if (userDetails?.showShimmer) {
              return '';
            }
            const userUid = userDetails?.user_uid;
            const dateRange = { fromDate: this.schedulerParams['from_date'], toDate: this.schedulerParams['to_date'] };
            const preferences = { display: this.metaData?.employee.more_information };
            const jobCount = this._dispatchBoardService.getUserJobCount(this.schedulerRoutes, userUid);
            const viewMode = this.currentView;
            return await _this.templateService.getEmployeePreviewTemplate('routes', dateRange, userDetails, preferences, jobCount, viewMode);
          },
          onFocusIn: (event: any): any => {
            const openUserDetails = event?.toWidget?.currentElement ? (event.toWidget.currentElement as HTMLElement).querySelector('#employeeDetailsExternal') : null;
            const userUid = openUserDetails?.['dataset'].useruid;
            if (openUserDetails && userUid) {
              openUserDetails.addEventListener('click', () => {
                this.openEmployeeDetailsDrawer(userUid);
              });
            }
          },
          onHide: (event: any): any => {
            const openUserDetails = event?.toWidget?.currentElement ? (event?.toWidget?.currentElement as HTMLElement).querySelector('#employeeDetailsExternal'): null;
            if (openUserDetails) {
              openUserDetails.removeEventListener('click', () => { });
            }
          }
        },
        nestedEvents: {
          eventLayout: 'stack',
          eventHeight: Object.keys(this.metaData?.scheduler.card_view).length * 30,
          barMargin: 10,
          allowDeNestingOnDrop: false,
          resourceMargin: 10
        },
        resourceTimeRanges: {
          enableMouseEvents: true,
        },
        timeRanges: {
          showHeaderElements: true,
          showCurrentTimeLine: true,
        },
        scheduleMenu: false,
        eventMenu: {
          items: {
            copyEvent: false,
            cutEvent: false,
            editEvent: false,
            deleteEvent: false,
            unassignEvent: false,
            splitEvent: false,
            rescheduleJob: {
              text: this._utilityService.getLocaleValue('text.reschedule_job', 'Reschedule Job'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-clock-edit text-xl',
              onItem(event: any): any {
                const jobDetails = event.eventRecord.originalData;
                const routeDetails = event.eventRecord.parent.data;
                const userDetails = event.resourceRecord.originalData;
                const dropDateTime = event.eventRecord.startDate;
                _this._dispatchBoardService.trackEvent('scheduler_job_reschedule');
                _this._sdkEventService
                  .openCustomWithPreEventListener(RescheduleJobComponent, {
                    dialogId: 'dispatch_board.job_reschedule',
                    data: {
                      holidays: this.holidays,
                      userDetails: userDetails,
                      jobDetails: jobDetails,
                      dropDateTime: dropDateTime,
                      customUserDetails: this.customUserDetails,
                      teamUid: this.selectedTeam,
                      routeDetails: routeDetails,
                      targetRouteDetails: routeDetails,
                      checkRouteJobConflict: true,
                      checkRouteDurationExceed: true,
                      enableClearSchedule: true,
                    },
                    extraClass: 'w-fit',
                  }, {
                    ...jobDetails, dispatch_details: {
                      user_details: userDetails,
                      drop_date_time: moment(dropDateTime).format('YYYY-MM-DD HH:mm:ss'),
                      selected_team: {
                        team_uid: this.selectedTeam,
                        team_name: this.getTeamName(this.selectedTeam)
                      }
                    }
                  })
                  .then(
                    (
                      rescheduleDialogInstance: MatDialogRef<RescheduleJobComponent> | null
                    ) => {
                      rescheduleDialogInstance
                        ?.afterClosed()
                        .subscribe((data: any) => {
                          if (data) {
                            _this.getSchedulerData(true, false);
                          }
                        });
                    }
                  );
              }
            },
            clearJobSchedule: {
              text: this._utilityService.getLocaleValue('text.clear_schedule', 'Clear Schedule'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-eraser text-xl',
              onItem(event: any): any {
                const jobDetails = event.eventRecord.originalData;
                _this._dispatchBoardService.trackEvent('clear_job_schdedule');

                if(jobDetails?.due_date){
                  const clearScheduleConfirmationDialogRef = _this._dispatchBoardService.jobDetailsChangeConfirmationDialog(jobDetails, 'clearSchedule');
                  clearScheduleConfirmationDialogRef.afterClosed()
                  .subscribe((data: any) => {
                    if (data) {
                      _this._dispatchBoardService.clearScheduleJob(jobDetails, (status: true) => {
                        if (status) {
                          _this.getSchedulerData(true, false);
                        }
                      });
                    }
                  });
                }
                else {
                  const dueDateDialog = _this._zuperDialogService.openCustom(UpdateDueDateComponent,{
                    data: jobDetails,
                    extraClass:'w-2/5',
                    clearSchedule: true, //prefill checkbox based in the value
                    updateDueDateAndClearSchedule: true // change primary button text and add note on top
                   });

                   dueDateDialog.afterClosed().subscribe((response: any)=>{
                    if(response){
                      if(jobDetails?.route?.route_uid) {
                        _this._dispatchBoardService.clearScheduleJobFromRoute(jobDetails, (status: true) => {
                          if (status) {
                            _this.getSchedulerData(true, false);
                          }
                        });
                      }
                      else {
                        _this.getSchedulerData(true, false);
                      }
                    }
                  });
                }
              }
            },
            rescheduleRoute: {
              text: this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.dialog.reschedule_route', 'Reschedule Route'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-clock-edit text-xl',
              onItem(event: any): any {
                const routeDetails = event.eventRecord.originalData;
                const userDetails = event.resourceRecord.originalData;
                const routeDuration = routeDetails?.duration || 1;
                const startDateTime = moment(event.eventRecord.startDate);
                const endDateTime = startDateTime.clone().add(routeDuration, 'h');
                _this._dispatchBoardService.trackEvent('scheduler_route_reschedule');
                const rescheduleRouteDialogInstance = _this._zuperDialogService.openCustom(RescheduleRouteComponent,
                  {
                    data:
                    {
                      routeDetails: routeDetails,
                      userDetails: userDetails,
                      startDateTime: startDateTime,
                      endDateTime: endDateTime,
                      duration: routeDuration,
                      customUserDetails: _this.customUserDetails,
                      showRescheduleSuccessToast: true
                    },
                    extraClass: 'route-schdule-dialog'
                  });

                rescheduleRouteDialogInstance.afterClosed()
                  .subscribe((data: any) => {
                    if (data) {
                      _this.getSchedulerData(true, false);;
                    }
                  });
              }
            },
            reassignRoute: {
              text: this._utilityService.getLocaleValue('text.assign.another_route', 'Assign to another Route'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-git-pull-request text-xl',
              onItem(event: any): any {
                const jobDetails = event.eventRecord.data;
                const routeDetails = event.eventRecord.parent.data;
                const routeUid = routeDetails?.route_uid;
                const date = _this.schedulerTbarForm.get('schedulerDate')?.value;
                _this._dispatchBoardService.trackEvent('scheduler_reassign_route');
                _this.openRouteAssignDrawer(jobDetails, routeUid, date);
              }
            },
            removeJobFromRoute: {
              text: this._utilityService.getLocaleValue('text.remove_from_route', 'Remove from Route'),
              weight: 300,
              cls: 'text-red-600 primary-font leading-normal text-base',
              icon: 'ti ti-map-off text-xl text-red-600',
              onItem(event: any): any {
                const routeDetails = event.eventRecord.parent.data;
                const jobDetails = event.eventRecord.data;
                const jobUid = jobDetails?.job_uid;
                const routeUid = routeDetails?.route_uid;
                let showCheckbox = false;
                _this._dispatchBoardService.trackEvent('scheduler_remove_job_from_route');
                if (routeDetails?.assigned_to?.length) {
                  showCheckbox = true;
                }
                const removeFromRoteConfirmationDialogRef = _this._zuperDialogService.openCustom(RemoveJobComponent, {
                  data: jobDetails,
                  checkbox: true,
                  extraClass: 'route-delete-dialog'
                });
                removeFromRoteConfirmationDialogRef.afterClosed()
                  .subscribe((dialogData: any) => {
                    if (dialogData) {
                      const removeJobParam = {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        jobs: [{ job_uid: jobUid }], unassign_users: dialogData?.unassign
                      };
                      _this._dispatchBoardService.removeJobFromRoute(routeUid, removeJobParam, (status: true) => {
                        if (status) {
                          _this.getSchedulerData(true, false);
                        }
                      });
                    }
                  });
              }
            },
            editRoute: {
              text: this._utilityService.getLocaleValue('route.edit', 'Edit Route'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-edit text-xl',
              onItem(event: any): any {
                const routeDetails = event.eventRecord.data;
                _this._dispatchBoardService.trackEvent('scheduler_edit_route');
                if (routeDetails) {
                  _this.toggleRouteForm('edit', routeDetails, true);
                }
              }
            },
            cloneRoute: {
              text: this._utilityService.getLocaleValue('text.clone_route', 'Clone Route'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-copy text-xl',
              onItem(event: any): any {
                const routeDetails = event.eventRecord.data;
                if (routeDetails) {
                  _this._dispatchBoardService.trackEvent('scheduler_clone_route');
                  _this.toggleRouteForm('clone', routeDetails, true);
                }
              }
            },
            showOnMap: {
              text: this._utilityService.getLocaleValue('dispatchBoard.scheduler.event_menu.options.show_on_map', 'Show on Map'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-map-pin text-xl',
              onItem(event: any): any {
                _this.mapViewData = {};
                const routeDetails = event.eventRecord.data;
                _this._dispatchBoardService.trackEvent('scheduler_job_show_on_map');
                if (_this.selectedSchedulerPlanningNavTab === 'DISPATCH_BOARD') {
                  _this.onSchedulerPlanningNavTabChange('MAP');
                }
                _this._mapService.showOnMap.next({ module: 'ROUTES', eventUid: routeDetails?.route_uid });
              }
            },
            optimizeRoute: {
              text: this._utilityService.getLocaleValue('optimise.route', 'Optimize Route'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-wand text-xl',
              onItem(event: any): any {
                const routeDetails = event.eventRecord.data;
                const routeUid = routeDetails?.route_uid;
                _this._dispatchBoardService.trackEvent('scheduler_optimize_route');
                _this._dispatchBoardService.optimizeRoute(routeUid, (status: boolean) => {
                  if (status) {
                    _this.getSchedulerData(true, false);
                  }
                });
              }
            },
            unAssignRoute: {
              text: this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.event_menu.options.unassign_route', 'Unassign Route'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-user-minus text-xl',
              onItem(event: any): any {
                const routeDetails = event.eventRecord.data;
                const userDetails = event.resourceRecord.data;
                const userUid = userDetails?.user_uid;
                const routeUid = routeDetails?.route_uid;
                _this._dispatchBoardService.trackEvent('scheduler_unassign_route');
                const unassignRouteDialogRef = _this._dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, 'unassignRoute', { userDetails: userDetails });
                unassignRouteDialogRef.afterClosed()
                  .subscribe((_result: any) => {
                    if (_result) {
                      const userTeamUid = _this.getUserTeamId(userUid);
                      const unassignUserDetails = {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        users: [{ team_uid: userTeamUid, user_uid: userUid }]
                      };
                      _this._dispatchBoardService.unAssignRoute(routeUid, unassignUserDetails, true, (status: boolean) => {
                        if (status) {
                          _this.getSchedulerData(true, false);
                          _this.updateGridData(false, false, true);
                        }
                      });
                    }
                  });
              }
            },
            lockRoute: {
              text: this._utilityService.getLocaleValue('text.lock_route', 'Lock Route'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-lock text-xl',
              onItem(event: any): any {
                const routeDetails = event.eventRecord.data;
                const routeUid = routeDetails?.route_uid;
                const isRouteLocked = routeDetails?.is_locked;
                let lockConfirmationDialogRef: MatDialogRef<any>;
                if (isRouteLocked) {
                  lockConfirmationDialogRef = _this._dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, 'unlockRoute');
                  _this._dispatchBoardService.trackEvent('scheduler_unlock_route');
                }
                else {
                  lockConfirmationDialogRef = _this._dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, 'lockRoute');
                  _this._dispatchBoardService.trackEvent('scheduler_lock_route');
                }
                lockConfirmationDialogRef.afterClosed()
                  .subscribe((_result) => {
                    if (_result) {
                      const lockUpdateToast = _this._toastService.loading(_this._utilityService.getLocaleValue('route.lock.updating'));
                      // eslint-disable-next-line @typescript-eslint/naming-convention
                      _this._dispatchBoardService.updateRouteLock(routeUid, !isRouteLocked, (status: boolean) => {
                        if (status) {
                          _this.getSchedulerData(true, false);
                          lockUpdateToast.close();
                        }
                        else {
                          lockUpdateToast.close();
                        }
                      });
                    }
                  });
              }
            },
            deleteRoute: {
              text: this._utilityService.getLocaleValue('text.delete_route', 'Delete Route'),
              cls: 'text-red-600 primary-font leading-normal text-base',
              weight: 300,
              icon: 'ti ti-trash text-xl text-red-600',
              onItem(event: any): any {
                const routeDetails = event.eventRecord.data;
                const routeUid = routeDetails?.route_uid;
                _this._dispatchBoardService.trackEvent('scheduler_delete_route');
                const deleteConfirmationDialogRef = _this._dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, 'deleteRoute');
                deleteConfirmationDialogRef.afterClosed()
                  .subscribe((_result: any) => {
                    if (_result) {
                      _this._dispatchBoardService.deleteRoute(routeUid, (status: true) => {
                        if (status) {
                          _this.schedulerInstance?.eventStore.remove(routeUid);
                          _this.gridViewInstance?.store.remove(routeUid);
                          _this.updateLocalRecordsAfterChanges('ROUTES', routeDetails, 'delete');
                          _this.schedulerRoutes = _this.schedulerRoutes.filter((route: any) => route?.route_uid !== routeUid);
                          _this.updateMapRouteFilter();
                        }
                      });
                    }
                  });
              }
            }
          },
          processItems(event): any {
            const items: any = event.items;
            const eventRecord: any = event.eventRecord;
            if (eventRecord.isParent) {
              const routeDetails = eventRecord.data;
              const isRouteLocked = routeDetails?.is_locked;
              const routeHasJobs = (routeDetails?.jobs || [])?.length;
              items.rescheduleJob.hidden = true;
              items.reassignRoute.hidden = true;
              items.removeJobFromRoute.hidden = true;
              items.clearJobSchedule.hidden = true;
              items.editRoute.hidden = !_this.permissions.updateRoute || isRouteLocked;
              items.cloneRoute.hidden = !_this.permissions.cloneRoute;
              items.showOnMap.hidden = (!_this.moduleAccess.map || !_this.isMapViewEnabled || !_this.metaData?.map.layers.routes);
              items.deleteRoute.hidden = !_this.permissions.deleteRoute || isRouteLocked;
              items.optimizeRoute.hidden = routeDetails?.is_optimized || !_this.permissions.updateRoute || isRouteLocked || !routeHasJobs;
              items.unAssignRoute.hidden = !_this.permissions.updateRouteAssignment || isRouteLocked;
              items.rescheduleRoute.hidden = !_this.permissions.updateRoute || isRouteLocked;
              items.lockRoute.hidden = false;
              items.lockRoute.icon = routeDetails?.is_locked ? 'ti ti-lock-open text-xl' : 'ti ti-lock text-xl';
              items.lockRoute.text = routeDetails?.is_locked ? _this._utilityService.getLocaleValue('text.unlock_route', 'Unlock Route') : _this._utilityService.getLocaleValue('text.lock_route', 'Lock Route');
            }
            else {
              const routeDetails = eventRecord.parent.data;
              const isRouteLocked = routeDetails?.is_locked;
              items.rescheduleJob.hidden = !_this.permissions.rescheduleJob || isRouteLocked;
              items.reassignRoute.hidden = !_this.permissions.updateJobAssignment || isRouteLocked;
              items.removeJobFromRoute.hidden = !_this.permissions.updateJob || isRouteLocked;
              items.editRoute.hidden = true;
              items.cloneRoute.hidden = true;
              items.showOnMap.hidden = true;
              items.deleteRoute.hidden = true;
              items.optimizeRoute.hidden = true;
              items.unAssignRoute.hidden = true;
              items.lockRoute.hidden = true;
              items.rescheduleRoute.hidden = true;
              items.clearJobSchedule.hidden = false;
            }
          }
        },
        eventTooltip: {
          hideDelay: 0,
          template: ((context: any): any => {
            const eventDetails = context.eventRecord.data;
            const detailsType: 'job' | 'route' = eventDetails?.detailsType;
            if (detailsType === 'job') {
              const jobDetails = eventDetails;
              return this.templateService.getJobDetailsTemplate(jobDetails, this.currentView, this.metaData);
            }
            else if (detailsType === 'route') {
              const routeDetails = eventDetails;
              return this.templateService.getRouteDetailsTooltipTemplate(routeDetails);
            }
          })
        },
        summary: {
          disabled: true,
          renderer: (event: any): string => {
            let eventIds = [];
            event?.events.forEach((eventModel: any) => {
              if (eventModel._data.detailsType === 'route') {
                eventIds.push(eventModel._data.id);
              }
            });
            eventIds = _.uniq(eventIds);
            return `<div class='cursor-default' eventIds=${eventIds.join(',')}>${eventIds.length}</div>`;
          }
        },
        eventResize: {
          validatorFn(context: any): any {
            const startDate = moment(context.startDate);
            const endDate = moment(context.endDate);
            if (endDate.diff(startDate, 'm') > 1440) {
              return { valid: false, message: _this._utilityService.getLocaleValue('"dispatchBoard.error.route_max_duration', 'Route duration should not exceed 24 hours') };
            }
          }
        },
        eventDrag: {
          constrainDragToResource: !(this.permissions.updateJobAssignment || this.permissions.updateRouteAssignment)
        }
      },
      onEventClick: (event: any): void => {
        if (event.eventRecord.isParent) {
          const routeDetails = event.eventRecord.data;
          const routeUid = routeDetails.route_uid;
          if (routeUid) {
            this._dispatchBoardService.trackEvent('scheduler_route_preview');
            this.openRoutePreviewDrawer(routeUid, 'scheduler', routeDetails);
          }
        }
        else {
          const jobUid = event.eventRecord.data.job_uid;
          if (jobUid) {
            this._dispatchBoardService.trackEvent('scheduler_job_preview');
            this.openJobPreviewDrawer(jobUid, 'scheduler');
          }
        }
      },
      listeners: {
        beforeEventResizeFinalize({ context }): any {
          const eventDetails = context.eventRecord.data;
          const userDetails = context.resourceRecord.data;
          const detailsType: 'job' | 'route' = eventDetails?.detailsType;
          const startDateTime = moment(moment(context.startDate).tz(_this.browserTimezone).format('YYYY-MM-DD HH:mm:ss'));
          const endDateTime = moment(moment(context.endDate).tz(_this.browserTimezone).format('YYYY-MM-DD HH:mm:ss'));
          if (detailsType === 'job') {
            context.async = true;
            const jobDetails = context.eventRecord.data;
            const parentRouteDetails = context.eventRecord.parent.data;
            const warnings: any[] = _this._dispatchBoardService.getScheduleWarningMsg('job', jobDetails, userDetails, moment.tz(startDateTime.format('YYYY-MM-DD HH:mm:ss'), _this.selectedTimezone), moment.tz(endDateTime.format('YYYY-MM-DD HH:mm:ss'), _this.selectedTimezone), _this.customUserDetails, true, null, { checkRouteJobConflict: true, routeDetails: parentRouteDetails });
            _this._dispatchBoardService.trackEvent('scheduler_resize_job_rescheudle');
            const rescheduleRemarksDialogInstance = _this._zuperDialogService.openCustom(RemarksComponent,
              {
                data:
                {
                  jobDetails: jobDetails,
                  warnings: warnings,
                  startDateTime: moment.tz(startDateTime.format('YYYY-MM-DD HH:mm:ss'), _this.selectedTimezone).toISOString(),
                  endDateTime: moment.tz(endDateTime.format('YYYY-MM-DD HH:mm:ss'), _this.selectedTimezone).toISOString(),
                  timeZone: _this.selectedTimezone
                },
                extraClass: 'w-2/5'
              });
            rescheduleRemarksDialogInstance?.afterClosed()
              .subscribe((status: boolean) => {
                if (status) {
                  _this.getSchedulerData(true, false);
                  context.finalize(true);
                }
                else {
                  context.finalize(false);
                }
              });
          }
          else if (detailsType === 'route') {
            context.async = true;
            const routeDetails = { ...context.eventRecord.data };
            const routeDuration = routeDetails?.duration || 1;
            _this._dispatchBoardService.trackEvent('scheduler_resize_route_rescheudle');
            const rescheduleRouteDialogInstance = _this._zuperDialogService.openCustom(RescheduleRouteComponent,
              {
                data:
                {
                  routeDetails: routeDetails,
                  userDetails: userDetails,
                  startDateTime: moment(context.startDate),
                  endDateTime: moment(context.endDate),
                  duration: routeDuration,
                  customUserDetails: _this.customUserDetails,
                  showRescheduleSuccessToast: true
                },
                extraClass: 'route-schdule-dialog'
              });
            rescheduleRouteDialogInstance?.afterClosed()
              .subscribe((status: boolean) => {
                if (status) {
                  context.finalize(true);
                  _this.getSchedulerData(true, false);
                }
                else {
                  context.finalize(false);
                }
              });
          }
        },
        beforeEventDropFinalize({ context }): any {
          const eventDetails = context.eventRecord.data;
          const oldUserDetails = context?.resourceRecord.data;
          const detailsType: 'job' | 'route' = eventDetails?.detailsType;
          const newUserDetails = context?.newResource.data;
          const newStartTime = moment(context?.startDate);
          const oldStartTime = moment(context?.sourceDate);
          const newEndTime = moment(context?.endDate);
          if (detailsType === 'job') {
            context.async = true;
            const jobDetails = eventDetails;
            const oldRouteDetails = context.eventRecord.parent.data;
            const newRouteDetails = context.targetEventRecord.data;
            if (_this.permissions.rescheduleJob) {
              if (newRouteDetails?.is_locked) {
                _this._toastService.error(_this._utilityService.getLocaleValue('dispatchBoard.error.unlock_route_to_add_job'));
                context.finalize(false);
              }
              else {
                _this._dispatchBoardService.trackEvent('scheduler_job_drop_rescheudle');
                _this._sdkEventService
                  .openCustomWithPreEventListener(RescheduleJobComponent, {
                    dialogId: 'dispatch_board.job_reschedule',
                    data: {
                      holidays: _this.holidays,
                      userDetails: newUserDetails,
                      jobDetails: jobDetails,
                      dropDateTime: newStartTime,
                      customUserDetails: _this.customUserDetails,
                      teamUid: _this.selectedTeam,
                      routeDetails: oldRouteDetails,
                      targetRouteDetails: newRouteDetails,
                      checkRouteJobConflict: true,
                      checkRouteDurationExceed: true,
                    },
                    extraClass: 'w-fit',
                  }, {
                    ...jobDetails, dispatch_details: {
                      user_details: newUserDetails,
                      drop_date_time: moment(newStartTime).format('YYYY-MM-DD HH:mm:ss'),
                      new_route_details: newRouteDetails,
                      selected_team: {
                        team_uid: _this.selectedTeam,
                        team_name: _this.getTeamName(_this.selectedTeam)
                      }
                    }
                  })
                  .then(
                    (
                      rescheduleDialogInstance: MatDialogRef<RescheduleJobComponent> | null
                    ) => {
                      rescheduleDialogInstance
                        ?.afterClosed()
                        .subscribe((dialogData: any) => {
                          if (
                            !_this._utilityService.isEmptyOrUndefined(
                              dialogData
                            )
                          ) {
                            context.finalize(true);
                            _this.getSchedulerData(true, false);
                            if (
                              newUserDetails?.user_uid !==
                              oldUserDetails?.user_uid
                            ) {
                              _this._dispatchBoardService.trackEvent(
                                'scheduler_job_drop_user'
                              );
                            }
                          } else {
                            context.finalize(false);
                          }
                        });
                    }
                  );
              }
            }
            else {
              context.finalize(false);
              _this._toastService.error(_this._utilityService.getLocaleValue('dispatchBoard.scheduler.permission.error', 'You don\'t have permission to perform this action'));
            }
          }
          else if (detailsType === 'route') {
            context.async = true;
            const routeDetails = eventDetails;
            const routeUid = routeDetails?.route_uid;
            const oldUserUid = oldUserDetails?.user_uid;
            const newUserUid = newUserDetails?.user_uid;
            const assignNewUserWithotReschedule = newStartTime.isSame(oldStartTime) && (oldUserUid !== newUserUid);
            _this._dispatchBoardService.trackEvent('scheduler_route_drop_rescheudle');
            if (assignNewUserWithotReschedule) {
              if (_this.permissions.updateRouteAssignment) {
                const unassignUserDetails = {
                  // eslint-disable-next-line @typescript-eslint/naming-convention
                  users: [{ team_uid: _this.getUserTeamId(oldUserUid) || _this.selectedTeam, user_uid: oldUserUid }]
                };
                _this._dispatchBoardService.unAssignRoute(routeUid, unassignUserDetails, false, (status: boolean) => {
                  if (status) {
                    const assignUserDetails = {
                      // eslint-disable-next-line @typescript-eslint/naming-convention
                      users: [{ team_uid: _this.selectedTeam, user_uid: newUserUid }]
                    };
                    _this._dispatchBoardService.assignRoute(routeUid, assignUserDetails, false, (_status: boolean) => {
                      if (_status) {
                        _this._dispatchBoardService.trackEvent('scheduler_route_drop_user');
                        _this._toastService.success(_this._utilityService.getLocaleValue('dispatchBoard.route.success.route_assignment_updated', 'Route Assignment Updated'));
                        context.finalize(true);
                        _this.getSchedulerData(true, false);
                      }
                      else {
                        context.finalize(false);
                      }
                    });
                  }
                });
              }
              else {
                context.finalize(false);
                _this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.permission.error', 'You don\'t have permission to perform this action'));
              }
            }
            else {
              const routeDuration = routeDetails?.duration || 1;
              const rescheduleRouteDialogInstance = _this._zuperDialogService.openCustom(RescheduleRouteComponent,
                {
                  data:
                  {
                    routeDetails: routeDetails,
                    userDetails: newUserDetails,
                    startDateTime: newStartTime,
                    endDateTime: newEndTime,
                    duration: routeDuration,
                    customUserDetails: _this.customUserDetails,
                    showRescheduleSuccessToast: false
                  },
                  extraClass: 'route-schdule-dialog'
                });
              rescheduleRouteDialogInstance?.afterClosed()
                .subscribe((status: boolean) => {
                  if (status) {
                    if (oldUserUid !== newUserUid) {
                      const userTeamUid = _this.getUserTeamId(oldUserUid);
                      const unassignUserDetails = {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        users: [{ team_uid: userTeamUid, user_uid: oldUserUid }]
                      };
                      _this._dispatchBoardService.unAssignRoute(routeUid, unassignUserDetails, false, (unassignStatus: boolean) => {
                        if (unassignStatus) {
                          const assignUserDetails = {
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            users: [{ team_uid: _this.selectedTeam, user_uid: newUserUid }]
                          };
                          _this._dispatchBoardService.assignRoute(routeUid, assignUserDetails, false, (_status: boolean) => {
                            _this._toastService.success(_this._utilityService.getLocaleValue('dispatchBoard.route.success.route_details_updated', 'Route Details Updated'));
                            _this._dispatchBoardService.trackEvent('scheduler_route_drop_user');
                            _this.getSchedulerData(true, false);
                          });
                        }
                      });
                    }
                    else {
                      _this.getSchedulerData(true, false);
                    }
                    context.finalize(true);
                  }
                  else {
                    context.finalize(false);
                  }
                });

            }
          }

        },
        beforeEventDrag: ((event: any): any => {
          const detailsType: 'job' | 'route' = event.eventRecord.data.detailsType;
          if (detailsType === 'job') {
            return this.permissions.rescheduleJob || this.permissions.updateJobAssignment;
          }
          else if (detailsType === 'route') {
            return this.permissions.updateRoute || this.permissions.updateRouteAssignment;
          }
        }),
        beforeEventResize: ((event: any): any => {
          const detailsType: 'job' | 'route' = event.eventRecord.data.detailsType;
          if (detailsType === 'job') {
            return this.permissions.rescheduleJob;
          }
          else if (detailsType === 'route') {
            return this.permissions.updateRoute;
          }
        }),
        eventMenuItem: ((event: any): any => {
          _this.schedulerScrollPositionData.eventRecord = event?.eventRecord;
          _this.schedulerScrollPositionData.resourceRecord = event?.resourceRecord;
        })
      }
    };
    this.setSchedulerStartEndDate();
    this.initiateTooltipInstances();
    this.setSchedulerPreset();
  }

  applyQueryParams(): void {
    const scrollOptions: any = {
      block: 'center',
      extendTimeAxis: false,
      animate: true
    };
    try {
      if (this.schedulerFocusData.eventUid || this.schedulerFocusData.userUid) {
        let resourecRecord = this.schedulerInstance.resourceStore.getById(this.schedulerFocusData.userUid);
        const eventRecord = this.schedulerInstance.eventStore.getById(this.schedulerFocusData.eventUid);
        if (eventRecord && !resourecRecord) {
          if (eventRecord?.resourceIds?.length > 1) {
            resourecRecord = eventRecord.resource;
            this.schedulerInstance.scrollResourceEventIntoView(resourecRecord, eventRecord, scrollOptions).then(()=> {
              this.removeSchedulerEventLisners();
            });
            this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'event', eventRecord);
          }
          else {
            this.schedulerInstance.scrollEventIntoView(eventRecord, scrollOptions).then(() => {
              this.removeSchedulerEventLisners();
            });
            this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'event', eventRecord);
          }
        }
        else if (resourecRecord && !eventRecord) {
          this.schedulerInstance.scrollResourceIntoView(resourecRecord, scrollOptions).then(()=>{
            this.removeSchedulerEventLisners();
          });
          this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'resource', resourecRecord);
        }
        else if (resourecRecord && eventRecord) {
          this.schedulerInstance.scrollResourceEventIntoView(resourecRecord, eventRecord, scrollOptions).then(()=>{
            this.removeSchedulerEventLisners();
          });
          const assignmentRecord = this.schedulerInstance.assignmentStore.getById(eventRecord.id + '_' + resourecRecord.id);
          this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'both', assignmentRecord);
        }
      }
      else {
        this.removeSchedulerEventLisners();
      }
    }
    finally {
    }
  }
  initiateTooltipInstances(): void {
    this.timeoffTooltipInstance = new Tooltip({
      hoverDelay: 0,
      hideDelay: 250,
      forSelector: '#routeScheduler .b-sch-resourcetimerange.timeoff',
      cls: 'h-auto w-96 ',
      allowOver: true,
      listeners: {
        show: (event: any): any => {
          if (this.tooltipTimeoffEvent) {
            this.timeoffEditElement = event.source.currentElement.querySelector('#timeoff_edit');
            this.timeoffDeleteElement = event.source.currentElement.querySelector('#timeoff_delete');

            if (this.timeoffEditElement) {
              this.timeoffEditHandler = this.timeoffEditHandler || this.editResourceTimeRangeEvent.bind(this, this.tooltipTimeoffEvent);
              this.timeoffEditElement.addEventListener('click', this.timeoffEditHandler);
            }

            if (this.timeoffDeleteElement) {
              this.timeoffDeleteHandler = this.timeoffDeleteHandler || this.deleteResourceTimeRangeEvent.bind(this, this.tooltipTimeoffEvent);
              this.timeoffDeleteElement.addEventListener('click', this.timeoffDeleteHandler);
            }
          }
        },
        hide: (event: any): any => {
          if (this.timeoffEditElement) {
            this.timeoffEditElement.removeEventListener('click', this.timeoffEditHandler);
          }
          if (this.timeoffDeleteElement) {
            this.timeoffDeleteElement.removeEventListener('click', this.timeoffDeleteHandler);
          }
          this.timeoffEditElement = null;
          this.timeoffDeleteElement = null;
          this.timeoffEditHandler = null;
          this.timeoffDeleteHandler = null;
        }
      },
      getHtml: (event: any): string => {
        const timeoff = event.activeTarget.elementData.eventRecord.data;
        const userDetails = event.activeTarget.elementData.resourceRecord.originalData;
        this.tooltipTimeoffEvent = timeoff;
        this.tooltipTimeoffEvent['userDetails'] = userDetails;
        return this.templateService.getTimeoffTooltipTemplate(userDetails, timeoff);
      }
    });

    this.schedulerSummaryTooltipInstance = new Tooltip({
      hoverDelay: 0,
      hideDelay: 0,
      forSelector: '#routeScheduler .b-timeaxis-summary-value',
      cls: 'h-auto max-w-96 max-h-96',
      bodyCls: 'zuper-scrollbar',
      allowOver: true,
      getHtml: (event: any): string => {
        const eventIdsString: string = event.activeTarget.firstElementChild.attributes.eventIds.nodeValue;
        const eventIds: any[] = _.uniq(eventIdsString.split(','));
        let jobCount = eventIds.length;
        if (!eventIdsString) {
          jobCount = 0;
        }
        const resoureAssignments = this.constructResoureAssignmentObject(eventIds);
        return this.templateService.getSchedulerSummaryTooltip('job', resoureAssignments, jobCount);
      }
    });
  }

  destroyTooltipInstances(): void {
    this.timeoffTooltipInstance?.destroy();
    this.schedulerSummaryTooltipInstance?.destroy();
    this.timeoffTooltipInstance = null;
  }

  getDateRange(): { fromDate: string; toDate: string } {
    return this.schedulerParams ? { fromDate: this.schedulerParams['from_date'], toDate: this.schedulerParams['to_date'] } : null;
  }

  schedulerDateIncrementBtnState(action: 'enable' | 'disable'): void {
    if (action === 'enable') {
      this.schedulerDatePrevBtn = false;
      this.schedulerDateNextBtn = false;
    }
    else if (action === 'disable') {
      this.schedulerDatePrevBtn = true;
      this.schedulerDateNextBtn = true;
    }
  }

  schedulerDateIncrement(type: 'next' | 'prev'): void {
    let fromDate: Moment;     fromDate = this.schedulerTbarForm.get('schedulerDate')?.value;
    if (type === 'next') {
      if (this.selectedRouteTab === 'TRACKING' && fromDate.clone().isAfter(moment(), 'date')) {
        return;
      }
      fromDate = fromDate.add(1, 'day');
    }
    else if (type === 'prev') {
      fromDate = fromDate.subtract(1, 'day');
    }
    this.schedulerTbarForm.get('schedulerDate').setValue(fromDate);
    this.onSchedulerDateChange();

  }

  onSchedulerDateChange(init: boolean = false): void {
    const schedulerDate = this.schedulerTbarForm.get('schedulerDate').value.format('YYYY-MM-DD');
    if (!init) {
      this.getSchedulerData(false, false);
    }
    this.updateSchedulerPreference('date', schedulerDate);
    this.setSchedulerStartEndDate();
  }

  onSchedulerDateRangeChange(init: boolean = false): void {
    let fromDate = this.schedulerTbarForm.get('scheduleStartDate').value;
    let toDate = this.schedulerTbarForm.get('scheduleEndDate').value;
    if (!fromDate) {
      this.schedulerTbarForm.get('scheduleStartDate').setValue(toDate);
      fromDate = toDate.clone();
    }
    else if (!toDate) {
      this.schedulerTbarForm.get('scheduleEndDate').setValue(fromDate);
      toDate = fromDate.clone();
    }

    if (!init) {
      this.getSchedulerData(false, false);
    }

    //Added setTimeout to defer execution, after current stack is cleared
    setTimeout(() => {
      fromDate = fromDate.format('YYYY-MM-DD');
      toDate = toDate.format('YYYY-MM-DD');
      this.updateSchedulerPreference('from_date', fromDate);
      this.updateSchedulerPreference('to_date', toDate);
      this.updateSchedulerSettings();
    });
  }

  updateSchedulerPreference(key: string, value: string): void {
    const schedulerPreference: any = this._localStorageService.getLocalStorage('dispatch_board_scheduler_preferences') || {};
    schedulerPreference['route'][key] = value;
    this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
  }

  initSchedulerPresets(): void {
    this.schedulerPresets = _.cloneDeep(this._dispatchBoardService.getSchedulerPresets());
  }

  setSchedulerPreset(schedulerPresets: any = this.schedulerPresets): any {
    this.suspendAllSchedulerEvents({ preset: true });
    const currentView = this.currentView;
    this.schedulerProConfig.presets = [];
    const currentPresets = schedulerPresets?.[currentView.toLowerCase()];
    if (!this._utilityService.isEmptyOrUndefined(currentPresets)) {
      this.schedulerProConfig.presets = currentPresets;
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        this.schedulerInstance.presets = currentPresets;
      }
    }

    if (currentView === 'DAY') {
      this.schedulerProConfig.viewPreset = 'customHourAndDay';
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        this.schedulerInstance.viewPreset = 'customHourAndDay';
      }

    } else if (currentView === 'WEEK' || currentView === 'MONTH') {
      this.schedulerProConfig.viewPreset = 'dayAndWeek';
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        this.schedulerInstance.viewPreset = 'dayAndWeek';
      }
    }
    this.setSchedulerFillTricks();
    this.resumeAllSchedulerEvents({ preset: true });
  }

  setSchedulerZoom(type: 'zoomIn' | 'zoomOut'): void {
    this.setSchedulerStartEndDate(true);
    if (type === 'zoomIn') {
      this.schedulerInstance?.zoomIn(1, { startDate: this.schedulerInstance?.startDate, endDate: this.schedulerInstance?.endDate });
    }
    else if (type === 'zoomOut') {
      this.schedulerInstance?.zoomOut(1, { startDate: this.schedulerInstance?.startDate, endDate: this.schedulerInstance?.endDate });
    }
    this.setSchedulerFillTricks();
  }

  setSchedulerFillTricks(): any {
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      this.suspendAllSchedulerEvents();
      this.schedulerZoomInBtnState = this.schedulerInstance?.maxZoomLevel === this.schedulerInstance?.zoomLevel;
      this.schedulerZoomOutBtnState = this.schedulerInstance?.minZoomLevel === this.schedulerInstance?.zoomLevel;
      if (this.currentView === 'DAY') {
        this.schedulerInstance.fillTicks = false;
      }
      else if (this.currentView === 'MONTH' || this.currentView === 'WEEK') {
        if (this.schedulerInstance?.zoomLevel === this.schedulerInstance?.minZoomLevel) {
          if (this.selectedRouteTab === 'TRACKING') {
            this.schedulerInstance.fillTicks = true;
          }
        }
        else {
          this.schedulerInstance.fillTicks = false;
        }
      }
      this.resumeAllSchedulerEvents();
    }
  }

  updateSchedulerSettings(initialLoad: boolean = false): void {
    const schedulerSettings: any = this.metaData?.scheduler;
    if (!schedulerSettings) {return;}
    const preference = schedulerSettings?.display;
    this.setSchedulerStartEndDate();
    this.updateSchedulerWeekends(preference.weekends);
    this.updateSchedulerWeekNumber(preference.week_numbers);
    if (!initialLoad) {
      this.toggleSchedulerSummary(preference.job_summary);
    }
  }

  toggleSchedulerSummary(enable: boolean): void {
    if (!this.schedulerInstance?.features?.summary) return;
    const currentlyEnabled = !this.schedulerInstance.features.summary.disabled;
    const newState = enable !== undefined ? enable : !currentlyEnabled;
    try {
      if (newState) {
        this.schedulerInstance.features.summary.disabled = false;
        const hasColumnMismatch = this.checkSummaryColumnMismatch();
        if (hasColumnMismatch) {
          this.schedulerInstance.features.summary.disabled = true;
          setTimeout(() => {
            this.schedulerInstance.features.summary.disabled = false;
          }, 10);
        }
      } else {
        this.schedulerInstance.features.summary.disabled = true;
      }
    } catch (error) {
    }
  }

  checkSummaryColumnMismatch(): boolean {
    const summaryContainer = this.schedulerInstance.features.summary?.summaryBarElement;
    const timeAxis = this.schedulerInstance.timeAxis;
    if (!summaryContainer || !timeAxis) return false;
    const timeAxisLength = timeAxis.count;
    const summaryColumnCount = summaryContainer?.children?.length || 0;
    return summaryColumnCount > timeAxisLength;
  }

  updateSchedulerWeekends(enable: boolean): void {
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      if (!enable && this.selectedRouteTab === 'PLANNING') {
        this.schedulerInstance.timeAxis.filter({
          id: 'weekends',
          filterBy: ((tick: any) => tick.startDate.getDay() !== 6 && tick.startDate.getDay() !== 0)
        });
      }
      else {
        this.schedulerInstance.timeAxis.removeFilter('weekends');
      }
    }
  }

  updateSchedulerWeekNumber(enable: boolean): void {
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      this.suspendAllSchedulerEvents({ preset: true });
      const headers = this.schedulerInstance.timeAxis.headers;
      this.schedulerInstance.timeAxis.headers = headers.filter(header => header.unit !== 'week');
      if (enable) {
        this.schedulerInstance.timeAxis.headers.splice(0, 0, {
          unit: 'week',
          renderer: (date: any) => 'Week ' + moment(date).week()
        });
      }
      this.schedulerInstance.timeAxisViewModel.update();
      this.resumeAllSchedulerEvents({ preset: true });
    }
  }

  async buildBusinessHoursTimeRange(type?: 'add' | 'remove'): Promise<void> {
    let action: any = type;
    if (!type) {
      action = this.metaData?.scheduler.display?.business_hours_only ? 'remove' : 'add';
    }
    let timeRanges = [];
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      this.suspendAllSchedulerEvents({ timeRange: true });
      timeRanges = this.schedulerInstance?.timeRangeStore?.data || [];
      timeRanges = timeRanges.filter((timeRange: any) => !timeRange.id.startsWith('obh_'));
      if (action === 'add') {
        if (this.currentView === 'DAY') {
          let startDate: Dayjs;
          let endDate: Dayjs;
          if (this.selectedRouteTab === 'TRACKING') {
            startDate = endDate = this.schedulerTbarForm.get('schedulerDate').value.clone().format('YYYY-MM-DD');
          }
          else if (this.selectedRouteTab === 'PLANNING') {
            startDate = this.schedulerTbarForm.get('scheduleStartDate').value.clone().format('YYYY-MM-DD');
            endDate = this.schedulerTbarForm.get('scheduleEndDate').value.clone().format('YYYY-MM-DD');
          }
          const startDateTime = new Date(`${startDate} 00:00:00`);
          const endDateTime = new Date(`${endDate} 23:59:59`);
          timeRanges = await this._dispatchBoardService.createBusinessHoursList(startDateTime, endDateTime, this.metaData);
          timeRanges.forEach((timeRange: any) => {
            this.schedulerInstance.timeRangeStore.add(timeRange);
          });
        }
      }
      else if (action === 'remove') {
        this._dispatchBoardService.removeSchedulerOutOfBusinessTimeRange(this.schedulerInstance);
      }
      this.resumeAllSchedulerEvents({ timeRange: true });
    }
  }

  buildHolidaysTimeRange(): void {
    this._dispatchBoardService.buildHolidaysTimeRange('ROUTES', this.schedulerInstance, this.holidays);
  }

  applyEmployeeSearch(event: any, action?: string): void {
    if (event?.keyCode === 13 || action === 'clear') {
      const searchKeyword = this.employeeSearchKeyword.trim();
      this.appliedEmployeeSearchKeyword = searchKeyword;
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        if (searchKeyword) {
          this.schedulerInstance.resourceStore.removeFilter('userSearch');
          this.schedulerInstance.resourceStore.filter({
            id: 'userSearch',
            filterBy: (resource: any) => resource?.name?.toLowerCase().includes(searchKeyword.toLowerCase())
          });
        }
        else {
          this.schedulerInstance.resourceStore.removeFilter('userSearch');
        }
      }
    }
  }

  resetEmployeeSearch(): void {
    if (this.employeeSearchKeyword || this.appliedEmployeeSearchKeyword) {
      this.employeeSearchKeyword = '';
      this.appliedEmployeeSearchKeyword = '';
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        this.schedulerInstance.resourceStore.removeFilter('userSearch');
      }
      if (this.employeeSearchTippy) {
        this.employeeSearchTippy.props.onHide(this.employeeSearchTippy)
      }
    }
  }

  resetEventSearch(): void {
    if (this.schedulerSearchKeyword || this.appliedSchedulerSearchKeyword) {
      this.schedulerSearchKeyword = '';
      this.appliedSchedulerSearchKeyword = '';
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        this.schedulerInstance.eventStore.removeFilter('schedulerEventSearch');
      }
    if (this.schedulerSearchTippyInstance) {
      this.schedulerSearchTippyInstance.props.onHide(this.schedulerSearchTippyInstance)
    }
    }
  }

  //Sorting
  cleanUserSortTippyContent(): void {
    if (this.userSortData.contentRef) {
      this.userSortData.contentRef.destroy();
      this.userSortData.contentRef = null;
    }

    if (this.userSortData?.instanceRef) {
      this.userSortData.instanceRef.destroy();
      this.userSortData.instanceRef = null;
    }

    this.userSortData.isOpened = false;
  }

  showUserSkillSubMenu(target: Element): void {
    if (this.userSortData.skillSubMenu.isOpened) return;
    this.clearUserSkillSubMenu();
    this.userSortData.skillSubMenu.isOpened = true;
    this._changeDetector.detectChanges();

    const tooltipContent = this.userSkillSubMenuTippyWrapper.nativeElement;
    this.userSortData.skillSubMenu.instanceRef = tippy(target, {
      content: tooltipContent,
      trigger: 'manual',
      arrow: false,
      hideOnClick: false,
      allowHTML: true,
      theme: 'light',
      interactive: true,
      appendTo: document.body,
      placement: 'right-start',
      animation: 'fade',
      offset: [0, -5],
      onShow: () => { this.userSortData.skillSubMenu.isOpened = true },
      onHide: () => { this.userSortData.skillSubMenu.isOpened = false },
      onHidden: () => this.clearUserSkillSubMenu(),
    });

    this.userSortData.skillSubMenu.instanceRef.show();
  }

  cancelUserSkillHideSubMenu(): void {
    if (this.userSortData.skillSubMenu.hideTimeout) {
      clearTimeout(this.userSortData.skillSubMenu.hideTimeout);
      this.userSortData.skillSubMenu.hideTimeout = null;
    }
  }

  hideUserSkillSubMenu(): void {
    this.cancelUserSkillHideSubMenu();
    this.userSortData.skillSubMenu.hideTimeout = setTimeout(() => {
      this.userSortData.skillSubMenu.instanceRef?.hide();
    }, 200);
  }

  onSkillParentLeave(): void {
    this.hideUserSkillSubMenu();
  }

  selectUserSortSkill(skill: any): void {
    this.userSortData.skillSubMenu.filteredSkillset.forEach((skill: any) => skill.selected = false);
    skill.selected = true;
    this.userSortData.selectedSkill = skill?.skillset_uid;
    this.userSortData.selectedSkillName = skill?.skillset_name;
    this.setUserSort('sort_by', 'skill');
    this.userSortData.skillSubMenu.instanceRef?.hide();
  }

  resetUserSortSkill(): void {
    this.userSortData.skillSubMenu.filteredSkillset.forEach((skill: any) => skill.selected = false);
    this.userSortData.selectedSkill = null;
    this.userSortData.selectedSkillName = '';
    this.setUserSort('sort_by', 'name');
    this.setUserSort('sort', 'ASC');
    this.userSortData.skillSubMenu.searchKeyword = '';
    this.onUserSortSkillSearch();
  }

  setUserSort(key: string, value: string): void {
    this.sortOptions.user[key] = value;
    this._changeDetector.detectChanges();
  }

  applyUserSort(): void {
    this.sortSchedulerResources(this.sortOptions.user.sort_by, (this.sortOptions.user.sort) as 'ASC' | 'DESC' || 'ASC');
    this.closeUserSort();
  }

  closeUserSort(): void {
    this.userSortData.isOpened = false;
    if (this.userSortData.instanceRef) {
      this.userSortData.instanceRef.destroy();
      this.userSortData.instanceRef = null;
    }
  }

  onUserSortSkillSearch(): void {
    this.userSortSearchInput$.next(this.userSortData.skillSubMenu.searchKeyword || '');
  }

  clearUserSkillSubMenu(): void {
    this.userSortData.skillSubMenu.instanceRef?.destroy();
    this.userSortData.skillSubMenu.instanceRef = null;

    this.userSortData.skillSubMenu.contentViewRef?.destroy();
    this.userSortData.skillSubMenu.contentViewRef = null;

    this.cancelUserSkillHideSubMenu();
    this.userSortData.skillSubMenu.isOpened = false;
    this.userSortData.skillSubMenu.searchKeyword = '';
    this.userSortData.skillSubMenu.filteredSkillset = [...this.userSortData.skillSubMenu.skillList]
    this.userSortData.skillSubMenu.filteredSkillset.forEach((skill: any) => skill.selected = this.userSortData.selectedSkill === skill?.skillset_uid);
    this.onUserSortSkillSearch();
  }

  sortSchedulerResources(sortBy: string = this.sortOptions.user.sort_by, sort: 'ASC' | 'DESC' = (this.sortOptions.user.sort) as 'ASC' | 'DESC'): void {
    this.sortOptions.user.sort_by = sortBy;
    this.sortOptions.user.sort = sort;
    if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
      this.suspendAllSchedulerEvents({ resource: true });
      if (sortBy === 'name') {
        this.schedulerInstance.resourceStore.sort({
          field: sortBy,
          ascending: sort === 'ASC',
          silent: true
        });
      }
      else if (sortBy === 'skill') {
        const sorterFn = (resourceA: any, resourceB: any) => {
          const skillsA = resourceA?.data?.skills || [];
          const skillsB = resourceB?.data?.skills || [];
          const skillA = skillsA.find((skill: any) => skill.id === this.userSortData.selectedSkill);
          const skillB = skillsB.find((skill: any) => skill.id === this.userSortData.selectedSkill);

          if (skillA && skillB) {
            const percentageA = skillA.percentage;
            const percentageB = skillB.percentage;
            return sort === 'ASC' ? percentageA - percentageB : percentageB - percentageA;
          }
          if (skillA) return -1;
          if (skillB) return 1;

          const nameA = resourceA?.data?.name || '';
          const nameB = resourceB?.data?.name || '';
          return sort === 'ASC' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
        };
        this.schedulerInstance.resourceStore.sort({
          fn: sorterFn,
          silent: true
        });
      }
      this.resumeAllSchedulerEvents({ resource: true });
    }
  }

  addJobInRouteDetails(routeDetails: any, jobDetails: any): any {
    const newJob = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      job_uid: jobDetails?.job_uid, distance: 0, geo_cords: [0, 0], job: jobDetails
    };
    // eslint-disable-next-line @typescript-eslint/naming-convention
    routeDetails.jobs = routeDetails.jobs.filter((routeJob: any) => routeJob.job_uid !== jobDetails?.job_uid);
    routeDetails.jobs.push(newJob);
    return routeDetails;
  }

  updateSchedulerRouteMasterRecords(detailsType: 'job' | 'route', routeUid: any, updatedRouteDetails: any, updateScheduler: boolean = false, schedulerEventRefresh: boolean = false): void {
    const schedulerRecords: any[] = this._dispatchBoardService.getSchedulerRoutesRecords();
    if (detailsType === 'job') {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const recordIndex = _.findIndex(schedulerRecords, { 'route_uid': routeUid });
      if (recordIndex === -1) {
        return;
      }
      schedulerRecords[recordIndex]['departure'] = updatedRouteDetails?.departure;
      schedulerRecords[recordIndex]['route_end_time'] = updatedRouteDetails?.route_end_time;
      schedulerRecords[recordIndex]['jobs'] = updatedRouteDetails?.jobs;
      schedulerRecords[recordIndex].assigned_to = updatedRouteDetails?.assigned_to;
      this._dispatchBoardService.setSchedulerRoutesRecords(schedulerRecords);
    }
    else if (detailsType === 'route') {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const recordIndex = _.findIndex(schedulerRecords, { 'route_uid': routeUid });
      if (recordIndex === -1) {
        schedulerRecords.push(updatedRouteDetails);
      }
      else {
        schedulerRecords.splice(recordIndex, 1);
        schedulerRecords.splice(recordIndex, 0, updatedRouteDetails);
      }
      this._dispatchBoardService.setSchedulerRecords(schedulerRecords);
    }
    // this.upadteCustomEmployeeDetails();
  }

  updateLocalRecordsAfterChanges(type: 'JOBS' | 'ROUTES', eventDetails: any, action: 'update' | 'delete', updateScheduler: boolean = false, schedulerEventRefresh: boolean = true): void {
    this.suspendAllGridEvents();
    this.suspendAllSchedulerEvents({ event: true });
    try {
      let gridData = _.cloneDeep(this.gridData[type]);
      if (action === 'update') {
        const id = type === 'JOBS' ? eventDetails?.job_uid : eventDetails?.route_uid;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const gridDataIndex = type === 'JOBS' ? _.findIndex(gridData, { 'job_uid': id }) : _.findIndex(gridData, { 'route_uid': id });
        gridData.splice(gridDataIndex, 1);
        gridData.splice(gridDataIndex, 0, eventDetails);
        this._dispatchBoardService.setGridRecords(gridData);
        this.injectGridDataIntoView(gridData);
        this.schedulerRoutes = this.schedulerRoutes.filter((route: any) => route.route_uid !== id);
        this.schedulerRoutes.push(eventDetails);
      }
      else if (action === 'delete') {
        if (type === 'ROUTES') {
          const routeUid = eventDetails?.route_uid;
          gridData = gridData.filter((route: any) => route.route_uid !== routeUid);
          this._dispatchBoardService.setRouteTabRoutesRecord(gridData);
          this.schedulerRoutes = this.schedulerRoutes.filter((route: any) => route.route_uid !== routeUid);
          let allEvents = this.schedulerProConfig.events;
          allEvents = allEvents.filter((event: any) => event.route_uid !== routeUid);
          this.schedulerProConfig.events = allEvents;
          this.schedulerInstance.eventStore.loadDataAsync(allEvents);
        }
      }
    }
    finally {
      this.resumeAllSchedulerEvents({ event: true });
      this.resumeAllGridEvents();
    }
  }

  constructResoureAssignmentObject(eventIds: any[]): any {
    const resourceAssignemennt: any = {};
    eventIds.forEach((eventId: any) => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const jobDetails = _.find(this.schedulerRoutes, { 'route_uid': eventId });
      const assignedTo = jobDetails?.assigned_to;
      assignedTo?.forEach((assignee: any) => {
        const userUid = assignee?.user.user_uid;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const userDetails = _.find(this.schedulerEmployees, { 'user_uid': userUid });
        if (userDetails) {
          if (resourceAssignemennt.hasOwnProperty(userDetails.name)) {
            resourceAssignemennt[userDetails.name] += 1;
          }
          else {
            resourceAssignemennt[userDetails.name] = 1;
          }
        }
      });
    });
    return resourceAssignemennt;
  }

  openEmployeeDetailsDrawer(userUid: any): void {
    this.schedulerInstance.features.cellTooltip.tip.hide();
    this.previewDrawer.drawerOpen = true;
    this.previewDrawer.moduleUID = userUid;
    this.previewDrawer.module = 'USER';
    this._dispatchBoardService.trackEvent('user_details_preview');
  }

  getPreviewDataOptions(): void {
    this.previewDataOptions = {
      position: 'right',
      type: 'summary',
      mode: 'over',
      hasBackDrop: false,
      allowToEdit: this.permissions.updateJob,
      disableClose: true,
      menuOptions: {
        viewDetails: true,
        clone: this.permissions.cloneJob,
        delete: this.permissions.deleteJob
      }
    };
  }

  closePreviewDrawer(): void {
    this.previewDrawer.drawerOpen = false;
    this.previewDrawer.moduleUID = '';
    this.previewDrawer.module = '';
    this.previewDrawer.source = '';
  }

  previewDrawerEventHandler(event: any): any {
    if (this.previewDrawer.module === 'USER') {
      if (event.drawerClosed) {
        this.closePreviewDrawer();
      }
    }
    if (this.previewDrawer.module === 'JOB') {
      if (event.drawerClosed) {
        if (event?.action === 'UPDATE' || event?.action === 'CLONE' || event?.action === 'DELETE') {
          const jobPresence = this.getJobPresence(this.previewDrawer.moduleUID);
          if (jobPresence.includes('grid')) {
            this.updateGridData(false, true, true);
          }
          if (jobPresence.includes('scheduler')) {
            this.getSchedulerData(true, false);
          }
        }
        this.closePreviewDrawer();
      }
    }
  }

  openJobPreviewDrawer(jobUid: any, source: 'grid' | 'scheduler'): void {
    if (jobUid) {
      this.previewDrawer.drawerOpen = true;
      this.previewDrawer.module = 'JOB';
      this.previewDrawer.moduleUID = jobUid;
      this.previewDrawer.source = source;
      this.previewDataOptions.timeZone = this.selectedTimezone;
    }
  }

  setGridEmptyText(): void {
    if (this.gridViewInstance) {
      this.gridViewInstance.emptyText = this.selectedGridTab === 'JOBS' ? this._utilityService.getLocaleValue('text.no_jobs_found', 'No Jobs Found') : this._utilityService.getLocaleValue('text.no_routes_found', 'No Routes Found');
    }
  }

  applySchedulerSearch(event: any, action?: string): void {
    if (event?.keyCode === 13 || action === 'clear') {
      const searchKeyword = this.schedulerSearchKeyword.trim();
      this.appliedSchedulerSearchKeyword = searchKeyword;
      if (this.schedulerInstance && !this.schedulerInstance?.isDestroyed) {
        if (searchKeyword) {
          this.schedulerInstance.eventStore.removeFilter('schedulerEventSearch');
          this.schedulerInstance.eventStore.filter({
            id: 'schedulerEventSearch',
            filterBy: (eventDetails: any) => eventDetails?.name?.toLowerCase().includes(searchKeyword.toLowerCase())
          });
        }
        else {
          this.schedulerInstance.eventStore.removeFilter('schedulerEventSearch');
        }
      }
    }
  }

  saveTimezoneSchedulerPreference(timezone: string): void {
    const schedulerPreference: any = this._localStorageService.getLocalStorage('dispatch_board_scheduler_preferences');
    schedulerPreference['timezone'].ROUTES = timezone;
    if (this._dispatchBoardService?.companyConfig?.multipleTimezone) {
      schedulerPreference['timezone'].JOBS = timezone;
    }
    this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
  }

  refreshSchedulerTimezone(): void {
    this.buildBusinessHoursTimeRange('remove');
    this._dispatchBoardService.selectedTimezone.ROUTES = this.selectedTimezone;
    this.schedulerProConfig.timeZone = this.selectedTimezone;
    this.previewDataOptions.timeZone = this.selectedTimezone;
    this.updateSchedulerPreference('team_uid', this.selectedTeam);
    this.saveTimezoneSchedulerPreference(this.selectedTimezone);
    if (this.selectedPlanningTab === 'MAP') {
      this._dispatchBoardService.injectDrawOnMapData(null, this.selectedPlanningTab, this.metaData, null, true);
    }
    this._dispatchBoardService.setResourceTimeoff(this.schedulerInstance, this.schedulerEmployees);
    this._dispatchBoardService.setResourceShift(this.schedulerInstance, this.schedulerEmployees, this.currentView);
    //Workaround - set schduler start/end date after a delay to avoid timezone related issue in nested events.
    setTimeout(() => {
      this.setSchedulerStartEndDate();
      this.schedulerInstance.timeZone = this.selectedTimezone;
      this.injectGridDataIntoView();
      this.schedulerInstance?.timeAxis?.refreshData();
    }, 100);
  } 

  editResourceTimeRangeEvent(timeoffDetails: any): void {
    this.timeoffTooltipInstance.close();
    this._dispatchBoardService.editTimeOffEvent(this.schedulerInstance, timeoffDetails, this.schedulerEmployees, this.allTeams, this.selectedTeam, this.selectedTimezone, (status: boolean, userUid: string, timeoff: any ) => {
      if(status) {
        this.updateTimeOffInLocalRecords('add', userUid, timeoff);
      }
    });
  }

  deleteResourceTimeRangeEvent(timeoffDetails: any): void {
    this.timeoffTooltipInstance.close();
    this._dispatchBoardService.deleteTimeOffEvent(this.schedulerInstance, timeoffDetails, (status: boolean) => {
      if (status) {
        this.updateTimeOffInLocalRecords('delete', timeoffDetails['userDetails']?.user_uid, timeoffDetails);
      }
    });
  }

  updateTimeOffInLocalRecords(action: 'add' | 'delete', userUid: any, timeOffDetails: any): void {
    this.schedulerEmployees = this.schedulerEmployees.map((user: any) => {
      if (user.user_uid === userUid && user?.timeoff_request?.length) {
        user.timeoff_request = user.timeoff_request.filter((requestDetail: any) => requestDetail.request_uid !== timeOffDetails.request_uid);
        if(action === 'add') {
          user.timeoff_request.push(timeOffDetails);
        }
      }
      return user;
    });
    this.upadteCustomEmployeeDetails();
  }

  upadteCustomEmployeeDetails(): void {
    const startDate = moment(this.schedulerParams?.from_date, 'YYYY-MM-DD').startOf('day');
    const endDate = moment(this.schedulerParams?.to_date, 'YYYY-MM-DD').endOf('day');
    this.customUserDetails = this._dispatchBoardService.getCustomEmployeeDetailsLocal(startDate, endDate, this.schedulerEmployees, this.schedulerJobs);
  }

  scrollSchedulerToToady(): void {
    if( this.isSchedulerInCurrentDate) {
      this._dispatchBoardService.setSchedulerScrollPosition(this.schedulerInstance, 'DAY');
    }
    else if (this.selectedRouteTab === 'TRACKING') {
      this.schedulerTbarForm.get('schedulerDate').setValue(moment());
      this.onSchedulerDateChange();
    }
  }


  //Service territory
  getServiceTerritory(onInit: boolean = false): Observable<any> {
    if (!this.enableServiceTerritory) {
      return of([]);
    }

    this.territorySearchPagination.isLoading = true;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const params = {
      'page': this.territorySearchPagination.currentPage,
      'filter.keyword': this.territorySearchPagination.keyword || '',
      'filter.territory_uid': this.territorySearchPagination.filterUid || '',
      'filter.is_active': true
    };

    const originalFilterUid = this.territorySearchPagination.filterUid;

    return this._dataCollectorService.getData(this._dispatchBoardService.territoryDataUrl, params).pipe(
      switchMap(response => {
        if (onInit && (!response?.data || response.data?.length === 0) && originalFilterUid) {
          const fallbackParams = { ...params };
          fallbackParams['filter.territory_uid'] = '';
          this.territorySearchPagination.filterUid = '';
          this.selectedServiceTerritory = 'ALL';
          this.teamSearchPagination.serviceTerritoryFilterUid = '';
          this.saveServiceTerritorySchedulerPreference("ALL", this._utilityService.getLocaleValue('text.all_service_territory', 'All Service Territory'), [], null, 0);
          return this._dataCollectorService.getData(this._dispatchBoardService.territoryDataUrl, fallbackParams);
        }
        return of(response);
      }),

      map(response => {
        if (onInit) {
          this.allTerritories = [this.allServiceTerritorySelectOption, ...(response?.data || [])];
          if (this.allTerritories?.length <= 1) {
            this.territorySearchPagination.filterUid = '';
            this.teamSearchPagination.serviceTerritoryFilterUid = '';
            this.selectedServiceTerritory = 'ALL';
          }
        } else {
          this.allTerritories.push(this.allServiceTerritorySelectOption, ...(response.data || []));
          this.allTerritories = _.uniqBy(this.allTerritories, 'territory_uid');
        }

        this.territorySearchPagination.totalPage = response.total_pages || 1;
        this.territorySearchPagination.currentPage = Number(response.current_page) || 1;
        this.serviceTerritoryPickerList = _.unionBy(
          [this.allServiceTerritorySelectOption],
          this.serviceTerritoryPickerList,
          response.data || [],
          'territory_uid'
        );
        this.territorySearchPagination.isLoading = false;

        return [this.allServiceTerritorySelectOption, ...(response?.data || [])];
      }),

      catchError(error => {
        this.territorySearchPagination.isLoading = false;
        return of([]);
      }),

      shareReplay(1)
    );
  }

  onServiceTerritoryPickerOpen(): void {
    if (this.territorySearchPagination.filterUid && this.selectedServiceTerritory) {
      this.territorySearchPagination.currentPage = 1;
      this.territorySearchPagination.filterUid = '';
      this.territorySearchPagination.keyword = '';
      this.getServiceTerritory().subscribe((territories: any) => {
        this.serviceTerritories = of(_.unionBy(territories, this.serviceTerritoryPickerList, 'territory_uid'));;
      });
    }
  }

  onServiceTerritorySearch(): void {
    if (this.territorySearchPagination.currentPage !== this.territorySearchPagination.totalPage || this.territorySearchPagination.filterUid) {
      this.serviceTerritories = this.serviceTerritoryValueSubject.pipe(
        distinctUntilChanged(),
        debounceTime(500),
        switchMap((term: any) => {
          if (!_.isNil(term)) {
            this.territorySearchPagination.keyword = term;
            this.territorySearchPagination.currentPage = 1;
            this.territorySearchPagination.filterUid = '';
            if (term?.trim().length === 0) {
              this.territorySearchPagination.keyword = '';
            }
            return this.getServiceTerritory();
          }
          else {
            return of(this.serviceTerritoryPickerList);
          }
        })
      );
    }
  }

  serviceTerritoryPickerScrollToEnd(): any {
    if (this.territorySearchPagination.currentPage < this.territorySearchPagination.totalPage) {
      this.territorySearchPagination.currentPage += 1;
      this.getServiceTerritory().subscribe(() => {
        this.serviceTerritories = of(_.uniqBy(this.serviceTerritoryPickerList, 'territory_uid'));
      });
    }
  }

  onServiceTerritoryChange(event?: any): void {
    this.selectedServiceTerritoryDetails.name = event?.territory_name || '';
    this.selectedServiceTerritoryDetails.type = event?.territory_type || null;
    this.teamSearchPagination.serviceTerritoryFilterUid = this.selectedServiceTerritory !== 'ALL' ? this.selectedServiceTerritory : '';
    let radius: number = 0;
    if (event?.territory_type === 'RADIUS' && event?.territory_radius?.geo_cordinates?.length === 2) {
      this.selectedServiceTerritoryDetails.geoCords = event?.territory_radius?.geo_cordinates;
      radius = event?.territory_radius?.radius || 0;
      const bounds = this._mapService.getCircleBounds(this.selectedServiceTerritoryDetails.geoCords[0], this.selectedServiceTerritoryDetails.geoCords[1], radius);
      this._mapService.mapFitBoundByGeoCords.next(bounds);
    }
    else if (event?.territory_type === 'GEOFENCE') {
      this.selectedServiceTerritoryDetails.geoCords = event?.territory_coordinates;
      this._mapService.mapFitBoundByGeoCords.next(event?.territory_coordinates);
    }
    else {
      this.selectedServiceTerritoryDetails.geoCords = [];
    }
    this.saveServiceTerritorySchedulerPreference(this.selectedServiceTerritory, this.selectedServiceTerritoryDetails.name, this.selectedServiceTerritoryDetails.geoCords, this.selectedServiceTerritoryDetails.type, radius);
    this.teamSearchPagination.filterUid = '';
    this.teamSearchPagination.currentPage = 1;
    this._dispatchBoardService.selectedTeam.ROUTES = this.selectedTeam = null;
    this.schedulerTbarForm.get('selectedTeam').setValue(null);
    this.teams = of([]);
    this.getTeams(true).subscribe(() => {
      this.teams = of(_.uniqBy(this.teamPickerList, 'team_uid'));
      if (this.selectedGridTab === 'JOBS') {
        this.getGridData().then(() => {
          this.injectGridDataIntoView();
        });
      }
      this.getSchedulerData(true, true);
    });
  }

  saveServiceTerritorySchedulerPreference(serviceTerritoryUid: string, serviceTerritoryName: string, geoCords: number[] = [], type: string, radius: number = 0): void {
    const schedulerPreference: any = this._localStorageService.getLocalStorage('dispatch_board_scheduler_preferences') || this.defaultSchedulerPreference;
    if (!schedulerPreference['service_territory']) {
      schedulerPreference['service_territory'] = {};
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    schedulerPreference['service_territory']['ROUTES'] = { serviceTerritoryUid: serviceTerritoryUid, serviceTerritoryName: serviceTerritoryName, geoCords: geoCords, type: type, radius: radius };
    this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
  }

  createNewRoute(): void {
    this.routeFormOption = {
      state: 'new',
      header: 'route.create'
    };
    this.openRouteFormDrawer = true;
    this._dispatchBoardService.trackEvent('create_route');
  }

  toggleRouteForm(action: 'edit' | 'clone', currentRoute: any, getRouteDataFromRemote: boolean = false): void {
    this.routeFormOption = {
      state: action,
      header: action === 'edit' ? 'route.edit' : 'text.clone_route'
    };
    const isJobDetailsUnavailable: boolean = currentRoute?.jobs?.length && currentRoute?.jobs.some((jobDetails: any) => !jobDetails?.job);
    if (getRouteDataFromRemote && isJobDetailsUnavailable && currentRoute?.route_uid) {
      this._dispatchBoardService.getRouteDetails(currentRoute?.route_uid).subscribe((routeDetails: any) => {
        this.routeFormCurrentRoute = routeDetails?.data;
        this.openRouteFormDrawer = true;
      });
    }
    else {
      this.routeFormCurrentRoute = currentRoute;
      this.openRouteFormDrawer = true;
    }
  }

  onRouteFormDrawerClose(event: any): void {
    if (event.state === 'edit') {
      if (event?.completed) {
        const newRouteDetails = event?.data;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const oldRouteDetails = _.find(this.schedulerRoutes, { 'route_uid': event.uid });
        newRouteDetails['route_uid'] = event.uid;
        if (oldRouteDetails) {
          this.updateLocalRecordsOnEditRoute(oldRouteDetails, newRouteDetails);
        }
        this.openRouteFormDrawer = false;
        this.routeFormCurrentRoute = null;
      }
      else {
        this.openRouteFormDrawer = false;
      }
    }
    else if (event.state === 'clone') {
      if (event.completed) {
        this.getSchedulerData(true, false);
        this.openRouteFormDrawer = false;
      }
      else {
        this.openRouteFormDrawer = false;
        if(!event.isRecurringRoute){
          this.routeFormCurrentRoute = null;
        }
      }
    }
    else if (event.state === 'new') {
      if (event.completed) {
        if (event?.data?.recurring_route_uid) {
          this.gridTbarData.ROUTES.type = 'RECURRING_ROUTES';
          this.changeGridRouteType();
        }
        else {
          this.onToggleGridTab('ROUTES');
          this.updateGridData(false, true, true);
        }
        this.openRouteFormDrawer = false;
        this.routeFormCurrentRoute = null;
        if (event?.data?.recurring_route_uid) {
          if (event?.action === 'VIEW_RECURRENCE_ROUTE_DETAILS') {
            this.closeRecurringRoutePreview();
            this.openRecurringRoutePreview(event?.data?.recurring_route_uid, null, 'REFRESH_RR', 100);
          }
          else if (event?.action === 'ADD_JOB_TO_RECURRENCE_ROUTE') {
            this.closeRecurringRoutePreview();
            this.openRecurringRoutePreview(event?.data?.recurring_route_uid, null, 'ADD_JOB', 500);
          }
        }
      }
      else {
        this.openRouteFormDrawer = false;
        this.routeFormCurrentRoute = null;
      }
      this.drawOnMapDrawCreatedEvent({ type: 'delete' });
      this.updateMapLayersData();
    }
  }

  updateLocalRecordsOnEditRoute(oldRouteDetails: any, newRouteDetails: any): void {
    const routeUid: string = oldRouteDetails?.route_uid;
    if (this.canLocalUpdateOnEditRoute(oldRouteDetails, newRouteDetails)) {
      const allEvents = this.schedulerInstance.events;
      const eventIndex = _.findIndex(allEvents, { id: routeUid });
      const localEventIndex = _.findIndex(this.schedulerProConfig.events, { id: routeUid });
      if (eventIndex !== -1) {
        this.schedulerInstance.eventStore.getAt(eventIndex)['route_name'] = newRouteDetails.route_name;
        this.schedulerInstance.eventStore.getAt(eventIndex)['color'] = newRouteDetails.color;
        this.schedulerProConfig.events[localEventIndex]['route_name'] = newRouteDetails.route_name;
        this.schedulerProConfig.events[localEventIndex]['color'] = newRouteDetails.color;
      }
    }
    else {
      this.getSchedulerData(true, false);
    }
  }

  canLocalUpdateOnEditRoute(oldRouteDetails: any, newRouteDetails: any): boolean {
    const newDeparture = moment.utc(newRouteDetails.departure, 'YYYY-MM-DD HH:mm:ss');
    const oldDeparture = moment.utc(oldRouteDetails.departure);
    const oldRouteJobs = oldRouteDetails.jobs.map((job: any) => job.job_uid);
    const newRouteJobs = newRouteDetails.jobs.map((job: any) => job.job_uid);
    let canUpdateRoute: boolean = true;
    if (!newDeparture.isSame(oldDeparture) || oldRouteDetails.duration !== newRouteDetails.duration ||
      !_.isEqual((oldRouteDetails.end_location?.geo_cords || []).sort(), (newRouteDetails.end_location?.geo_cords || []).sort()) ||
      !_.isEqual(oldRouteDetails.start_location.geo_cords.sort(), newRouteDetails.start_location.geo_cords.sort()) ||
      oldRouteDetails.transport_mode !== newRouteDetails.transport_mode ||
      oldRouteDetails.route_type !== newRouteDetails.route_type || oldRouteDetails.jobs.length !== newRouteDetails.jobs.length ||
      !_.isEqual(oldRouteJobs, newRouteJobs)) {
      canUpdateRoute = false;
    }
    return canUpdateRoute;
  }

  routeDetailsEvent(event: any): void {
    if ((event?.status === 'change' || event?.status === 'clone' || event?.status === 'delete') && !event?.onInit && event.data) {
      if (this.routePreviewDrawerData.source === 'scheduler') {
        this.getSchedulerData(true, false);
      }
      else if (this.routePreviewDrawerData.source === 'grid') {
        this.getRouteData(true).then(() => {
          this.injectGridDataIntoView();
        });
      }
      else if(this.routePreviewDrawerData.source === 'map') {
        if (event?.data?.route_uid) {
          const gridRouteIndex = this.routeCardData.findIndex((route: any) => route.route_uid === event?.data?.route_uid);
          const schedulerRouteIndex = this.schedulerRoutes.findIndex((route: any) => route.route_uid === event?.data?.route_uid);
          if (gridRouteIndex !== -1) {
            this.getRouteData(true).then(() => {
              this.injectGridDataIntoView();
            });
          }
          if (schedulerRouteIndex !== -1) {
            this.getSchedulerData(true, false);
          }
        }
      }
    }

    if (event?.status === 'close' || event?.status === 'delete') {
      this.routePreviewDrawerData.routeDetailsUid = null;
      this.routePreviewDrawerData.isOptimized = false;
      this.routePreviewDrawerData.assignedTo = [];
      this._dispatchBoardService.previewRouteDetails.set({ show: false, routeDetailsUid: '', source: this.routePreviewDrawerData.source });
    }
  }

  isAssignedToChanged(assignToOne: any, assignToTwo: any): boolean {
    const _assignToOne = assignToOne.map((assignee: any) => assignee?.user?.user_uid);
    const _assignToTwo = assignToTwo.map((assignee: any) => assignee?.user?.user_uid);
    return _.isEqual(_assignToOne, _assignToTwo);
  }

  openRoutePreviewDrawer(routeUid: string, source: 'grid' | 'scheduler' | 'map', routeDetails?: any): void {
    if (source === 'grid') {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      routeDetails = _.find(this.gridData.ROUTES, { 'route_uid': routeUid });
    }
    this.routePreviewDrawerData.isOptimized = routeDetails?.is_optimized;
    this.routePreviewDrawerData.assignedTo = routeDetails?.assigned_to;
    this.routePreviewDrawerData.isLocked = routeDetails?.is_locked;

    this.routePreviewDrawerData.source = source;
    this.routePreviewDrawerData.routeDetailsUid = routeUid;
    this._dispatchBoardService.previewRouteDetails.set({ show: true, routeDetailsUid: routeUid, source: source });
  }

  openRecurringRoutePreview(routeUid: string, rrDetails?: any, performAction: string = null, delay: number = 0): void {
    this.recurringRouteDetails.routeUid = routeUid;
    this.recurringRouteDetails.rrDetails = rrDetails;
    this.recurringRouteDetails.isOpened = true;
    this.recurringRouteDetails.performAction = performAction;
    setTimeout(() => {
      this._mapService.mapResizeIndicator.next(true);
      this.recurringRouteService.recurringRouteDetailsPerformAction.next({ performAction: performAction, routeUid: routeUid });
    }, delay);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this.location.replaceState(this._dispatchBoardService.createQueryParam(this.selectedRouteTab, {'recurrence-route-uid': routeUid }));
    this.setRecurringRouteMasterDetailsSplitSettings();
  }

  setRecurringRouteMasterDetailsSplitSettings(): void {
    this.dispatchRouteSplitSettings.grid.size = this.isMapViewEnabled && this.selectedRouteTab === 'TRACKING' ? 56 : 46;
    this.dispatchRouteSplitSettings.grid.minSize = 36;
    this.dispatchRouteSplitSettings.grid.maxSize = 60;
  }

  closeRecurringRoutePreview(): void {
    this.recurringRouteDetails.routeUid = null;
    this.recurringRouteDetails.rrDetails = null;
    this.recurringRouteDetails.isOpened = false;
    this.updateDispatchRouteSplitSettings();
    this.location.replaceState(this._dispatchBoardService.createQueryParam(this.selectedRouteTab));
    this._dispatchBoardService.recurringRouteDetailsSubject.next({ action: 'RECURRING_ROUTE_INSTANCES_LIST', data: [] });
    //Refresh the grid view after some delay
    setTimeout(()=>{
      this.gridViewInstance?.renderContents();
      this.gridViewInstance?.refreshRows();
      this._mapService.mapResizeIndicator.next(true);

    }, 100);
  }

  toggleRecurringRouteViewRouteSeries(toggleState: boolean): void {
    this._dispatchBoardService.toggleRecurringRouteViewRouteSeriesSubject.next(toggleState);
    if (!toggleState) {
      this.updateDispatchRouteSplitSettings();
    }
  }

  recurringRouteDetailsEventEmitter(event: any): void {
    if (event?.isClosed && !event?.isUpdated) {
      this.closeRecurringRoutePreview();
    }
    else if (event?.isClosed && event?.isUpdated) {
      this.closeRecurringRoutePreview();
      this.updateGridData(false, false, true);
    }
    else {
      if (event?.action === 'MOVE') {
        const sourceRouteUid = event?.data?.route_uid;
        const moveRouteJobDialogInstance = this._zuperDialogService.openCustom(MoveRouteJobComponent, {
          title: 'Schedule',
          dismissible: false,
          data: { sourceRoute: sourceRouteUid, timezone: this.selectedTimezone, holidays: this.holidays },
          extraClass: 'move-route-job-dialog'
        });
        moveRouteJobDialogInstance.afterClosed().subscribe((moveEvent: any) => {
          if(moveEvent?.isClosed) {
            if (moveEvent?.isRouteChanged) {
              this.recurringRouteService.recurringRouteDetailsPerformAction.next({ performAction: 'REFRESH_RR_INSTANCE', routeUid: sourceRouteUid});
            }
          }
        });
      }
      if (event?.isRouteInstanceSegmentOpen) {
        this.setRecurringRouteMasterDetailsSplitSettings();
      }
      else {
        this.dispatchRouteSplitSettings.grid.size = 23;
        this.dispatchRouteSplitSettings.grid.minSize = 18;
        this.dispatchRouteSplitSettings.grid.maxSize = 30;
      }
    }
    if(event?.isUpdated) {
      this.updateGridData(false, false, true);
    }
  }

  openRouteAssignDrawer(jobDetails: any, routeUid: string, date: any): void {
    this.routeAssignDrawerData.routeUid = routeUid;
    this.routeAssignDrawerData.date = date;
    this.routeAssignDrawerData.jobTitle = jobDetails?.job_title;
    this.routeAssignDrawerData.jobUid = jobDetails?.job_uid;
    this.routeAssignDrawerData.show = true;
    this.routeAssignDrawerInstance = this.zuperDrawerService.getComponent(this.routeAssignDrawerData.drawerName);
    this.routeAssignDrawerInstance.open();
  }

  routeAssignDrawerCloseEvent(isOpened: any): void {
    if (!isOpened) {
      this.routeAssignDrawerInstance?.close();
      this.routeAssignDrawerData.show = false;
      this.routeAssignDrawerData.date = '';
      this.routeAssignDrawerData.jobTitle = '';
      this.routeAssignDrawerData.routeUid = '';
      this.routeAssignDrawerData.jobUid = '';

    }
  }

  jobAssignToAnotherRoute(): void {
    const routeSelected = this._jobsService.getSelectedRoute();
    const newRouteUid: string = routeSelected?.route_uid;
    const oldRouteUid: string = this.routeAssignDrawerData.routeUid;
    const jobUid: string = this.routeAssignDrawerData.jobUid;
    if (Object.keys(routeSelected).length > 1 && newRouteUid && jobUid) {
      const loader = this._toastService.loading(this._utilityService.getLocaleValue('loader.reassign.jobs'));
      this._dataCollectorService.postData(this._mapService.getRouteAssignUrl(oldRouteUid), {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        assign_route_users: true, job_uid: jobUid, route_uid: newRouteUid
      }).subscribe((response: any) => {
        loader.close();
        this.getSchedulerData(true, false);
        if (response?.message) {
          this._toastService.success(response?.message);
          this.routeAssignDrawerCloseEvent(false);
        }
      },
        () => {
          loader.close();
          this.routeAssignDrawerCloseEvent(false);
        });
    }
    else {
      this.routeAssignDrawerCloseEvent(false);
    }
  }

  routeDatePickerDateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if (!this.selectedTeam) {
      return '';
    }
    if ((moment(cellDate).date() === 1) && (view === 'month')) {
      this._dispatchBoardService.getRoutesCount(cellDate, this.selectedTeam);
    }
    return '';
  };

  drawOnMapRouteCreatedEvent(event: any): void {
    if (event.state === 'new' && event.completed) {
      this.mapViewData = {};
      this.onToggleGridTab('ROUTES');
      this.updateGridData(false, true, true);
      setTimeout(() => { this.mapViewData = event?.data; });
    }
  }

  assignRouteDrawerRouteUnlockEvent(event: any): void {
    if (event.status === 'routeUnlocked') {
      this.getSchedulerData(true, false);
    }
  }

  changeGridRouteType(): void {
    this.updateMetaData(this.metaData);
    this.setGridSchedulerInstance();
    this.gridBbarData.ROUTES.gridPageNumber = 1;
    if (this.metaData?.grid.view_type !== this.gridViewType) {
      this.gridViewType = this.metaData?.grid.view_type;
      this.gridViewInstance = this.gridViewType === 'listView' ? this.cardViewInstance : this.tableViewInstance;
      this.dragInstance?.destroy();
      this.initiateDragHelper(this.gridViewType);
    }
    this.updateGridData(false, true, true);
  }

  updateGridRouteTypeParam(routeParam: any): void {
    if (!routeParam?.filter_rules) {
      routeParam['filter_rules'] = [];
    }
    if (this.gridTbarData.ROUTES.type === 'UNASSIGNED') {
      routeParam['filter_rules'] = this._dispatchBoardService.removeFilterKey('assigned_to', routeParam['filter_rules'] || []);
      routeParam['filter_rules'].push({
        'type': 'default_field',
        'key': 'assigned_to',
        'value': [],
        'operator': 'IS_EMPTY'
      });
    }
    else {
      routeParam['filter_rules'] = this._dispatchBoardService.removeFilterKey('assigned_to',routeParam['filter_rules'] || []);
    }
    return routeParam;
  }

  //Map
  onMapEventChange(event: any): void {
    if (event.event === 'MAP-LOADED') {
      this.updateMapLayersData(false, null, null, null, true);
      this._mapService.toggleMapDrawTool(this.metaData?.map?.layers?.routes);
    }
    else if (event.event === 'FILTER') {
      this.openDispatchFilter('MAP');
    }
    else if (event.event === 'SETTINGS') {
      this.openSettingsDialog('MAP');
    }
    else if (event.event === 'PIN') {
      const oldMetaData = this.metaData;
      this.updateMetaData();
      this.updateMapLayersData(false, oldMetaData, this.metaData);
    }
    else if (event?.event === 'LEGEND') {
      this.toggleMapLegendBar(event?.isOpen, event?.legendDetails);
    }
  }


  toggleMapLegendBar(isOpen: boolean, legendDetails: any, updateLegendStateOnMap: boolean = false): void {
    if (!this.mapLegendContainerRef) {
      return;
    }
    const mapLegendBarElement: HTMLElement = (this.mapLegendContainerRef.nativeElement as HTMLElement).querySelector('#map-legend-bar-route');
    if (mapLegendBarElement) {
      if (isOpen) {
        mapLegendBarElement.classList.add('open');
      }
      else {
        mapLegendBarElement.classList.remove('open');
      }
    }

    if (updateLegendStateOnMap) {
      const legendContainer: HTMLElement = (this.mapLegendContainerRef.nativeElement as HTMLElement).querySelector('.custom-control-container.legend-container') as HTMLElement;
      this._mapService.setMapLegendActiveState(legendContainer, false);
    }

    if (_.isPlainObject(legendDetails) && isOpen) {
      let allLegends = Object.values(legendDetails).flatMap(value => Object.values(value));
      allLegends = allLegends.map((legend: any) => ({ ...legend, textColor: this._utilityService.getTextColorBasedOnBg(legend?.color) }));
      this.mapLegendData.legendDetails = allLegends;
    }
    if (isOpen) {
      setTimeout(() => {
        this.calculateMapLegendVisibleItems();
      }, 100);
      this.mapLegendContainerRef.nativeElement.style.zIndex = 99;
    }
    else {
      //Need to set z-index to 0 after animation complete
      setTimeout(() => {this.mapLegendContainerRef.nativeElement.style.zIndex = 0}, 300);
    }
  }
  
  async onJobSelected(jobDetails: any): Promise<void> {
    if (jobDetails) {
      const jobUid = jobDetails?.job_uid;
      const scrollOptions: any = {
        animate: {
          easing: 'easeFromTo',
          duration: 500
        },
        extendTimeAxis: false
      };
      const jobFromScheduler = this.schedulerInstance?.eventStore.getById(jobUid);
      const jobFromGrid = this.gridViewInstance?.store.getById(jobUid);
      const assignedTo = jobDetails?.assigned_to || [];
      this._dispatchBoardService.trackEvent('map_click_on_job');
      let resouceRecord: any;
      if (jobFromScheduler) {
        const eventRecord: any = this.schedulerInstance?.eventStore.getById(jobUid).parent;
        _.forEach(assignedTo, (assignee: any) => {
          const userUid = assignee.user.user_uid;
          resouceRecord = this.schedulerInstance?.resourceStore.getById(userUid);
          if (resouceRecord) {
            return false;
          }
        });
        if (eventRecord && resouceRecord) {
          const schedulerStart = this.schedulerInstance.timeAxis.startDate;
          const schedulerEnd = this.schedulerInstance.timeAxis.endDate;
          const isEventInScheduler = eventRecord.startDate < schedulerEnd && eventRecord.endDate > schedulerStart;
          if (isEventInScheduler) {
            await this.schedulerInstance?.scrollResourceEventIntoView(resouceRecord, eventRecord, scrollOptions);
            this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'event', eventRecord);
          }
        }
      }
 
      if (jobFromGrid) {
        this.gridViewInstance?.scrollRowIntoView(jobFromGrid, { scrollOptions, highlight: true });
      }
    }
  }

  getEmployeeLocationData(count: number): void {
    if (this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
      if (!this.metaData.map.layers.users || !this.metaData?.map.enable_map_view) {
        this._mapService.employeeLocationData.next([]);
        return;
      }
      if (count > 0) {
        const params = {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          team_uid: this.selectedTeam,
          page: 1,
          limit: count
        };
        this._dataCollectorService.getData(this._dispatchBoardService.employeeLocationDataUrl, params)
          .subscribe((response: any) => {
            this._dispatchBoardService.employeeLocationData['ROUTES'] = response?.data?.user_data;
            this._dispatchBoardService.injectEmployeeLocationMapData('ROUTES', this.metaData);
          });
      }
      else {
        this._mapService.employeeLocationData.next([]);
      }
    }
  }

  onMapViewDrag(event: any): void {
    this._mapService.mapResizeIndicator.next(true);
  }

  drawOnMapEventChange(event: any): void {
    if (event.event === 'PIN') {
      this.updateMetaData();
      this._dispatchBoardService.injectDrawOnMapData(null, this.selectedPlanningTab, this.metaData, null, true);
    }
  }

  drawOnMapDrawCreatedEvent(event: any): void {
    const selectedJob = _.map(event?.selectedJob|| [], 'job');
    this.drawOnMapNavbarData.selectedJobs = selectedJob;
    if (event?.type === 'create') {
      this._dispatchBoardService.trackEvent('draw_on_map');
      this.createRouteOnDraw();
    }
    else if (event?.type === 'delete') {
      this.drawOnMapNavbarData.selectedJobs = [];
    }
    else if (event?.type === 'update') {
      const routeUid: string = event?.routeUid;
      const routeFromScheduler = this.schedulerInstance?.eventStore.getById(routeUid);
      const routeFromCurrentGrid = this.gridData.ROUTES.find((route: any) => route?.route_uid === routeUid);
      if (routeFromCurrentGrid) {
        this.getRouteData(true).then(() => {
          this.injectGridDataIntoView();
          this.updateMapRouteFilter();
        });
      }
      if (routeFromScheduler) {
        this.getSchedulerData(true, false);
      }
      if(event?.addedJobs?.length) {
        const addedJobs: any[] = event?.addedJobs;
        let updatedJobInGrid: boolean = false;
        _.forEach(addedJobs, (job: any) => {
          const jobFromGrid = this.gridData.JOBS.find((jobDetails: any) => jobDetails?.job_uid === job?.job_uid);
          if (jobFromGrid) {
            updatedJobInGrid = true;
            return false;
          }
        });
        if (updatedJobInGrid) {
          this.getGridData(true).then(() => {
            this.injectGridDataIntoView();
            this.updateMapRouteFilter();
          });
        }
        else {
          const updatedRouteInGrid: any = this.gridData.ROUTES.find((route: any) => route?.route_uid === routeUid);
          if (updatedRouteInGrid) {
            this.getRouteData(true).then(() => {
              this.injectGridDataIntoView();
              this.updateMapRouteFilter();
            });
          }
        }
      }
      this._dispatchBoardService.refreshNearByMapDataWithoutPan(this.metaData, 'ROUTES');
    }
  }

  createRouteOnDraw(): void {
    this._dispatchBoardService.trackEvent('draw_on_map_create_route');
    this.routeFormOption = {
      state: 'new',
      header: 'route.create'
    };
    this.routeFormCurrentRoute = { jobs: this.drawOnMapNavbarData.selectedJobs };
    this.openRouteFormDrawer = true;
  }

  getAllRoutesDataLocal(): any {
    const gridRoutes = this.gridTbarData.ROUTES.type !== 'RECURRING_ROUTES' ? this.gridData.ROUTES: [];
    return _.uniqBy([...this.schedulerRoutes,  ...gridRoutes, ...this.recurringRouteInstances], 'route_uid');
  }

  updateMapRouteFilter(): void {
    if (this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
      const mapRouteData = { data: this.getAllRoutesDataLocal() };
      const dispatchFilters = this.getDispatchFilterValues();
      const routeFilterUids: any[] = dispatchFilters.filterOptions.map['filter.route_uid'] || [];
      if(this.isMapViewEnabled && this.metaData?.map?.layers.routes && mapRouteData?.data?.length) {
        if (routeFilterUids?.length) {
          const selectedRoutes = { data: [] };
          selectedRoutes.data = mapRouteData?.data.filter((route: any) => routeFilterUids.includes(route?.route_uid));
          this._mapService.routeLocationData.next(selectedRoutes);
          this.setFilterCount('map', selectedRoutes.data.length);
        }
        else{
          this._mapService.routeLocationData.next(mapRouteData);
          this.setFilterCount('map', 0);
        }
      }
      else {
        this._mapService.routeLocationData.next({data: []});
        this.setFilterCount('map', 0);
      }
    }
  }

  calculateMapLegendVisibleItems(): void {
    if (!this.mapLegendWrapperRef) { return; }
    const container = this.mapLegendWrapperRef?.nativeElement;
    const containerRect = container.getBoundingClientRect();
    const containerWidth = containerRect.width;
    const previousExtraCount: number = this.mapLegendData.extraCount;
    let totalWidth = 0;
    let visibleCount = 0;
    let lastElement: any = null;
    this.mapLegendItems.forEach((item) => {
      const element = item.nativeElement;
      const itemRect = element.getBoundingClientRect();
      const itemWidth = itemRect.width;
      if (totalWidth + itemWidth <= containerWidth && itemRect.right <= containerRect.right) {
        totalWidth += itemWidth;
        element.style.display = 'inline-block';
        lastElement = element;
        visibleCount++;
      } else {
        element.style.display = 'none';
      }
    });
    this.mapLegendData.extraCount = this.mapLegendData.legendDetails?.length - visibleCount || 0;
    if (this.mapLegendData.extraCount && (!!previousExtraCount !== !!this.mapLegendData.extraCount)) {
      if (lastElement) {
        lastElement.style.display = 'none';
        this.mapLegendData.extraCount += 1;
      }
    }
    else {
      this.mapLegendData.extraCount = this.mapLegendData.legendDetails?.length - visibleCount || 0;
    }
  }


  setFilterCount(key: string, value: number): void {
    if(!key) { return; };
    const dispatchBoardFilter = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.filterCount;
    dispatchBoardFilter.route.filterCount[key] = value;
    this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchBoardFilter);
    this.filterCount[key] = value;
    this.updateFilterCount();
  }

  //Filters
  manageQuickFilters(): void {
    const teamName: string = this.getTeamName(this.selectedTeam)
    const manageFilter: any = this._zuperDialogService.openCustom(ManageDispatchFilterComponent,
      {
        extraClass: 'manage-dispatch-filters-container',
        data: {
          isMapViewEnabled: this.isMapViewEnabled,
          dateRange: this.getDateRange(),
          currentTab: this.selectedDispatchTab,
          filterTabs: this.getDispatchFilterTabs(),
          additionalFilters: {
            key: 'assigned_to.user_uid',
            filter: {
              'filter.team_uid': this.selectedTeam
            },
            appendToDisplayKey: teamName ? `${this._utilityService.getLocaleValue('text.users_team')} : ${teamName}`: ''
          },
        }
      });
    manageFilter.afterClosed().subscribe((response: any) => {
      this.selectedQuickFilter = this.fallbackSelectedQuickFilter;
      if (response?.createNewFilter) {
        const dispatchFilterValues: any = {
          filterOptions: {},
          sortOptions: {
            grid: { ...this.gridTbarData[this.selectedGridTab].sortOptions }
          },
          filterUid: 'ALL'
        };
        this.updateTeamInUserFilter();
        this.dispatchFilterDrawerData.dispatchFilterValues = dispatchFilterValues;
        this.dispatchFilterDrawerData.addNewFilter = true;
        this.dispatchFilterDrawerData.openFilter = true;
      }

      if (response?.isFilterUpdated) {
        this.getQuickFilters(false).pipe(take(1)).subscribe();
      }
    });
  }

  getDispatchFilterTabs(): any {
    return {
      grid: {
        show: true
      },
      employee: {
        show: true
      },
      scheduler: {
        show: true
      },
      map: {
        show: this.isMapViewEnabled
      }
    };
  }

  addNewDispatchFilter(): void {
    this.updateTeamInUserFilter();
    this.dispatchFilterDrawerData.addNewFilter = true;
    this.dispatchFilterDrawerData.openFilter = true;
    this.dispatchFilterDrawerData.saveFilterByDefault = true;
    this.dispatchFilterDrawerData.dispatchFilterValues = this.getDispatchFilterValues(true);
  }

  updateDispatchBoardFilterValuesLocal(key: any, values: any): void {
    const dispatchBoardFilters = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.defaultDispatchBoardFilters;
    dispatchBoardFilters[key] = values;
    this.currentFilters = values;
    this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchBoardFilters);
  }

  filterDrawerEmitter(event: any): void {
    if (event?.isClosed) {
      this.dispatchFilterDrawerData.openFilter = false;
      if (event?.type !== 'save' || !event?.filterUid) {
        this.selectedQuickFilter = this.fallbackSelectedQuickFilter;
      }
    }
    if (event?.filterUid) {
      const newFilterUid = event?.filterUid;
      this.updateSelectedQuickFilterValue(newFilterUid);
      this.getQuickFilters(false, newFilterUid).pipe(take(1)).subscribe();
    }

    if (event?.type === 'reset') {
      this.selectedQuickFilter = 'ALL';
      this.updateSelectedQuickFilterValue(this.selectedQuickFilter);
      this.updateDispatchBoardFilterValuesLocal('route', this.defaultDispatchBoardFilters.route);
      this.applyQuickFilter('dispatchFilter', this.defaultDispatchBoardFilters.route.filterOptions, this.defaultDispatchBoardFilters.route.sortOptions, this.defaultDispatchBoardFilters.route);
      this.filterCount = this._dispatchFilterService.getFilterCount(this.defaultDispatchBoardFilters.route.filterOptions, this.selectedDispatchTab);
    }
    else if (event?.filter) {
      let filter = event?.filter;
      filter = this.filterCleanUp(filter);
      this.updateDispatchBoardFilterValuesLocal('route', filter);
      this.applyQuickFilter('dispatchFilter', filter?.filterOptions, filter?.sortOptions, event?.filter);
    }
    this.updateFilterCount();
  }

  filterCleanUp(filter: any): any{
    filter.filterOptions['grid'] = this._dispatchBoardService.addSearchKeywordFilterRule(this.gridTbarData.JOBS.gridSearchKeyword, filter.filterOptions['grid']);
    return filter;
  }

  applyQuickFilter(source: 'quickFilter' | 'dispatchFilter', filterOptions: any, sortOptions: any, filterObj: any, init: boolean = false): void {
    if (filterOptions) {
      filterOptions = this._dispatchBoardService.sanitizeFilterOptions(filterOptions);
      //Grid
      const oldGridFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.gridParam?.filter_rules);
      const newGridFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', filterOptions?.grid);
      const isGridFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(oldGridFilter, newGridFilter);

      //GridRoute
      let oldRouteFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.routeParam?.filter_rules);
      oldRouteFilter = this._dispatchBoardService.removeFilterKey('assigned_to', this.routeParam?.filter_rules);
      const newRouteFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', filterOptions?.grid_route);
      const isRouteGridFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(oldRouteFilter, newRouteFilter);

      //Scheduler
      const oldSchedulerFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.schedulerParams?.filter_rules) || [];
      const newSchedulerFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', filterOptions?.scheduler) || [];
      const isSchedulerFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(oldSchedulerFilter, newSchedulerFilter);

      //SchdulerRoute
      const oldSchedulerRouteFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.schedulerParams?.route_filter_rules);
      const newSchedulerRouteFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', filterOptions?.scheduler_route);
      const isSchedulerRouteFilterChanged = !this._dispatchBoardService.isSameFilterRule(oldSchedulerRouteFilter, newSchedulerRouteFilter);

      //Employee
      const oldEmployeeFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.schedulerParams?.employee_filter_rules) || [];
      const newEmployeeFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', filterOptions?.employee) || [];
      const isEmployeeFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(oldEmployeeFilter, newEmployeeFilter);

      //Maps
      const isMapFilterChanged = !_.isEqual(this.dispatchFilterDrawerData.dispatchFilterValues?.['map'], filterOptions?.map);

      if (filterObj) {
        this.currentFilters = filterObj;
      }

      if (isGridFilterRuleChanged || init) {
        this.gridTbarData.JOBS.sortOptions.sort = sortOptions?.grid.sort;
        this.gridTbarData.JOBS.sortOptions.sort_by = sortOptions?.grid.sort_by;
        this.gridParam = _.merge(this.gridParam, sortOptions?.grid);
        this.gridParam['filter_rules'] = newGridFilter;
        this.gridFilterOptions = filterOptions?.grid;
        this.gridBbarData[this.selectedGridTab].gridPageNumber = 1;
        this.updateGridData(false, init, false, 'JOBS');
      }

      if (isRouteGridFilterRuleChanged || init) {
        this.gridTbarData.ROUTES.gridSearchKeyword = this._dispatchBoardService.getFilterValue('keyword', newRouteFilter) || '';
        this.gridTbarData.ROUTES.sortOptions.sort_by = sortOptions?.grid_route?.sort_by;
        this.gridTbarData.ROUTES.sortOptions.sort = sortOptions?.grid_route?.sort;
        this.gridBbarData.ROUTES.gridPageNumber = 1;
        this.routeParam['filter_rules'] = newRouteFilter;
        this.updateGridData(false, init, false, 'ROUTES');
      }

      if ((isSchedulerFilterRuleChanged || isSchedulerRouteFilterChanged || isEmployeeFilterRuleChanged) && !init) {
        this.schedulerParams = _.merge(this.schedulerParams, sortOptions?.scheduler);
        this.schedulerParams['filter_rules'] = newSchedulerFilter;
        this.schedulerParams['employee_filter_rules'] = newEmployeeFilter;
        this.schedulerParams['route_filter_rules'] = newSchedulerRouteFilter;
        this.getSchedulerData(!init, (isEmployeeFilterRuleChanged || init));
      }
      if (isMapFilterChanged) {
        this.updateMapRouteFilter();
      }
    }
  }

  updateFilterCount(refreshFilterCount: boolean = true): void {
    if (!this.mapContainerRef) { return; }
    const mapFilterBadge =  (this.mapContainerRef.nativeElement as HTMLElement).querySelector('#mapFilterBadge');
    const employeeFilterBadge = (this.schedulerProComponent['elementRef']?.['nativeElement'] as HTMLElement).querySelector(`#employeeFilterBadge-ROUTES`);
    if (refreshFilterCount) {
      this.refreshFilterCount();
    }

    if (mapFilterBadge) {
      if (this.filterCount.map > 0) {
        mapFilterBadge.classList.remove('opacity-0');
        mapFilterBadge.innerHTML = this.filterCount.map.toString();
      }
      else {
        mapFilterBadge.classList.add('opacity-0');
      }
    }

    if (employeeFilterBadge) {
      if (this.filterCount.employee > 0) {
        employeeFilterBadge.classList.remove('opacity-0');
        employeeFilterBadge.innerHTML = this.filterCount.employee.toString();
      }
      else {
        employeeFilterBadge.classList.add('opacity-0');
      }
    }
  }

  refreshFilterCount(): void {
    const advanceFilterValue = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.defaultDispatchBoardFilters;
    this.filterCount = this._dispatchFilterService.getFilterCount(advanceFilterValue?.route.filterOptions, this.selectedDispatchTab);
    advanceFilterValue.route.filterCount = this.filterCount;
    this._localStorageService.setLocalStorage('dispatch_board_advance_filter', advanceFilterValue);
  }

  updateSelectedQuickFilterValue(filterUid: any, filterCount?: any): void {
    const dispatchFilterValues = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.defaultDispatchBoardFilters;
    dispatchFilterValues.route['filterUid'] = filterUid;
    dispatchFilterValues.route['filterCount'] = filterCount || this.filterCount;
    this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchFilterValues);
  }

  getDispatchFilterValues(emptyValues: boolean = false): any {
    const dispatchFilterValues = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.defaultDispatchBoardFilters;
    if (emptyValues) {
      dispatchFilterValues.route['filterOptions']['grid'] = [];
      dispatchFilterValues.route['filterOptions']['grid_route'] = [];
      dispatchFilterValues.route['filterOptions']['employee'] = [];
      dispatchFilterValues.route['filterOptions']['scheduler'] = [];
      dispatchFilterValues.route['filterOptions']['scheduler_route'] = [];
      // eslint-disable-next-line @typescript-eslint/naming-convention
      dispatchFilterValues.route['filterOptions']['map'] = { 'filter.route_uid': [] };
    }
    dispatchFilterValues.route['sortOptions']['grid'] = { ... this.gridTbarData.JOBS.sortOptions };
    dispatchFilterValues.route['sortOptions']['grid_route'] = { ... this.gridTbarData.ROUTES.sortOptions };
    return dispatchFilterValues.route;
  }

  openDispatchFilter(moduleName: any): void {
    if (!this.dispatchFilterDrawerData.openFilter) {
      this._dispatchBoardService.trackEvent('filter_' + moduleName.toLowerCase());
    }
    this.updateTeamInUserFilter();
    this.dispatchFilterDrawerData.hideSaveFilter = false;
    this.dispatchFilterDrawerData.addNewFilter = false;
    this.dispatchFilterDrawerData.saveFilterByDefault = false;
    this.dispatchFilterDrawerData.dispatchFilterValues = this.getDispatchFilterValues();
    this.dispatchFilterDrawerData.selectedModule = moduleName;
    this.dispatchFilterDrawerData.filterOptionalValues = { map: this.getAllRoutesDataLocal() };
    this.dispatchFilterDrawerData.openFilter = true;
  }

  closeDispatchFilter(): void {
    this.dispatchFilterDrawerData.openFilter = false;
  }

  getQuickFilterUid(): string {
    const dispatchBoardFilters = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.defaultDispatchBoardFilters;
    return dispatchBoardFilters?.['route']?.['filterUid'] || 'ALL';
  }

  //Color profile
  openColorProfileDrawer(): void {
    this.colorProfiletCreateDrawerData.openDrawer = true;
    this.toggleMapLegendBar(false, null, true);
  }

  closeColorProfileDrawer(): void {
    this.colorProfiletCreateDrawerData.openDrawer = false;
  }

  colorProfileEventEmitter(event: any): void {
    if (event?.isClosed) {
      this.closeColorProfileDrawer();
    }
    if (event?.isUpdated) {
      this.getSchedulerData(true, false);
      this.getGridData().then(() => {
        this.injectGridDataIntoView();
      });
      this.updateMapLayersData();
    }
  }
  

  //Settings
  openSettingsDialog(moduleName: string): void {
    this.toggleMapLegendBar(false, null, true);
    this.settingsDialogdata['module'] = moduleName;
    this.settingsDialogdata['tab'] = this.selectedDispatchTab;
    this.settingsDialogdata['moduleAccess'] = this.moduleAccess;
    this.settingsDialogdata['display'] = { grid: true, employee: true, scheduler: true, map: true };
    this._dispatchBoardService.trackEvent('settings_' + moduleName);
    this._sharedService.settingsDialogInstance = this._zuperDialogService.openCustom(SettingsComponent, {
      data: this.settingsDialogdata,
      extraClass: ['w-fit', 'route-settings-dialog']
    });
    this._sharedService.settingsDialogInstance.afterClosed()
      .subscribe((dialogData: any) => {
        if (dialogData?.openColorProfile) {
          this.openColorProfileDrawer();
        }
        else {
          this.updateSettings(dialogData);
        }
      });
  }

  updateMapLayersData(skipGetRoutes: boolean = false, oldMetaData?: any, newMetaData?: any, changedLayers?: any, forceUpdate?: boolean): void {
    setTimeout(() => {
      if (this.isMapViewEnabled) {
        let isValueChanged: boolean = false;
        if (_.isEmpty(changedLayers)) {
          [isValueChanged, changedLayers] = this._dispatchBoardService.isMapLayerChanged(oldMetaData, newMetaData);
        }
        else {
          isValueChanged = true;
        }
        if ((newMetaData?.map?.layers && oldMetaData?.map?.layers) || changedLayers || forceUpdate) {
          if (changedLayers?.jobs || forceUpdate) {
            this._dispatchBoardService.injectJobLocationMapData('ROUTES', null, this.metaData, null, false, true);
          }  
          if ((!skipGetRoutes && changedLayers?.routes) || forceUpdate) {
            this.updateMapRouteFilter();
          }
          if (changedLayers?.users) {
            this.getEmployeeLocationData(this.schedulerEmployees?.length);
          }
          if (changedLayers?.service_territories || forceUpdate) {
            this._dispatchBoardService.injectServiceTerritoryMapData(this.metaData);
          }
          if ((isValueChanged && (changedLayers?.assets || changedLayers?.customers || changedLayers?.jobs || changedLayers?.organizations || changedLayers?.properties || changedLayers?.nearby_jobs)) || forceUpdate) {
            this._dispatchBoardService.getNearByData(this.metaData).pipe(takeUntil(this.tearDown$)).subscribe((nearByData: any) => {
              this._dispatchBoardService.injectNearByMapData(this.metaData, nearByData, 'ROUTES');
            });
          }
        }
        else {
          this._dispatchBoardService.getNearByData(this.metaData).pipe(takeUntil(this.tearDown$)).subscribe((nearByData: any) => {
            this._dispatchBoardService.injectNearByMapData(this.metaData, nearByData, 'ROUTES');
          });
        }
      }
    }, 300);
  }

  isColorProfileDataPresentInJobList(): boolean {
    return this.schedulerJobs.every((jobDetails: any) => (jobDetails || {}).hasOwnProperty('color_profile'));
  }

  refreshJobDataOnMap(): void {
    this._dispatchBoardService.injectJobLocationMapData(this.selectedDispatchTab, null, this.metaData, null, false, true);
  }

  updateSettings(metaData: any): void {
    this.suspendAllSchedulerEvents({resource: true, event: true });
    this.suspendAllGridEvents();
    const oldMetaData = _.cloneDeep(this.metaData);
    if (metaData && !metaData?.map.enable_map_view) {
      this._dispatchBoardService.enableMapViewByDefault = false;
    }
    this._mapService.toggleMapDrawTool(this.metaData?.map?.layers?.routes);
    if (metaData) {
      this.metaData = this.templateService.updateTemplateMetaDataFromLocal();
      if (this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
        if (!metaData?.map.layers.routes) {
          this._dispatchBoardService.enableMapLayerByDefault.routes = false;
        }
        if (!metaData?.map.layers.jobs) {
          this._dispatchBoardService.enableMapLayerByDefault.routesJob = false;
        }
        if (!metaData?.map.layers?.service_territories) {
          this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory = false;
        }
      }
      this.updateMetaData(this.metaData);
      this._mapService.mapCurrentLocation.next({ additionalData: { metaData: this.metaData } });
      this.calculateSchedulerHeight();
      if (this.metaData?.scheduler?.primary_color === 'custom') {
        this.useColorProfile = true;
        if (oldMetaData?.scheduler?.primary_color !== this.metaData?.scheduler?.primary_color) {
          const existingDataHasColorProfileDetails: boolean = this.isColorProfileDataPresentInJobList();
          if (!existingDataHasColorProfileDetails) {
            this.getSchedulerData(true, false);
          }
          else {
            this.refreshJobDataOnMap();
          }
        }
      }
      else {
        this.useColorProfile = false;
      }
      this.updateSchedulerSettings();
      this.isMapViewEnabled = this.metaData?.map.enable_map_view;
      if (!this.isMapViewEnabled) {
        if (this.selectedRouteTab === 'PLANNING' && this.selectedSchedulerPlanningNavTab === 'MAP') {
          this.onSchedulerPlanningNavTabChange('DISPATCH_BOARD');
        }
      }
      this.schedulerPlanningNavTabs = this.schedulerPlanningNavTabs.map((tab: any) => {
        if (tab?.dataKey === 'MAP') {
          tab['isEnabled'] = this.isMapViewEnabled && this.moduleAccess.map;
        }
        return tab;
      });
      const [isMapLayerChanged, changedLayers] = this._dispatchBoardService.isMapLayerChanged(oldMetaData, metaData);
      if (isMapLayerChanged) {
        this.updateMapLayersData(false, oldMetaData, this.metaData, changedLayers);
      }
      if (this.gridParam.count && this.gridParam.count !== metaData?.grid?.job_count) {
        this.updateGridData(true);
      }
      if (this.metaData?.grid.view_type !== oldMetaData?.grid.view_type) {
        this.gridViewType = this.metaData?.grid.view_type;
        this.gridBbarData[this.selectedGridTab].gridPageNumber = 1;
        this.updateGridData(false, true, true);

        setTimeout(() => {
          this.setGridSchedulerInstance();
          this.dragInstance?.destroy();
          this.initiateDragHelper(this.gridViewType);
        }, 100);
      }
      else {
        this.setGridSchedulerInstance();
        if (this.gridViewType === 'tableView') {
          this.updateTableContent(this.gridData[this.selectedGridTab]);
        }
        else if (this.gridViewType === 'listView') {
          this.cardViewInstance?.renderContents();
        }
      }
      if (this.gridViewType === 'tableView') {
        this.updateTableColumns();
      }
      
      //Update gutter split settings to default if grid position is changed
      this.updateDispatchRouteSplitSettings();
      if (this.metaData?.grid?.table_grid_position !== oldMetaData?.grid?.table_grid_position || (this.metaData?.grid?.table_grid_position === 'BOTTOM' && this.metaData?.grid.view_type === 'listView')) {
        this.resetSplitVisibility(1);
      }
    }
    this.resumeAllGridEvents();
    this.resumeAllSchedulerEvents({resource: true, event: true });
  }

  setGridSchedulerInstance(): void {
    if (this.gridViewType === 'listView' && (!this.cardViewInstance || this.cardViewInstance?.isDestroyed)) {
      this.cardViewInstance = this.cardViewComponent?.instance;
    }
    else if (this.gridViewType === 'tableView' && (!this.tableViewInstance || this.tableViewInstance?.isDestroyed)) {
      this.tableViewInstance = this.tableViewComponent?.instance;
    }
    this.gridViewInstance = this.gridViewType === 'listView' ? this.cardViewInstance : this.tableViewInstance;
    if (!this.schedulerInstance ||  this.schedulerInstance?.isDestroyed) {
      this.schedulerInstance = this.schedulerProComponent?.instance;
    }
  }

  calculateSchedulerHeight(): void {
    const calculateRowHeight = (view: any): number => Math.max(60, (Object.keys(view || {}).length || 1) * 30);

    const schedulerCardViewCount = Object.keys(this.metaData?.scheduler?.card_view || {}).length || 1;
    const baseRowHeight = calculateRowHeight(this.metaData?.employee?.card_view);

    this.schedulerResourceRowHeight = baseRowHeight;
    this.schedulerJobEventRowHeight = calculateRowHeight(this.metaData?.scheduler?.card_view);
    this.schedulerRouteEventRowHeight = schedulerCardViewCount * 47 + (45 / schedulerCardViewCount);
    this.schedulerResourceRowHeight = Math.max(baseRowHeight, this.schedulerJobEventRowHeight, this.schedulerRouteEventRowHeight);
  }

  async getRoutesAndJobs(): Promise<void> {
    this.masterRouteJobs = {};
    this.allRoutes = [];
    this.allJobs = [];
    this.allRouteJobs = [];
    await this.getAllRoutes();
    await this.getAllJobs();
    this._mapService.routeJobLocationData.next(this.allRouteJobs);
  }

  getAllRoutes(): Promise<any> {
    const filter = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      limit: 20, page: 1, from_date: moment().format('YYYY-MM-DD'), to_date: moment().format('YYYY-MM-DD')
    };
    return new Promise((resolve) => {
      this._dataCollectorService.getData(this._mapService.mapsAPi.getRoutes, filter)
        .subscribe((res) => {
          this.allRoutes = res.data;
          this._mapService.allRoutesLocationData.next(this.allRoutes);
          if (this.allRoutes?.length) {
            this.allRoutes.forEach((route: any, i: number) => {
              route.jobs.forEach((job: any) => {
                this.masterRouteJobs[job?.job_uid] = job?.job;
                job['job']['route'] = route;
              });
              if (i === (this.allRoutes?.length - 1)) {
                resolve(true);
              }
            });
          } else {
            resolve(true);
          }
        });
    });
  }

  async getAllJobs(): Promise<any> {
    return new Promise((resolve) => {
      this._dataCollectorService.getData(this._mapService.mapsAPi.getJobs, {})
        .subscribe((res) => {
          this.allJobs = res?.data;
          if (this.allJobs?.length > 0) {
            this.allJobs.forEach((job: any, i: number) => {
              if (!this.masterRouteJobs[job?.job_uid]) {
                this.masterRouteJobs[job?.job_uid] = job;
                const data = {
                  job: job,
                };
                if (job?.customer_address?.geo_cordinates?.length) {
                  data['job']['geo_cords'] = job?.customer_address?.geo_cordinates;
                }
                this.allRouteJobs.push(data);
              }
              if (i === (this.allJobs?.length - 1)) {
                resolve(true);
              }
            });
          } else {
            resolve(true);
          }
        });
    });
  }

  getEmptyText(): void {
    if (this.selectedGridTab === 'JOBS') {
      return this._utilityService.getLocaleValue('text.no_jobs_found', 'No Jobs Found');
    }
    else if (this.selectedGridTab === 'ROUTES') {
      if (this.gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
        return this._utilityService.getLocaleValue('recurring_route.no_recurring_route', 'No recurring routes found');
      }
      else {
        return this._utilityService.getLocaleValue('text.no_routes_found', 'No Routes Found');
      }
    }
  }
}
